/*! For license information please see pivot.grid.min.js.LICENSE.txt */
!(function (t, e) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = e())
    : 'function' == typeof define && define.amd
      ? define([], e)
      : 'object' == typeof exports
        ? (exports.pivot = e())
        : (t.pivot = e());
})(self, () =>
  (() => {
    var t = {
        167: function (t, e, n) {
          var r;
          (t = n.nmd(t)),
            function () {
              var s,
                i = 'Expected a function',
                o = '__lodash_hash_undefined__',
                a = '__lodash_placeholder__',
                l = 32,
                u = 128,
                c = 1 / 0,
                f = 9007199254740991,
                h = NaN,
                d = 4294967295,
                _ = [
                  ['ary', u],
                  ['bind', 1],
                  ['bindKey', 2],
                  ['curry', 8],
                  ['curryRight', 16],
                  ['flip', 512],
                  ['partial', l],
                  ['partialRight', 64],
                  ['rearg', 256],
                ],
                g = '[object Arguments]',
                p = '[object Array]',
                m = '[object Boolean]',
                v = '[object Date]',
                y = '[object Error]',
                C = '[object Function]',
                b = '[object GeneratorFunction]',
                x = '[object Map]',
                T = '[object Number]',
                O = '[object Object]',
                S = '[object Promise]',
                w = '[object RegExp]',
                A = '[object Set]',
                L = '[object String]',
                E = '[object Symbol]',
                P = '[object WeakMap]',
                k = '[object ArrayBuffer]',
                D = '[object DataView]',
                I = '[object Float32Array]',
                M = '[object Float64Array]',
                F = '[object Int8Array]',
                W = '[object Int16Array]',
                N = '[object Int32Array]',
                j = '[object Uint8Array]',
                z = '[object Uint8ClampedArray]',
                B = '[object Uint16Array]',
                H = '[object Uint32Array]',
                R = /\b__p \+= '';/g,
                U = /\b(__p \+=) '' \+/g,
                V = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
                $ = /&(?:amp|lt|gt|quot|#39);/g,
                Y = /[&<>"']/g,
                K = RegExp($.source),
                X = RegExp(Y.source),
                G = /<%-([\s\S]+?)%>/g,
                Z = /<%([\s\S]+?)%>/g,
                q = /<%=([\s\S]+?)%>/g,
                J = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
                Q = /^\w*$/,
                tt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
                et = /[\\^$.*+?()[\]{}|]/g,
                nt = RegExp(et.source),
                rt = /^\s+/,
                st = /\s/,
                it = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
                ot = /\{\n\/\* \[wrapped with (.+)\] \*/,
                at = /,? & /,
                lt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
                ut = /[()=,{}\[\]\/\s]/,
                ct = /\\(\\)?/g,
                ft = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
                ht = /\w*$/,
                dt = /^[-+]0x[0-9a-f]+$/i,
                _t = /^0b[01]+$/i,
                gt = /^\[object .+?Constructor\]$/,
                pt = /^0o[0-7]+$/i,
                mt = /^(?:0|[1-9]\d*)$/,
                vt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
                yt = /($^)/,
                Ct = /['\n\r\u2028\u2029\\]/g,
                bt = '\\ud800-\\udfff',
                xt = '\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff',
                Tt = '\\u2700-\\u27bf',
                Ot = 'a-z\\xdf-\\xf6\\xf8-\\xff',
                St = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
                wt = '\\ufe0e\\ufe0f',
                At =
                  '\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
                Lt = '[' + bt + ']',
                Et = '[' + At + ']',
                Pt = '[' + xt + ']',
                kt = '\\d+',
                Dt = '[' + Tt + ']',
                It = '[' + Ot + ']',
                Mt = '[^' + bt + At + kt + Tt + Ot + St + ']',
                Ft = '\\ud83c[\\udffb-\\udfff]',
                Wt = '[^' + bt + ']',
                Nt = '(?:\\ud83c[\\udde6-\\uddff]){2}',
                jt = '[\\ud800-\\udbff][\\udc00-\\udfff]',
                zt = '[' + St + ']',
                Bt = '\\u200d',
                Ht = '(?:' + It + '|' + Mt + ')',
                Rt = '(?:' + zt + '|' + Mt + ')',
                Ut = "(?:['’](?:d|ll|m|re|s|t|ve))?",
                Vt = "(?:['’](?:D|LL|M|RE|S|T|VE))?",
                $t = '(?:' + Pt + '|' + Ft + ')?',
                Yt = '[' + wt + ']?',
                Kt = Yt + $t + '(?:' + Bt + '(?:' + [Wt, Nt, jt].join('|') + ')' + Yt + $t + ')*',
                Xt = '(?:' + [Dt, Nt, jt].join('|') + ')' + Kt,
                Gt = '(?:' + [Wt + Pt + '?', Pt, Nt, jt, Lt].join('|') + ')',
                Zt = RegExp("['’]", 'g'),
                qt = RegExp(Pt, 'g'),
                Jt = RegExp(Ft + '(?=' + Ft + ')|' + Gt + Kt, 'g'),
                Qt = RegExp(
                  [
                    zt + '?' + It + '+' + Ut + '(?=' + [Et, zt, '$'].join('|') + ')',
                    Rt + '+' + Vt + '(?=' + [Et, zt + Ht, '$'].join('|') + ')',
                    zt + '?' + Ht + '+' + Ut,
                    zt + '+' + Vt,
                    '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
                    '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
                    kt,
                    Xt,
                  ].join('|'),
                  'g',
                ),
                te = RegExp('[' + Bt + bt + xt + wt + ']'),
                ee = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
                ne = [
                  'Array',
                  'Buffer',
                  'DataView',
                  'Date',
                  'Error',
                  'Float32Array',
                  'Float64Array',
                  'Function',
                  'Int8Array',
                  'Int16Array',
                  'Int32Array',
                  'Map',
                  'Math',
                  'Object',
                  'Promise',
                  'RegExp',
                  'Set',
                  'String',
                  'Symbol',
                  'TypeError',
                  'Uint8Array',
                  'Uint8ClampedArray',
                  'Uint16Array',
                  'Uint32Array',
                  'WeakMap',
                  '_',
                  'clearTimeout',
                  'isFinite',
                  'parseInt',
                  'setTimeout',
                ],
                re = -1,
                se = {};
              (se[I] = se[M] = se[F] = se[W] = se[N] = se[j] = se[z] = se[B] = se[H] = !0),
                (se[g] =
                  se[p] =
                  se[k] =
                  se[m] =
                  se[D] =
                  se[v] =
                  se[y] =
                  se[C] =
                  se[x] =
                  se[T] =
                  se[O] =
                  se[w] =
                  se[A] =
                  se[L] =
                  se[P] =
                    !1);
              var ie = {};
              (ie[g] =
                ie[p] =
                ie[k] =
                ie[D] =
                ie[m] =
                ie[v] =
                ie[I] =
                ie[M] =
                ie[F] =
                ie[W] =
                ie[N] =
                ie[x] =
                ie[T] =
                ie[O] =
                ie[w] =
                ie[A] =
                ie[L] =
                ie[E] =
                ie[j] =
                ie[z] =
                ie[B] =
                ie[H] =
                  !0),
                (ie[y] = ie[C] = ie[P] = !1);
              var oe = { '\\': '\\', "'": "'", '\n': 'n', '\r': 'r', '\u2028': 'u2028', '\u2029': 'u2029' },
                ae = parseFloat,
                le = parseInt,
                ue = 'object' == typeof n.g && n.g && n.g.Object === Object && n.g,
                ce = 'object' == typeof self && self && self.Object === Object && self,
                fe = ue || ce || Function('return this')(),
                he = e && !e.nodeType && e,
                de = he && t && !t.nodeType && t,
                _e = de && de.exports === he,
                ge = _e && ue.process,
                pe = (function () {
                  try {
                    return (de && de.require && de.require('util').types) || (ge && ge.binding && ge.binding('util'));
                  } catch (t) {}
                })(),
                me = pe && pe.isArrayBuffer,
                ve = pe && pe.isDate,
                ye = pe && pe.isMap,
                Ce = pe && pe.isRegExp,
                be = pe && pe.isSet,
                xe = pe && pe.isTypedArray;
              function Te(t, e, n) {
                switch (n.length) {
                  case 0:
                    return t.call(e);
                  case 1:
                    return t.call(e, n[0]);
                  case 2:
                    return t.call(e, n[0], n[1]);
                  case 3:
                    return t.call(e, n[0], n[1], n[2]);
                }
                return t.apply(e, n);
              }
              function Oe(t, e, n, r) {
                for (var s = -1, i = null == t ? 0 : t.length; ++s < i; ) {
                  var o = t[s];
                  e(r, o, n(o), t);
                }
                return r;
              }
              function Se(t, e) {
                for (var n = -1, r = null == t ? 0 : t.length; ++n < r && !1 !== e(t[n], n, t); );
                return t;
              }
              function we(t, e) {
                for (var n = null == t ? 0 : t.length; n-- && !1 !== e(t[n], n, t); );
                return t;
              }
              function Ae(t, e) {
                for (var n = -1, r = null == t ? 0 : t.length; ++n < r; ) if (!e(t[n], n, t)) return !1;
                return !0;
              }
              function Le(t, e) {
                for (var n = -1, r = null == t ? 0 : t.length, s = 0, i = []; ++n < r; ) {
                  var o = t[n];
                  e(o, n, t) && (i[s++] = o);
                }
                return i;
              }
              function Ee(t, e) {
                return !(null == t || !t.length) && ze(t, e, 0) > -1;
              }
              function Pe(t, e, n) {
                for (var r = -1, s = null == t ? 0 : t.length; ++r < s; ) if (n(e, t[r])) return !0;
                return !1;
              }
              function ke(t, e) {
                for (var n = -1, r = null == t ? 0 : t.length, s = Array(r); ++n < r; ) s[n] = e(t[n], n, t);
                return s;
              }
              function De(t, e) {
                for (var n = -1, r = e.length, s = t.length; ++n < r; ) t[s + n] = e[n];
                return t;
              }
              function Ie(t, e, n, r) {
                var s = -1,
                  i = null == t ? 0 : t.length;
                for (r && i && (n = t[++s]); ++s < i; ) n = e(n, t[s], s, t);
                return n;
              }
              function Me(t, e, n, r) {
                var s = null == t ? 0 : t.length;
                for (r && s && (n = t[--s]); s--; ) n = e(n, t[s], s, t);
                return n;
              }
              function Fe(t, e) {
                for (var n = -1, r = null == t ? 0 : t.length; ++n < r; ) if (e(t[n], n, t)) return !0;
                return !1;
              }
              var We = Ue('length');
              function Ne(t, e, n) {
                var r;
                return (
                  n(t, function (t, n, s) {
                    if (e(t, n, s)) return (r = n), !1;
                  }),
                  r
                );
              }
              function je(t, e, n, r) {
                for (var s = t.length, i = n + (r ? 1 : -1); r ? i-- : ++i < s; ) if (e(t[i], i, t)) return i;
                return -1;
              }
              function ze(t, e, n) {
                return e == e
                  ? (function (t, e, n) {
                      for (var r = n - 1, s = t.length; ++r < s; ) if (t[r] === e) return r;
                      return -1;
                    })(t, e, n)
                  : je(t, He, n);
              }
              function Be(t, e, n, r) {
                for (var s = n - 1, i = t.length; ++s < i; ) if (r(t[s], e)) return s;
                return -1;
              }
              function He(t) {
                return t != t;
              }
              function Re(t, e) {
                var n = null == t ? 0 : t.length;
                return n ? Ye(t, e) / n : h;
              }
              function Ue(t) {
                return function (e) {
                  return null == e ? s : e[t];
                };
              }
              function Ve(t) {
                return function (e) {
                  return null == t ? s : t[e];
                };
              }
              function $e(t, e, n, r, s) {
                return (
                  s(t, function (t, s, i) {
                    n = r ? ((r = !1), t) : e(n, t, s, i);
                  }),
                  n
                );
              }
              function Ye(t, e) {
                for (var n, r = -1, i = t.length; ++r < i; ) {
                  var o = e(t[r]);
                  o !== s && (n = n === s ? o : n + o);
                }
                return n;
              }
              function Ke(t, e) {
                for (var n = -1, r = Array(t); ++n < t; ) r[n] = e(n);
                return r;
              }
              function Xe(t) {
                return t ? t.slice(0, hn(t) + 1).replace(rt, '') : t;
              }
              function Ge(t) {
                return function (e) {
                  return t(e);
                };
              }
              function Ze(t, e) {
                return ke(e, function (e) {
                  return t[e];
                });
              }
              function qe(t, e) {
                return t.has(e);
              }
              function Je(t, e) {
                for (var n = -1, r = t.length; ++n < r && ze(e, t[n], 0) > -1; );
                return n;
              }
              function Qe(t, e) {
                for (var n = t.length; n-- && ze(e, t[n], 0) > -1; );
                return n;
              }
              var tn = Ve({
                  À: 'A',
                  Á: 'A',
                  Â: 'A',
                  Ã: 'A',
                  Ä: 'A',
                  Å: 'A',
                  à: 'a',
                  á: 'a',
                  â: 'a',
                  ã: 'a',
                  ä: 'a',
                  å: 'a',
                  Ç: 'C',
                  ç: 'c',
                  Ð: 'D',
                  ð: 'd',
                  È: 'E',
                  É: 'E',
                  Ê: 'E',
                  Ë: 'E',
                  è: 'e',
                  é: 'e',
                  ê: 'e',
                  ë: 'e',
                  Ì: 'I',
                  Í: 'I',
                  Î: 'I',
                  Ï: 'I',
                  ì: 'i',
                  í: 'i',
                  î: 'i',
                  ï: 'i',
                  Ñ: 'N',
                  ñ: 'n',
                  Ò: 'O',
                  Ó: 'O',
                  Ô: 'O',
                  Õ: 'O',
                  Ö: 'O',
                  Ø: 'O',
                  ò: 'o',
                  ó: 'o',
                  ô: 'o',
                  õ: 'o',
                  ö: 'o',
                  ø: 'o',
                  Ù: 'U',
                  Ú: 'U',
                  Û: 'U',
                  Ü: 'U',
                  ù: 'u',
                  ú: 'u',
                  û: 'u',
                  ü: 'u',
                  Ý: 'Y',
                  ý: 'y',
                  ÿ: 'y',
                  Æ: 'Ae',
                  æ: 'ae',
                  Þ: 'Th',
                  þ: 'th',
                  ß: 'ss',
                  Ā: 'A',
                  Ă: 'A',
                  Ą: 'A',
                  ā: 'a',
                  ă: 'a',
                  ą: 'a',
                  Ć: 'C',
                  Ĉ: 'C',
                  Ċ: 'C',
                  Č: 'C',
                  ć: 'c',
                  ĉ: 'c',
                  ċ: 'c',
                  č: 'c',
                  Ď: 'D',
                  Đ: 'D',
                  ď: 'd',
                  đ: 'd',
                  Ē: 'E',
                  Ĕ: 'E',
                  Ė: 'E',
                  Ę: 'E',
                  Ě: 'E',
                  ē: 'e',
                  ĕ: 'e',
                  ė: 'e',
                  ę: 'e',
                  ě: 'e',
                  Ĝ: 'G',
                  Ğ: 'G',
                  Ġ: 'G',
                  Ģ: 'G',
                  ĝ: 'g',
                  ğ: 'g',
                  ġ: 'g',
                  ģ: 'g',
                  Ĥ: 'H',
                  Ħ: 'H',
                  ĥ: 'h',
                  ħ: 'h',
                  Ĩ: 'I',
                  Ī: 'I',
                  Ĭ: 'I',
                  Į: 'I',
                  İ: 'I',
                  ĩ: 'i',
                  ī: 'i',
                  ĭ: 'i',
                  į: 'i',
                  ı: 'i',
                  Ĵ: 'J',
                  ĵ: 'j',
                  Ķ: 'K',
                  ķ: 'k',
                  ĸ: 'k',
                  Ĺ: 'L',
                  Ļ: 'L',
                  Ľ: 'L',
                  Ŀ: 'L',
                  Ł: 'L',
                  ĺ: 'l',
                  ļ: 'l',
                  ľ: 'l',
                  ŀ: 'l',
                  ł: 'l',
                  Ń: 'N',
                  Ņ: 'N',
                  Ň: 'N',
                  Ŋ: 'N',
                  ń: 'n',
                  ņ: 'n',
                  ň: 'n',
                  ŋ: 'n',
                  Ō: 'O',
                  Ŏ: 'O',
                  Ő: 'O',
                  ō: 'o',
                  ŏ: 'o',
                  ő: 'o',
                  Ŕ: 'R',
                  Ŗ: 'R',
                  Ř: 'R',
                  ŕ: 'r',
                  ŗ: 'r',
                  ř: 'r',
                  Ś: 'S',
                  Ŝ: 'S',
                  Ş: 'S',
                  Š: 'S',
                  ś: 's',
                  ŝ: 's',
                  ş: 's',
                  š: 's',
                  Ţ: 'T',
                  Ť: 'T',
                  Ŧ: 'T',
                  ţ: 't',
                  ť: 't',
                  ŧ: 't',
                  Ũ: 'U',
                  Ū: 'U',
                  Ŭ: 'U',
                  Ů: 'U',
                  Ű: 'U',
                  Ų: 'U',
                  ũ: 'u',
                  ū: 'u',
                  ŭ: 'u',
                  ů: 'u',
                  ű: 'u',
                  ų: 'u',
                  Ŵ: 'W',
                  ŵ: 'w',
                  Ŷ: 'Y',
                  ŷ: 'y',
                  Ÿ: 'Y',
                  Ź: 'Z',
                  Ż: 'Z',
                  Ž: 'Z',
                  ź: 'z',
                  ż: 'z',
                  ž: 'z',
                  Ĳ: 'IJ',
                  ĳ: 'ij',
                  Œ: 'Oe',
                  œ: 'oe',
                  ŉ: "'n",
                  ſ: 's',
                }),
                en = Ve({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' });
              function nn(t) {
                return '\\' + oe[t];
              }
              function rn(t) {
                return te.test(t);
              }
              function sn(t) {
                var e = -1,
                  n = Array(t.size);
                return (
                  t.forEach(function (t, r) {
                    n[++e] = [r, t];
                  }),
                  n
                );
              }
              function on(t, e) {
                return function (n) {
                  return t(e(n));
                };
              }
              function an(t, e) {
                for (var n = -1, r = t.length, s = 0, i = []; ++n < r; ) {
                  var o = t[n];
                  (o !== e && o !== a) || ((t[n] = a), (i[s++] = n));
                }
                return i;
              }
              function ln(t) {
                var e = -1,
                  n = Array(t.size);
                return (
                  t.forEach(function (t) {
                    n[++e] = t;
                  }),
                  n
                );
              }
              function un(t) {
                var e = -1,
                  n = Array(t.size);
                return (
                  t.forEach(function (t) {
                    n[++e] = [t, t];
                  }),
                  n
                );
              }
              function cn(t) {
                return rn(t)
                  ? (function (t) {
                      for (var e = (Jt.lastIndex = 0); Jt.test(t); ) ++e;
                      return e;
                    })(t)
                  : We(t);
              }
              function fn(t) {
                return rn(t)
                  ? (function (t) {
                      return t.match(Jt) || [];
                    })(t)
                  : (function (t) {
                      return t.split('');
                    })(t);
              }
              function hn(t) {
                for (var e = t.length; e-- && st.test(t.charAt(e)); );
                return e;
              }
              var dn = Ve({ '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'" }),
                _n = (function t(e) {
                  var n,
                    r = (e = null == e ? fe : _n.defaults(fe.Object(), e, _n.pick(fe, ne))).Array,
                    st = e.Date,
                    bt = e.Error,
                    xt = e.Function,
                    Tt = e.Math,
                    Ot = e.Object,
                    St = e.RegExp,
                    wt = e.String,
                    At = e.TypeError,
                    Lt = r.prototype,
                    Et = xt.prototype,
                    Pt = Ot.prototype,
                    kt = e['__core-js_shared__'],
                    Dt = Et.toString,
                    It = Pt.hasOwnProperty,
                    Mt = 0,
                    Ft = (n = /[^.]+$/.exec((kt && kt.keys && kt.keys.IE_PROTO) || '')) ? 'Symbol(src)_1.' + n : '',
                    Wt = Pt.toString,
                    Nt = Dt.call(Ot),
                    jt = fe._,
                    zt = St(
                      '^' +
                        Dt.call(It)
                          .replace(et, '\\$&')
                          .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') +
                        '$',
                    ),
                    Bt = _e ? e.Buffer : s,
                    Ht = e.Symbol,
                    Rt = e.Uint8Array,
                    Ut = Bt ? Bt.allocUnsafe : s,
                    Vt = on(Ot.getPrototypeOf, Ot),
                    $t = Ot.create,
                    Yt = Pt.propertyIsEnumerable,
                    Kt = Lt.splice,
                    Xt = Ht ? Ht.isConcatSpreadable : s,
                    Gt = Ht ? Ht.iterator : s,
                    Jt = Ht ? Ht.toStringTag : s,
                    te = (function () {
                      try {
                        var t = li(Ot, 'defineProperty');
                        return t({}, '', {}), t;
                      } catch (t) {}
                    })(),
                    oe = e.clearTimeout !== fe.clearTimeout && e.clearTimeout,
                    ue = st && st.now !== fe.Date.now && st.now,
                    ce = e.setTimeout !== fe.setTimeout && e.setTimeout,
                    he = Tt.ceil,
                    de = Tt.floor,
                    ge = Ot.getOwnPropertySymbols,
                    pe = Bt ? Bt.isBuffer : s,
                    We = e.isFinite,
                    Ve = Lt.join,
                    gn = on(Ot.keys, Ot),
                    pn = Tt.max,
                    mn = Tt.min,
                    vn = st.now,
                    yn = e.parseInt,
                    Cn = Tt.random,
                    bn = Lt.reverse,
                    xn = li(e, 'DataView'),
                    Tn = li(e, 'Map'),
                    On = li(e, 'Promise'),
                    Sn = li(e, 'Set'),
                    wn = li(e, 'WeakMap'),
                    An = li(Ot, 'create'),
                    Ln = wn && new wn(),
                    En = {},
                    Pn = Wi(xn),
                    kn = Wi(Tn),
                    Dn = Wi(On),
                    In = Wi(Sn),
                    Mn = Wi(wn),
                    Fn = Ht ? Ht.prototype : s,
                    Wn = Fn ? Fn.valueOf : s,
                    Nn = Fn ? Fn.toString : s;
                  function jn(t) {
                    if (ta(t) && !Uo(t) && !(t instanceof Rn)) {
                      if (t instanceof Hn) return t;
                      if (It.call(t, '__wrapped__')) return Ni(t);
                    }
                    return new Hn(t);
                  }
                  var zn = (function () {
                    function t() {}
                    return function (e) {
                      if (!Qo(e)) return {};
                      if ($t) return $t(e);
                      t.prototype = e;
                      var n = new t();
                      return (t.prototype = s), n;
                    };
                  })();
                  function Bn() {}
                  function Hn(t, e) {
                    (this.__wrapped__ = t),
                      (this.__actions__ = []),
                      (this.__chain__ = !!e),
                      (this.__index__ = 0),
                      (this.__values__ = s);
                  }
                  function Rn(t) {
                    (this.__wrapped__ = t),
                      (this.__actions__ = []),
                      (this.__dir__ = 1),
                      (this.__filtered__ = !1),
                      (this.__iteratees__ = []),
                      (this.__takeCount__ = d),
                      (this.__views__ = []);
                  }
                  function Un(t) {
                    var e = -1,
                      n = null == t ? 0 : t.length;
                    for (this.clear(); ++e < n; ) {
                      var r = t[e];
                      this.set(r[0], r[1]);
                    }
                  }
                  function Vn(t) {
                    var e = -1,
                      n = null == t ? 0 : t.length;
                    for (this.clear(); ++e < n; ) {
                      var r = t[e];
                      this.set(r[0], r[1]);
                    }
                  }
                  function $n(t) {
                    var e = -1,
                      n = null == t ? 0 : t.length;
                    for (this.clear(); ++e < n; ) {
                      var r = t[e];
                      this.set(r[0], r[1]);
                    }
                  }
                  function Yn(t) {
                    var e = -1,
                      n = null == t ? 0 : t.length;
                    for (this.__data__ = new $n(); ++e < n; ) this.add(t[e]);
                  }
                  function Kn(t) {
                    var e = (this.__data__ = new Vn(t));
                    this.size = e.size;
                  }
                  function Xn(t, e) {
                    var n = Uo(t),
                      r = !n && Ro(t),
                      s = !n && !r && Ko(t),
                      i = !n && !r && !s && la(t),
                      o = n || r || s || i,
                      a = o ? Ke(t.length, wt) : [],
                      l = a.length;
                    for (var u in t)
                      (!e && !It.call(t, u)) ||
                        (o &&
                          ('length' == u ||
                            (s && ('offset' == u || 'parent' == u)) ||
                            (i && ('buffer' == u || 'byteLength' == u || 'byteOffset' == u)) ||
                            gi(u, l))) ||
                        a.push(u);
                    return a;
                  }
                  function Gn(t) {
                    var e = t.length;
                    return e ? t[$r(0, e - 1)] : s;
                  }
                  function Zn(t, e) {
                    return ki(ws(t), ir(e, 0, t.length));
                  }
                  function qn(t) {
                    return ki(ws(t));
                  }
                  function Jn(t, e, n) {
                    ((n !== s && !zo(t[e], n)) || (n === s && !(e in t))) && rr(t, e, n);
                  }
                  function Qn(t, e, n) {
                    var r = t[e];
                    (It.call(t, e) && zo(r, n) && (n !== s || e in t)) || rr(t, e, n);
                  }
                  function tr(t, e) {
                    for (var n = t.length; n--; ) if (zo(t[n][0], e)) return n;
                    return -1;
                  }
                  function er(t, e, n, r) {
                    return (
                      cr(t, function (t, s, i) {
                        e(r, t, n(t), i);
                      }),
                      r
                    );
                  }
                  function nr(t, e) {
                    return t && As(e, Pa(e), t);
                  }
                  function rr(t, e, n) {
                    '__proto__' == e && te
                      ? te(t, e, { configurable: !0, enumerable: !0, value: n, writable: !0 })
                      : (t[e] = n);
                  }
                  function sr(t, e) {
                    for (var n = -1, i = e.length, o = r(i), a = null == t; ++n < i; ) o[n] = a ? s : Sa(t, e[n]);
                    return o;
                  }
                  function ir(t, e, n) {
                    return t == t && (n !== s && (t = t <= n ? t : n), e !== s && (t = t >= e ? t : e)), t;
                  }
                  function or(t, e, n, r, i, o) {
                    var a,
                      l = 1 & e,
                      u = 2 & e,
                      c = 4 & e;
                    if ((n && (a = i ? n(t, r, i, o) : n(t)), a !== s)) return a;
                    if (!Qo(t)) return t;
                    var f = Uo(t);
                    if (f) {
                      if (
                        ((a = (function (t) {
                          var e = t.length,
                            n = new t.constructor(e);
                          return (
                            e &&
                              'string' == typeof t[0] &&
                              It.call(t, 'index') &&
                              ((n.index = t.index), (n.input = t.input)),
                            n
                          );
                        })(t)),
                        !l)
                      )
                        return ws(t, a);
                    } else {
                      var h = fi(t),
                        d = h == C || h == b;
                      if (Ko(t)) return Cs(t, l);
                      if (h == O || h == g || (d && !i)) {
                        if (((a = u || d ? {} : di(t)), !l))
                          return u
                            ? (function (t, e) {
                                return As(t, ci(t), e);
                              })(
                                t,
                                (function (t, e) {
                                  return t && As(e, ka(e), t);
                                })(a, t),
                              )
                            : (function (t, e) {
                                return As(t, ui(t), e);
                              })(t, nr(a, t));
                      } else {
                        if (!ie[h]) return i ? t : {};
                        a = (function (t, e, n) {
                          var r,
                            s = t.constructor;
                          switch (e) {
                            case k:
                              return bs(t);
                            case m:
                            case v:
                              return new s(+t);
                            case D:
                              return (function (t, e) {
                                var n = e ? bs(t.buffer) : t.buffer;
                                return new t.constructor(n, t.byteOffset, t.byteLength);
                              })(t, n);
                            case I:
                            case M:
                            case F:
                            case W:
                            case N:
                            case j:
                            case z:
                            case B:
                            case H:
                              return xs(t, n);
                            case x:
                              return new s();
                            case T:
                            case L:
                              return new s(t);
                            case w:
                              return (function (t) {
                                var e = new t.constructor(t.source, ht.exec(t));
                                return (e.lastIndex = t.lastIndex), e;
                              })(t);
                            case A:
                              return new s();
                            case E:
                              return (r = t), Wn ? Ot(Wn.call(r)) : {};
                          }
                        })(t, h, l);
                      }
                    }
                    o || (o = new Kn());
                    var _ = o.get(t);
                    if (_) return _;
                    o.set(t, a),
                      ia(t)
                        ? t.forEach(function (r) {
                            a.add(or(r, e, n, r, t, o));
                          })
                        : ea(t) &&
                          t.forEach(function (r, s) {
                            a.set(s, or(r, e, n, s, t, o));
                          });
                    var p = f ? s : (c ? (u ? ei : ti) : u ? ka : Pa)(t);
                    return (
                      Se(p || t, function (r, s) {
                        p && (r = t[(s = r)]), Qn(a, s, or(r, e, n, s, t, o));
                      }),
                      a
                    );
                  }
                  function ar(t, e, n) {
                    var r = n.length;
                    if (null == t) return !r;
                    for (t = Ot(t); r--; ) {
                      var i = n[r],
                        o = e[i],
                        a = t[i];
                      if ((a === s && !(i in t)) || !o(a)) return !1;
                    }
                    return !0;
                  }
                  function lr(t, e, n) {
                    if ('function' != typeof t) throw new At(i);
                    return Ai(function () {
                      t.apply(s, n);
                    }, e);
                  }
                  function ur(t, e, n, r) {
                    var s = -1,
                      i = Ee,
                      o = !0,
                      a = t.length,
                      l = [],
                      u = e.length;
                    if (!a) return l;
                    n && (e = ke(e, Ge(n))),
                      r ? ((i = Pe), (o = !1)) : e.length >= 200 && ((i = qe), (o = !1), (e = new Yn(e)));
                    t: for (; ++s < a; ) {
                      var c = t[s],
                        f = null == n ? c : n(c);
                      if (((c = r || 0 !== c ? c : 0), o && f == f)) {
                        for (var h = u; h--; ) if (e[h] === f) continue t;
                        l.push(c);
                      } else i(e, f, r) || l.push(c);
                    }
                    return l;
                  }
                  (jn.templateSettings = { escape: G, evaluate: Z, interpolate: q, variable: '', imports: { _: jn } }),
                    (jn.prototype = Bn.prototype),
                    (jn.prototype.constructor = jn),
                    (Hn.prototype = zn(Bn.prototype)),
                    (Hn.prototype.constructor = Hn),
                    (Rn.prototype = zn(Bn.prototype)),
                    (Rn.prototype.constructor = Rn),
                    (Un.prototype.clear = function () {
                      (this.__data__ = An ? An(null) : {}), (this.size = 0);
                    }),
                    (Un.prototype.delete = function (t) {
                      var e = this.has(t) && delete this.__data__[t];
                      return (this.size -= e ? 1 : 0), e;
                    }),
                    (Un.prototype.get = function (t) {
                      var e = this.__data__;
                      if (An) {
                        var n = e[t];
                        return n === o ? s : n;
                      }
                      return It.call(e, t) ? e[t] : s;
                    }),
                    (Un.prototype.has = function (t) {
                      var e = this.__data__;
                      return An ? e[t] !== s : It.call(e, t);
                    }),
                    (Un.prototype.set = function (t, e) {
                      var n = this.__data__;
                      return (this.size += this.has(t) ? 0 : 1), (n[t] = An && e === s ? o : e), this;
                    }),
                    (Vn.prototype.clear = function () {
                      (this.__data__ = []), (this.size = 0);
                    }),
                    (Vn.prototype.delete = function (t) {
                      var e = this.__data__,
                        n = tr(e, t);
                      return !(n < 0 || (n == e.length - 1 ? e.pop() : Kt.call(e, n, 1), --this.size, 0));
                    }),
                    (Vn.prototype.get = function (t) {
                      var e = this.__data__,
                        n = tr(e, t);
                      return n < 0 ? s : e[n][1];
                    }),
                    (Vn.prototype.has = function (t) {
                      return tr(this.__data__, t) > -1;
                    }),
                    (Vn.prototype.set = function (t, e) {
                      var n = this.__data__,
                        r = tr(n, t);
                      return r < 0 ? (++this.size, n.push([t, e])) : (n[r][1] = e), this;
                    }),
                    ($n.prototype.clear = function () {
                      (this.size = 0), (this.__data__ = { hash: new Un(), map: new (Tn || Vn)(), string: new Un() });
                    }),
                    ($n.prototype.delete = function (t) {
                      var e = oi(this, t).delete(t);
                      return (this.size -= e ? 1 : 0), e;
                    }),
                    ($n.prototype.get = function (t) {
                      return oi(this, t).get(t);
                    }),
                    ($n.prototype.has = function (t) {
                      return oi(this, t).has(t);
                    }),
                    ($n.prototype.set = function (t, e) {
                      var n = oi(this, t),
                        r = n.size;
                      return n.set(t, e), (this.size += n.size == r ? 0 : 1), this;
                    }),
                    (Yn.prototype.add = Yn.prototype.push =
                      function (t) {
                        return this.__data__.set(t, o), this;
                      }),
                    (Yn.prototype.has = function (t) {
                      return this.__data__.has(t);
                    }),
                    (Kn.prototype.clear = function () {
                      (this.__data__ = new Vn()), (this.size = 0);
                    }),
                    (Kn.prototype.delete = function (t) {
                      var e = this.__data__,
                        n = e.delete(t);
                      return (this.size = e.size), n;
                    }),
                    (Kn.prototype.get = function (t) {
                      return this.__data__.get(t);
                    }),
                    (Kn.prototype.has = function (t) {
                      return this.__data__.has(t);
                    }),
                    (Kn.prototype.set = function (t, e) {
                      var n = this.__data__;
                      if (n instanceof Vn) {
                        var r = n.__data__;
                        if (!Tn || r.length < 199) return r.push([t, e]), (this.size = ++n.size), this;
                        n = this.__data__ = new $n(r);
                      }
                      return n.set(t, e), (this.size = n.size), this;
                    });
                  var cr = Ps(vr),
                    fr = Ps(yr, !0);
                  function hr(t, e) {
                    var n = !0;
                    return (
                      cr(t, function (t, r, s) {
                        return (n = !!e(t, r, s));
                      }),
                      n
                    );
                  }
                  function dr(t, e, n) {
                    for (var r = -1, i = t.length; ++r < i; ) {
                      var o = t[r],
                        a = e(o);
                      if (null != a && (l === s ? a == a && !aa(a) : n(a, l)))
                        var l = a,
                          u = o;
                    }
                    return u;
                  }
                  function _r(t, e) {
                    var n = [];
                    return (
                      cr(t, function (t, r, s) {
                        e(t, r, s) && n.push(t);
                      }),
                      n
                    );
                  }
                  function gr(t, e, n, r, s) {
                    var i = -1,
                      o = t.length;
                    for (n || (n = _i), s || (s = []); ++i < o; ) {
                      var a = t[i];
                      e > 0 && n(a) ? (e > 1 ? gr(a, e - 1, n, r, s) : De(s, a)) : r || (s[s.length] = a);
                    }
                    return s;
                  }
                  var pr = ks(),
                    mr = ks(!0);
                  function vr(t, e) {
                    return t && pr(t, e, Pa);
                  }
                  function yr(t, e) {
                    return t && mr(t, e, Pa);
                  }
                  function Cr(t, e) {
                    return Le(e, function (e) {
                      return Zo(t[e]);
                    });
                  }
                  function br(t, e) {
                    for (var n = 0, r = (e = ps(e, t)).length; null != t && n < r; ) t = t[Fi(e[n++])];
                    return n && n == r ? t : s;
                  }
                  function xr(t, e, n) {
                    var r = e(t);
                    return Uo(t) ? r : De(r, n(t));
                  }
                  function Tr(t) {
                    return null == t
                      ? t === s
                        ? '[object Undefined]'
                        : '[object Null]'
                      : Jt && Jt in Ot(t)
                        ? (function (t) {
                            var e = It.call(t, Jt),
                              n = t[Jt];
                            try {
                              t[Jt] = s;
                              var r = !0;
                            } catch (t) {}
                            var i = Wt.call(t);
                            return r && (e ? (t[Jt] = n) : delete t[Jt]), i;
                          })(t)
                        : (function (t) {
                            return Wt.call(t);
                          })(t);
                  }
                  function Or(t, e) {
                    return t > e;
                  }
                  function Sr(t, e) {
                    return null != t && It.call(t, e);
                  }
                  function wr(t, e) {
                    return null != t && e in Ot(t);
                  }
                  function Ar(t, e, n) {
                    for (
                      var i = n ? Pe : Ee, o = t[0].length, a = t.length, l = a, u = r(a), c = 1 / 0, f = [];
                      l--;

                    ) {
                      var h = t[l];
                      l && e && (h = ke(h, Ge(e))),
                        (c = mn(h.length, c)),
                        (u[l] = !n && (e || (o >= 120 && h.length >= 120)) ? new Yn(l && h) : s);
                    }
                    h = t[0];
                    var d = -1,
                      _ = u[0];
                    t: for (; ++d < o && f.length < c; ) {
                      var g = h[d],
                        p = e ? e(g) : g;
                      if (((g = n || 0 !== g ? g : 0), !(_ ? qe(_, p) : i(f, p, n)))) {
                        for (l = a; --l; ) {
                          var m = u[l];
                          if (!(m ? qe(m, p) : i(t[l], p, n))) continue t;
                        }
                        _ && _.push(p), f.push(g);
                      }
                    }
                    return f;
                  }
                  function Lr(t, e, n) {
                    var r = null == (t = Oi(t, (e = ps(e, t)))) ? t : t[Fi(Xi(e))];
                    return null == r ? s : Te(r, t, n);
                  }
                  function Er(t) {
                    return ta(t) && Tr(t) == g;
                  }
                  function Pr(t, e, n, r, i) {
                    return (
                      t === e ||
                      (null == t || null == e || (!ta(t) && !ta(e))
                        ? t != t && e != e
                        : (function (t, e, n, r, i, o) {
                            var a = Uo(t),
                              l = Uo(e),
                              u = a ? p : fi(t),
                              c = l ? p : fi(e),
                              f = (u = u == g ? O : u) == O,
                              h = (c = c == g ? O : c) == O,
                              d = u == c;
                            if (d && Ko(t)) {
                              if (!Ko(e)) return !1;
                              (a = !0), (f = !1);
                            }
                            if (d && !f)
                              return (
                                o || (o = new Kn()),
                                a || la(t)
                                  ? Js(t, e, n, r, i, o)
                                  : (function (t, e, n, r, s, i, o) {
                                      switch (n) {
                                        case D:
                                          if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
                                          (t = t.buffer), (e = e.buffer);
                                        case k:
                                          return !(t.byteLength != e.byteLength || !i(new Rt(t), new Rt(e)));
                                        case m:
                                        case v:
                                        case T:
                                          return zo(+t, +e);
                                        case y:
                                          return t.name == e.name && t.message == e.message;
                                        case w:
                                        case L:
                                          return t == e + '';
                                        case x:
                                          var a = sn;
                                        case A:
                                          var l = 1 & r;
                                          if ((a || (a = ln), t.size != e.size && !l)) return !1;
                                          var u = o.get(t);
                                          if (u) return u == e;
                                          (r |= 2), o.set(t, e);
                                          var c = Js(a(t), a(e), r, s, i, o);
                                          return o.delete(t), c;
                                        case E:
                                          if (Wn) return Wn.call(t) == Wn.call(e);
                                      }
                                      return !1;
                                    })(t, e, u, n, r, i, o)
                              );
                            if (!(1 & n)) {
                              var _ = f && It.call(t, '__wrapped__'),
                                C = h && It.call(e, '__wrapped__');
                              if (_ || C) {
                                var b = _ ? t.value() : t,
                                  S = C ? e.value() : e;
                                return o || (o = new Kn()), i(b, S, n, r, o);
                              }
                            }
                            return (
                              !!d &&
                              (o || (o = new Kn()),
                              (function (t, e, n, r, i, o) {
                                var a = 1 & n,
                                  l = ti(t),
                                  u = l.length;
                                if (u != ti(e).length && !a) return !1;
                                for (var c = u; c--; ) {
                                  var f = l[c];
                                  if (!(a ? f in e : It.call(e, f))) return !1;
                                }
                                var h = o.get(t),
                                  d = o.get(e);
                                if (h && d) return h == e && d == t;
                                var _ = !0;
                                o.set(t, e), o.set(e, t);
                                for (var g = a; ++c < u; ) {
                                  var p = t[(f = l[c])],
                                    m = e[f];
                                  if (r) var v = a ? r(m, p, f, e, t, o) : r(p, m, f, t, e, o);
                                  if (!(v === s ? p === m || i(p, m, n, r, o) : v)) {
                                    _ = !1;
                                    break;
                                  }
                                  g || (g = 'constructor' == f);
                                }
                                if (_ && !g) {
                                  var y = t.constructor,
                                    C = e.constructor;
                                  y == C ||
                                    !('constructor' in t) ||
                                    !('constructor' in e) ||
                                    ('function' == typeof y &&
                                      y instanceof y &&
                                      'function' == typeof C &&
                                      C instanceof C) ||
                                    (_ = !1);
                                }
                                return o.delete(t), o.delete(e), _;
                              })(t, e, n, r, i, o))
                            );
                          })(t, e, n, r, Pr, i))
                    );
                  }
                  function kr(t, e, n, r) {
                    var i = n.length,
                      o = i,
                      a = !r;
                    if (null == t) return !o;
                    for (t = Ot(t); i--; ) {
                      var l = n[i];
                      if (a && l[2] ? l[1] !== t[l[0]] : !(l[0] in t)) return !1;
                    }
                    for (; ++i < o; ) {
                      var u = (l = n[i])[0],
                        c = t[u],
                        f = l[1];
                      if (a && l[2]) {
                        if (c === s && !(u in t)) return !1;
                      } else {
                        var h = new Kn();
                        if (r) var d = r(c, f, u, t, e, h);
                        if (!(d === s ? Pr(f, c, 3, r, h) : d)) return !1;
                      }
                    }
                    return !0;
                  }
                  function Dr(t) {
                    return !(!Qo(t) || ((e = t), Ft && Ft in e)) && (Zo(t) ? zt : gt).test(Wi(t));
                    var e;
                  }
                  function Ir(t) {
                    return 'function' == typeof t
                      ? t
                      : null == t
                        ? nl
                        : 'object' == typeof t
                          ? Uo(t)
                            ? jr(t[0], t[1])
                            : Nr(t)
                          : fl(t);
                  }
                  function Mr(t) {
                    if (!Ci(t)) return gn(t);
                    var e = [];
                    for (var n in Ot(t)) It.call(t, n) && 'constructor' != n && e.push(n);
                    return e;
                  }
                  function Fr(t, e) {
                    return t < e;
                  }
                  function Wr(t, e) {
                    var n = -1,
                      s = $o(t) ? r(t.length) : [];
                    return (
                      cr(t, function (t, r, i) {
                        s[++n] = e(t, r, i);
                      }),
                      s
                    );
                  }
                  function Nr(t) {
                    var e = ai(t);
                    return 1 == e.length && e[0][2]
                      ? xi(e[0][0], e[0][1])
                      : function (n) {
                          return n === t || kr(n, t, e);
                        };
                  }
                  function jr(t, e) {
                    return mi(t) && bi(e)
                      ? xi(Fi(t), e)
                      : function (n) {
                          var r = Sa(n, t);
                          return r === s && r === e ? wa(n, t) : Pr(e, r, 3);
                        };
                  }
                  function zr(t, e, n, r, i) {
                    t !== e &&
                      pr(
                        e,
                        function (o, a) {
                          if ((i || (i = new Kn()), Qo(o)))
                            !(function (t, e, n, r, i, o, a) {
                              var l = Si(t, n),
                                u = Si(e, n),
                                c = a.get(u);
                              if (c) Jn(t, n, c);
                              else {
                                var f = o ? o(l, u, n + '', t, e, a) : s,
                                  h = f === s;
                                if (h) {
                                  var d = Uo(u),
                                    _ = !d && Ko(u),
                                    g = !d && !_ && la(u);
                                  (f = u),
                                    d || _ || g
                                      ? Uo(l)
                                        ? (f = l)
                                        : Yo(l)
                                          ? (f = ws(l))
                                          : _
                                            ? ((h = !1), (f = Cs(u, !0)))
                                            : g
                                              ? ((h = !1), (f = xs(u, !0)))
                                              : (f = [])
                                      : ra(u) || Ro(u)
                                        ? ((f = l), Ro(l) ? (f = pa(l)) : (Qo(l) && !Zo(l)) || (f = di(u)))
                                        : (h = !1);
                                }
                                h && (a.set(u, f), i(f, u, r, o, a), a.delete(u)), Jn(t, n, f);
                              }
                            })(t, e, a, n, zr, r, i);
                          else {
                            var l = r ? r(Si(t, a), o, a + '', t, e, i) : s;
                            l === s && (l = o), Jn(t, a, l);
                          }
                        },
                        ka,
                      );
                  }
                  function Br(t, e) {
                    var n = t.length;
                    if (n) return gi((e += e < 0 ? n : 0), n) ? t[e] : s;
                  }
                  function Hr(t, e, n) {
                    e = e.length
                      ? ke(e, function (t) {
                          return Uo(t)
                            ? function (e) {
                                return br(e, 1 === t.length ? t[0] : t);
                              }
                            : t;
                        })
                      : [nl];
                    var r = -1;
                    e = ke(e, Ge(ii()));
                    var s = Wr(t, function (t, n, s) {
                      var i = ke(e, function (e) {
                        return e(t);
                      });
                      return { criteria: i, index: ++r, value: t };
                    });
                    return (function (t) {
                      var e = t.length;
                      for (
                        t.sort(function (t, e) {
                          return (function (t, e, n) {
                            for (var r = -1, s = t.criteria, i = e.criteria, o = s.length, a = n.length; ++r < o; ) {
                              var l = Ts(s[r], i[r]);
                              if (l) return r >= a ? l : l * ('desc' == n[r] ? -1 : 1);
                            }
                            return t.index - e.index;
                          })(t, e, n);
                        });
                        e--;

                      )
                        t[e] = t[e].value;
                      return t;
                    })(s);
                  }
                  function Rr(t, e, n) {
                    for (var r = -1, s = e.length, i = {}; ++r < s; ) {
                      var o = e[r],
                        a = br(t, o);
                      n(a, o) && Zr(i, ps(o, t), a);
                    }
                    return i;
                  }
                  function Ur(t, e, n, r) {
                    var s = r ? Be : ze,
                      i = -1,
                      o = e.length,
                      a = t;
                    for (t === e && (e = ws(e)), n && (a = ke(t, Ge(n))); ++i < o; )
                      for (var l = 0, u = e[i], c = n ? n(u) : u; (l = s(a, c, l, r)) > -1; )
                        a !== t && Kt.call(a, l, 1), Kt.call(t, l, 1);
                    return t;
                  }
                  function Vr(t, e) {
                    for (var n = t ? e.length : 0, r = n - 1; n--; ) {
                      var s = e[n];
                      if (n == r || s !== i) {
                        var i = s;
                        gi(s) ? Kt.call(t, s, 1) : ls(t, s);
                      }
                    }
                    return t;
                  }
                  function $r(t, e) {
                    return t + de(Cn() * (e - t + 1));
                  }
                  function Yr(t, e) {
                    var n = '';
                    if (!t || e < 1 || e > f) return n;
                    do {
                      e % 2 && (n += t), (e = de(e / 2)) && (t += t);
                    } while (e);
                    return n;
                  }
                  function Kr(t, e) {
                    return Li(Ti(t, e, nl), t + '');
                  }
                  function Xr(t) {
                    return Gn(za(t));
                  }
                  function Gr(t, e) {
                    var n = za(t);
                    return ki(n, ir(e, 0, n.length));
                  }
                  function Zr(t, e, n, r) {
                    if (!Qo(t)) return t;
                    for (var i = -1, o = (e = ps(e, t)).length, a = o - 1, l = t; null != l && ++i < o; ) {
                      var u = Fi(e[i]),
                        c = n;
                      if ('__proto__' === u || 'constructor' === u || 'prototype' === u) return t;
                      if (i != a) {
                        var f = l[u];
                        (c = r ? r(f, u, l) : s) === s && (c = Qo(f) ? f : gi(e[i + 1]) ? [] : {});
                      }
                      Qn(l, u, c), (l = l[u]);
                    }
                    return t;
                  }
                  var qr = Ln
                      ? function (t, e) {
                          return Ln.set(t, e), t;
                        }
                      : nl,
                    Jr = te
                      ? function (t, e) {
                          return te(t, 'toString', { configurable: !0, enumerable: !1, value: Qa(e), writable: !0 });
                        }
                      : nl;
                  function Qr(t) {
                    return ki(za(t));
                  }
                  function ts(t, e, n) {
                    var s = -1,
                      i = t.length;
                    e < 0 && (e = -e > i ? 0 : i + e),
                      (n = n > i ? i : n) < 0 && (n += i),
                      (i = e > n ? 0 : (n - e) >>> 0),
                      (e >>>= 0);
                    for (var o = r(i); ++s < i; ) o[s] = t[s + e];
                    return o;
                  }
                  function es(t, e) {
                    var n;
                    return (
                      cr(t, function (t, r, s) {
                        return !(n = e(t, r, s));
                      }),
                      !!n
                    );
                  }
                  function ns(t, e, n) {
                    var r = 0,
                      s = null == t ? r : t.length;
                    if ('number' == typeof e && e == e && s <= 2147483647) {
                      for (; r < s; ) {
                        var i = (r + s) >>> 1,
                          o = t[i];
                        null !== o && !aa(o) && (n ? o <= e : o < e) ? (r = i + 1) : (s = i);
                      }
                      return s;
                    }
                    return rs(t, e, nl, n);
                  }
                  function rs(t, e, n, r) {
                    var i = 0,
                      o = null == t ? 0 : t.length;
                    if (0 === o) return 0;
                    for (var a = (e = n(e)) != e, l = null === e, u = aa(e), c = e === s; i < o; ) {
                      var f = de((i + o) / 2),
                        h = n(t[f]),
                        d = h !== s,
                        _ = null === h,
                        g = h == h,
                        p = aa(h);
                      if (a) var m = r || g;
                      else
                        m = c
                          ? g && (r || d)
                          : l
                            ? g && d && (r || !_)
                            : u
                              ? g && d && !_ && (r || !p)
                              : !_ && !p && (r ? h <= e : h < e);
                      m ? (i = f + 1) : (o = f);
                    }
                    return mn(o, 4294967294);
                  }
                  function ss(t, e) {
                    for (var n = -1, r = t.length, s = 0, i = []; ++n < r; ) {
                      var o = t[n],
                        a = e ? e(o) : o;
                      if (!n || !zo(a, l)) {
                        var l = a;
                        i[s++] = 0 === o ? 0 : o;
                      }
                    }
                    return i;
                  }
                  function is(t) {
                    return 'number' == typeof t ? t : aa(t) ? h : +t;
                  }
                  function os(t) {
                    if ('string' == typeof t) return t;
                    if (Uo(t)) return ke(t, os) + '';
                    if (aa(t)) return Nn ? Nn.call(t) : '';
                    var e = t + '';
                    return '0' == e && 1 / t == -1 / 0 ? '-0' : e;
                  }
                  function as(t, e, n) {
                    var r = -1,
                      s = Ee,
                      i = t.length,
                      o = !0,
                      a = [],
                      l = a;
                    if (n) (o = !1), (s = Pe);
                    else if (i >= 200) {
                      var u = e ? null : Ys(t);
                      if (u) return ln(u);
                      (o = !1), (s = qe), (l = new Yn());
                    } else l = e ? [] : a;
                    t: for (; ++r < i; ) {
                      var c = t[r],
                        f = e ? e(c) : c;
                      if (((c = n || 0 !== c ? c : 0), o && f == f)) {
                        for (var h = l.length; h--; ) if (l[h] === f) continue t;
                        e && l.push(f), a.push(c);
                      } else s(l, f, n) || (l !== a && l.push(f), a.push(c));
                    }
                    return a;
                  }
                  function ls(t, e) {
                    return null == (t = Oi(t, (e = ps(e, t)))) || delete t[Fi(Xi(e))];
                  }
                  function us(t, e, n, r) {
                    return Zr(t, e, n(br(t, e)), r);
                  }
                  function cs(t, e, n, r) {
                    for (var s = t.length, i = r ? s : -1; (r ? i-- : ++i < s) && e(t[i], i, t); );
                    return n ? ts(t, r ? 0 : i, r ? i + 1 : s) : ts(t, r ? i + 1 : 0, r ? s : i);
                  }
                  function fs(t, e) {
                    var n = t;
                    return (
                      n instanceof Rn && (n = n.value()),
                      Ie(
                        e,
                        function (t, e) {
                          return e.func.apply(e.thisArg, De([t], e.args));
                        },
                        n,
                      )
                    );
                  }
                  function hs(t, e, n) {
                    var s = t.length;
                    if (s < 2) return s ? as(t[0]) : [];
                    for (var i = -1, o = r(s); ++i < s; )
                      for (var a = t[i], l = -1; ++l < s; ) l != i && (o[i] = ur(o[i] || a, t[l], e, n));
                    return as(gr(o, 1), e, n);
                  }
                  function ds(t, e, n) {
                    for (var r = -1, i = t.length, o = e.length, a = {}; ++r < i; ) {
                      var l = r < o ? e[r] : s;
                      n(a, t[r], l);
                    }
                    return a;
                  }
                  function _s(t) {
                    return Yo(t) ? t : [];
                  }
                  function gs(t) {
                    return 'function' == typeof t ? t : nl;
                  }
                  function ps(t, e) {
                    return Uo(t) ? t : mi(t, e) ? [t] : Mi(ma(t));
                  }
                  var ms = Kr;
                  function vs(t, e, n) {
                    var r = t.length;
                    return (n = n === s ? r : n), !e && n >= r ? t : ts(t, e, n);
                  }
                  var ys =
                    oe ||
                    function (t) {
                      return fe.clearTimeout(t);
                    };
                  function Cs(t, e) {
                    if (e) return t.slice();
                    var n = t.length,
                      r = Ut ? Ut(n) : new t.constructor(n);
                    return t.copy(r), r;
                  }
                  function bs(t) {
                    var e = new t.constructor(t.byteLength);
                    return new Rt(e).set(new Rt(t)), e;
                  }
                  function xs(t, e) {
                    var n = e ? bs(t.buffer) : t.buffer;
                    return new t.constructor(n, t.byteOffset, t.length);
                  }
                  function Ts(t, e) {
                    if (t !== e) {
                      var n = t !== s,
                        r = null === t,
                        i = t == t,
                        o = aa(t),
                        a = e !== s,
                        l = null === e,
                        u = e == e,
                        c = aa(e);
                      if ((!l && !c && !o && t > e) || (o && a && u && !l && !c) || (r && a && u) || (!n && u) || !i)
                        return 1;
                      if ((!r && !o && !c && t < e) || (c && n && i && !r && !o) || (l && n && i) || (!a && i) || !u)
                        return -1;
                    }
                    return 0;
                  }
                  function Os(t, e, n, s) {
                    for (
                      var i = -1,
                        o = t.length,
                        a = n.length,
                        l = -1,
                        u = e.length,
                        c = pn(o - a, 0),
                        f = r(u + c),
                        h = !s;
                      ++l < u;

                    )
                      f[l] = e[l];
                    for (; ++i < a; ) (h || i < o) && (f[n[i]] = t[i]);
                    for (; c--; ) f[l++] = t[i++];
                    return f;
                  }
                  function Ss(t, e, n, s) {
                    for (
                      var i = -1,
                        o = t.length,
                        a = -1,
                        l = n.length,
                        u = -1,
                        c = e.length,
                        f = pn(o - l, 0),
                        h = r(f + c),
                        d = !s;
                      ++i < f;

                    )
                      h[i] = t[i];
                    for (var _ = i; ++u < c; ) h[_ + u] = e[u];
                    for (; ++a < l; ) (d || i < o) && (h[_ + n[a]] = t[i++]);
                    return h;
                  }
                  function ws(t, e) {
                    var n = -1,
                      s = t.length;
                    for (e || (e = r(s)); ++n < s; ) e[n] = t[n];
                    return e;
                  }
                  function As(t, e, n, r) {
                    var i = !n;
                    n || (n = {});
                    for (var o = -1, a = e.length; ++o < a; ) {
                      var l = e[o],
                        u = r ? r(n[l], t[l], l, n, t) : s;
                      u === s && (u = t[l]), i ? rr(n, l, u) : Qn(n, l, u);
                    }
                    return n;
                  }
                  function Ls(t, e) {
                    return function (n, r) {
                      var s = Uo(n) ? Oe : er,
                        i = e ? e() : {};
                      return s(n, t, ii(r, 2), i);
                    };
                  }
                  function Es(t) {
                    return Kr(function (e, n) {
                      var r = -1,
                        i = n.length,
                        o = i > 1 ? n[i - 1] : s,
                        a = i > 2 ? n[2] : s;
                      for (
                        o = t.length > 3 && 'function' == typeof o ? (i--, o) : s,
                          a && pi(n[0], n[1], a) && ((o = i < 3 ? s : o), (i = 1)),
                          e = Ot(e);
                        ++r < i;

                      ) {
                        var l = n[r];
                        l && t(e, l, r, o);
                      }
                      return e;
                    });
                  }
                  function Ps(t, e) {
                    return function (n, r) {
                      if (null == n) return n;
                      if (!$o(n)) return t(n, r);
                      for (var s = n.length, i = e ? s : -1, o = Ot(n); (e ? i-- : ++i < s) && !1 !== r(o[i], i, o); );
                      return n;
                    };
                  }
                  function ks(t) {
                    return function (e, n, r) {
                      for (var s = -1, i = Ot(e), o = r(e), a = o.length; a--; ) {
                        var l = o[t ? a : ++s];
                        if (!1 === n(i[l], l, i)) break;
                      }
                      return e;
                    };
                  }
                  function Ds(t) {
                    return function (e) {
                      var n = rn((e = ma(e))) ? fn(e) : s,
                        r = n ? n[0] : e.charAt(0),
                        i = n ? vs(n, 1).join('') : e.slice(1);
                      return r[t]() + i;
                    };
                  }
                  function Is(t) {
                    return function (e) {
                      return Ie(Za(Ra(e).replace(Zt, '')), t, '');
                    };
                  }
                  function Ms(t) {
                    return function () {
                      var e = arguments;
                      switch (e.length) {
                        case 0:
                          return new t();
                        case 1:
                          return new t(e[0]);
                        case 2:
                          return new t(e[0], e[1]);
                        case 3:
                          return new t(e[0], e[1], e[2]);
                        case 4:
                          return new t(e[0], e[1], e[2], e[3]);
                        case 5:
                          return new t(e[0], e[1], e[2], e[3], e[4]);
                        case 6:
                          return new t(e[0], e[1], e[2], e[3], e[4], e[5]);
                        case 7:
                          return new t(e[0], e[1], e[2], e[3], e[4], e[5], e[6]);
                      }
                      var n = zn(t.prototype),
                        r = t.apply(n, e);
                      return Qo(r) ? r : n;
                    };
                  }
                  function Fs(t) {
                    return function (e, n, r) {
                      var i = Ot(e);
                      if (!$o(e)) {
                        var o = ii(n, 3);
                        (e = Pa(e)),
                          (n = function (t) {
                            return o(i[t], t, i);
                          });
                      }
                      var a = t(e, n, r);
                      return a > -1 ? i[o ? e[a] : a] : s;
                    };
                  }
                  function Ws(t) {
                    return Qs(function (e) {
                      var n = e.length,
                        r = n,
                        o = Hn.prototype.thru;
                      for (t && e.reverse(); r--; ) {
                        var a = e[r];
                        if ('function' != typeof a) throw new At(i);
                        if (o && !l && 'wrapper' == ri(a)) var l = new Hn([], !0);
                      }
                      for (r = l ? r : n; ++r < n; ) {
                        var u = ri((a = e[r])),
                          c = 'wrapper' == u ? ni(a) : s;
                        l =
                          c && vi(c[0]) && 424 == c[1] && !c[4].length && 1 == c[9]
                            ? l[ri(c[0])].apply(l, c[3])
                            : 1 == a.length && vi(a)
                              ? l[u]()
                              : l.thru(a);
                      }
                      return function () {
                        var t = arguments,
                          r = t[0];
                        if (l && 1 == t.length && Uo(r)) return l.plant(r).value();
                        for (var s = 0, i = n ? e[s].apply(this, t) : r; ++s < n; ) i = e[s].call(this, i);
                        return i;
                      };
                    });
                  }
                  function Ns(t, e, n, i, o, a, l, c, f, h) {
                    var d = e & u,
                      _ = 1 & e,
                      g = 2 & e,
                      p = 24 & e,
                      m = 512 & e,
                      v = g ? s : Ms(t);
                    return function u() {
                      for (var y = arguments.length, C = r(y), b = y; b--; ) C[b] = arguments[b];
                      if (p)
                        var x = si(u),
                          T = (function (t, e) {
                            for (var n = t.length, r = 0; n--; ) t[n] === e && ++r;
                            return r;
                          })(C, x);
                      if ((i && (C = Os(C, i, o, p)), a && (C = Ss(C, a, l, p)), (y -= T), p && y < h)) {
                        var O = an(C, x);
                        return Vs(t, e, Ns, u.placeholder, n, C, O, c, f, h - y);
                      }
                      var S = _ ? n : this,
                        w = g ? S[t] : t;
                      return (
                        (y = C.length),
                        c
                          ? (C = (function (t, e) {
                              for (var n = t.length, r = mn(e.length, n), i = ws(t); r--; ) {
                                var o = e[r];
                                t[r] = gi(o, n) ? i[o] : s;
                              }
                              return t;
                            })(C, c))
                          : m && y > 1 && C.reverse(),
                        d && f < y && (C.length = f),
                        this && this !== fe && this instanceof u && (w = v || Ms(w)),
                        w.apply(S, C)
                      );
                    };
                  }
                  function js(t, e) {
                    return function (n, r) {
                      return (function (t, e, n, r) {
                        return (
                          vr(t, function (t, s, i) {
                            e(r, n(t), s, i);
                          }),
                          r
                        );
                      })(n, t, e(r), {});
                    };
                  }
                  function zs(t, e) {
                    return function (n, r) {
                      var i;
                      if (n === s && r === s) return e;
                      if ((n !== s && (i = n), r !== s)) {
                        if (i === s) return r;
                        'string' == typeof n || 'string' == typeof r
                          ? ((n = os(n)), (r = os(r)))
                          : ((n = is(n)), (r = is(r))),
                          (i = t(n, r));
                      }
                      return i;
                    };
                  }
                  function Bs(t) {
                    return Qs(function (e) {
                      return (
                        (e = ke(e, Ge(ii()))),
                        Kr(function (n) {
                          var r = this;
                          return t(e, function (t) {
                            return Te(t, r, n);
                          });
                        })
                      );
                    });
                  }
                  function Hs(t, e) {
                    var n = (e = e === s ? ' ' : os(e)).length;
                    if (n < 2) return n ? Yr(e, t) : e;
                    var r = Yr(e, he(t / cn(e)));
                    return rn(e) ? vs(fn(r), 0, t).join('') : r.slice(0, t);
                  }
                  function Rs(t) {
                    return function (e, n, i) {
                      return (
                        i && 'number' != typeof i && pi(e, n, i) && (n = i = s),
                        (e = ha(e)),
                        n === s ? ((n = e), (e = 0)) : (n = ha(n)),
                        (function (t, e, n, s) {
                          for (var i = -1, o = pn(he((e - t) / (n || 1)), 0), a = r(o); o--; )
                            (a[s ? o : ++i] = t), (t += n);
                          return a;
                        })(e, n, (i = i === s ? (e < n ? 1 : -1) : ha(i)), t)
                      );
                    };
                  }
                  function Us(t) {
                    return function (e, n) {
                      return ('string' == typeof e && 'string' == typeof n) || ((e = ga(e)), (n = ga(n))), t(e, n);
                    };
                  }
                  function Vs(t, e, n, r, i, o, a, u, c, f) {
                    var h = 8 & e;
                    (e |= h ? l : 64), 4 & (e &= ~(h ? 64 : l)) || (e &= -4);
                    var d = [t, e, i, h ? o : s, h ? a : s, h ? s : o, h ? s : a, u, c, f],
                      _ = n.apply(s, d);
                    return vi(t) && wi(_, d), (_.placeholder = r), Ei(_, t, e);
                  }
                  function $s(t) {
                    var e = Tt[t];
                    return function (t, n) {
                      if (((t = ga(t)), (n = null == n ? 0 : mn(da(n), 292)) && We(t))) {
                        var r = (ma(t) + 'e').split('e');
                        return +((r = (ma(e(r[0] + 'e' + (+r[1] + n))) + 'e').split('e'))[0] + 'e' + (+r[1] - n));
                      }
                      return e(t);
                    };
                  }
                  var Ys =
                    Sn && 1 / ln(new Sn([, -0]))[1] == c
                      ? function (t) {
                          return new Sn(t);
                        }
                      : al;
                  function Ks(t) {
                    return function (e) {
                      var n = fi(e);
                      return n == x
                        ? sn(e)
                        : n == A
                          ? un(e)
                          : (function (t, e) {
                              return ke(e, function (e) {
                                return [e, t[e]];
                              });
                            })(e, t(e));
                    };
                  }
                  function Xs(t, e, n, o, c, f, h, d) {
                    var _ = 2 & e;
                    if (!_ && 'function' != typeof t) throw new At(i);
                    var g = o ? o.length : 0;
                    if (
                      (g || ((e &= -97), (o = c = s)),
                      (h = h === s ? h : pn(da(h), 0)),
                      (d = d === s ? d : da(d)),
                      (g -= c ? c.length : 0),
                      64 & e)
                    ) {
                      var p = o,
                        m = c;
                      o = c = s;
                    }
                    var v = _ ? s : ni(t),
                      y = [t, e, n, o, c, p, m, f, h, d];
                    if (
                      (v &&
                        (function (t, e) {
                          var n = t[1],
                            r = e[1],
                            s = n | r,
                            i = s < 131,
                            o =
                              (r == u && 8 == n) ||
                              (r == u && 256 == n && t[7].length <= e[8]) ||
                              (384 == r && e[7].length <= e[8] && 8 == n);
                          if (!i && !o) return t;
                          1 & r && ((t[2] = e[2]), (s |= 1 & n ? 0 : 4));
                          var l = e[3];
                          if (l) {
                            var c = t[3];
                            (t[3] = c ? Os(c, l, e[4]) : l), (t[4] = c ? an(t[3], a) : e[4]);
                          }
                          (l = e[5]) && ((c = t[5]), (t[5] = c ? Ss(c, l, e[6]) : l), (t[6] = c ? an(t[5], a) : e[6])),
                            (l = e[7]) && (t[7] = l),
                            r & u && (t[8] = null == t[8] ? e[8] : mn(t[8], e[8])),
                            null == t[9] && (t[9] = e[9]),
                            (t[0] = e[0]),
                            (t[1] = s);
                        })(y, v),
                      (t = y[0]),
                      (e = y[1]),
                      (n = y[2]),
                      (o = y[3]),
                      (c = y[4]),
                      !(d = y[9] = y[9] === s ? (_ ? 0 : t.length) : pn(y[9] - g, 0)) && 24 & e && (e &= -25),
                      e && 1 != e)
                    )
                      C =
                        8 == e || 16 == e
                          ? (function (t, e, n) {
                              var i = Ms(t);
                              return function o() {
                                for (var a = arguments.length, l = r(a), u = a, c = si(o); u--; ) l[u] = arguments[u];
                                var f = a < 3 && l[0] !== c && l[a - 1] !== c ? [] : an(l, c);
                                return (a -= f.length) < n
                                  ? Vs(t, e, Ns, o.placeholder, s, l, f, s, s, n - a)
                                  : Te(this && this !== fe && this instanceof o ? i : t, this, l);
                              };
                            })(t, e, d)
                          : (e != l && 33 != e) || c.length
                            ? Ns.apply(s, y)
                            : (function (t, e, n, s) {
                                var i = 1 & e,
                                  o = Ms(t);
                                return function e() {
                                  for (
                                    var a = -1,
                                      l = arguments.length,
                                      u = -1,
                                      c = s.length,
                                      f = r(c + l),
                                      h = this && this !== fe && this instanceof e ? o : t;
                                    ++u < c;

                                  )
                                    f[u] = s[u];
                                  for (; l--; ) f[u++] = arguments[++a];
                                  return Te(h, i ? n : this, f);
                                };
                              })(t, e, n, o);
                    else
                      var C = (function (t, e, n) {
                        var r = 1 & e,
                          s = Ms(t);
                        return function e() {
                          return (this && this !== fe && this instanceof e ? s : t).apply(r ? n : this, arguments);
                        };
                      })(t, e, n);
                    return Ei((v ? qr : wi)(C, y), t, e);
                  }
                  function Gs(t, e, n, r) {
                    return t === s || (zo(t, Pt[n]) && !It.call(r, n)) ? e : t;
                  }
                  function Zs(t, e, n, r, i, o) {
                    return Qo(t) && Qo(e) && (o.set(e, t), zr(t, e, s, Zs, o), o.delete(e)), t;
                  }
                  function qs(t) {
                    return ra(t) ? s : t;
                  }
                  function Js(t, e, n, r, i, o) {
                    var a = 1 & n,
                      l = t.length,
                      u = e.length;
                    if (l != u && !(a && u > l)) return !1;
                    var c = o.get(t),
                      f = o.get(e);
                    if (c && f) return c == e && f == t;
                    var h = -1,
                      d = !0,
                      _ = 2 & n ? new Yn() : s;
                    for (o.set(t, e), o.set(e, t); ++h < l; ) {
                      var g = t[h],
                        p = e[h];
                      if (r) var m = a ? r(p, g, h, e, t, o) : r(g, p, h, t, e, o);
                      if (m !== s) {
                        if (m) continue;
                        d = !1;
                        break;
                      }
                      if (_) {
                        if (
                          !Fe(e, function (t, e) {
                            if (!qe(_, e) && (g === t || i(g, t, n, r, o))) return _.push(e);
                          })
                        ) {
                          d = !1;
                          break;
                        }
                      } else if (g !== p && !i(g, p, n, r, o)) {
                        d = !1;
                        break;
                      }
                    }
                    return o.delete(t), o.delete(e), d;
                  }
                  function Qs(t) {
                    return Li(Ti(t, s, Ui), t + '');
                  }
                  function ti(t) {
                    return xr(t, Pa, ui);
                  }
                  function ei(t) {
                    return xr(t, ka, ci);
                  }
                  var ni = Ln
                    ? function (t) {
                        return Ln.get(t);
                      }
                    : al;
                  function ri(t) {
                    for (var e = t.name + '', n = En[e], r = It.call(En, e) ? n.length : 0; r--; ) {
                      var s = n[r],
                        i = s.func;
                      if (null == i || i == t) return s.name;
                    }
                    return e;
                  }
                  function si(t) {
                    return (It.call(jn, 'placeholder') ? jn : t).placeholder;
                  }
                  function ii() {
                    var t = jn.iteratee || rl;
                    return (t = t === rl ? Ir : t), arguments.length ? t(arguments[0], arguments[1]) : t;
                  }
                  function oi(t, e) {
                    var n,
                      r,
                      s = t.__data__;
                    return (
                      'string' == (r = typeof (n = e)) || 'number' == r || 'symbol' == r || 'boolean' == r
                        ? '__proto__' !== n
                        : null === n
                    )
                      ? s['string' == typeof e ? 'string' : 'hash']
                      : s.map;
                  }
                  function ai(t) {
                    for (var e = Pa(t), n = e.length; n--; ) {
                      var r = e[n],
                        s = t[r];
                      e[n] = [r, s, bi(s)];
                    }
                    return e;
                  }
                  function li(t, e) {
                    var n = (function (t, e) {
                      return null == t ? s : t[e];
                    })(t, e);
                    return Dr(n) ? n : s;
                  }
                  var ui = ge
                      ? function (t) {
                          return null == t
                            ? []
                            : ((t = Ot(t)),
                              Le(ge(t), function (e) {
                                return Yt.call(t, e);
                              }));
                        }
                      : _l,
                    ci = ge
                      ? function (t) {
                          for (var e = []; t; ) De(e, ui(t)), (t = Vt(t));
                          return e;
                        }
                      : _l,
                    fi = Tr;
                  function hi(t, e, n) {
                    for (var r = -1, s = (e = ps(e, t)).length, i = !1; ++r < s; ) {
                      var o = Fi(e[r]);
                      if (!(i = null != t && n(t, o))) break;
                      t = t[o];
                    }
                    return i || ++r != s
                      ? i
                      : !!(s = null == t ? 0 : t.length) && Jo(s) && gi(o, s) && (Uo(t) || Ro(t));
                  }
                  function di(t) {
                    return 'function' != typeof t.constructor || Ci(t) ? {} : zn(Vt(t));
                  }
                  function _i(t) {
                    return Uo(t) || Ro(t) || !!(Xt && t && t[Xt]);
                  }
                  function gi(t, e) {
                    var n = typeof t;
                    return (
                      !!(e = null == e ? f : e) &&
                      ('number' == n || ('symbol' != n && mt.test(t))) &&
                      t > -1 &&
                      t % 1 == 0 &&
                      t < e
                    );
                  }
                  function pi(t, e, n) {
                    if (!Qo(n)) return !1;
                    var r = typeof e;
                    return !!('number' == r ? $o(n) && gi(e, n.length) : 'string' == r && e in n) && zo(n[e], t);
                  }
                  function mi(t, e) {
                    if (Uo(t)) return !1;
                    var n = typeof t;
                    return (
                      !('number' != n && 'symbol' != n && 'boolean' != n && null != t && !aa(t)) ||
                      Q.test(t) ||
                      !J.test(t) ||
                      (null != e && t in Ot(e))
                    );
                  }
                  function vi(t) {
                    var e = ri(t),
                      n = jn[e];
                    if ('function' != typeof n || !(e in Rn.prototype)) return !1;
                    if (t === n) return !0;
                    var r = ni(n);
                    return !!r && t === r[0];
                  }
                  ((xn && fi(new xn(new ArrayBuffer(1))) != D) ||
                    (Tn && fi(new Tn()) != x) ||
                    (On && fi(On.resolve()) != S) ||
                    (Sn && fi(new Sn()) != A) ||
                    (wn && fi(new wn()) != P)) &&
                    (fi = function (t) {
                      var e = Tr(t),
                        n = e == O ? t.constructor : s,
                        r = n ? Wi(n) : '';
                      if (r)
                        switch (r) {
                          case Pn:
                            return D;
                          case kn:
                            return x;
                          case Dn:
                            return S;
                          case In:
                            return A;
                          case Mn:
                            return P;
                        }
                      return e;
                    });
                  var yi = kt ? Zo : gl;
                  function Ci(t) {
                    var e = t && t.constructor;
                    return t === (('function' == typeof e && e.prototype) || Pt);
                  }
                  function bi(t) {
                    return t == t && !Qo(t);
                  }
                  function xi(t, e) {
                    return function (n) {
                      return null != n && n[t] === e && (e !== s || t in Ot(n));
                    };
                  }
                  function Ti(t, e, n) {
                    return (
                      (e = pn(e === s ? t.length - 1 : e, 0)),
                      function () {
                        for (var s = arguments, i = -1, o = pn(s.length - e, 0), a = r(o); ++i < o; ) a[i] = s[e + i];
                        i = -1;
                        for (var l = r(e + 1); ++i < e; ) l[i] = s[i];
                        return (l[e] = n(a)), Te(t, this, l);
                      }
                    );
                  }
                  function Oi(t, e) {
                    return e.length < 2 ? t : br(t, ts(e, 0, -1));
                  }
                  function Si(t, e) {
                    if (('constructor' !== e || 'function' != typeof t[e]) && '__proto__' != e) return t[e];
                  }
                  var wi = Pi(qr),
                    Ai =
                      ce ||
                      function (t, e) {
                        return fe.setTimeout(t, e);
                      },
                    Li = Pi(Jr);
                  function Ei(t, e, n) {
                    var r = e + '';
                    return Li(
                      t,
                      (function (t, e) {
                        var n = e.length;
                        if (!n) return t;
                        var r = n - 1;
                        return (
                          (e[r] = (n > 1 ? '& ' : '') + e[r]),
                          (e = e.join(n > 2 ? ', ' : ' ')),
                          t.replace(it, '{\n/* [wrapped with ' + e + '] */\n')
                        );
                      })(
                        r,
                        (function (t, e) {
                          return (
                            Se(_, function (n) {
                              var r = '_.' + n[0];
                              e & n[1] && !Ee(t, r) && t.push(r);
                            }),
                            t.sort()
                          );
                        })(
                          (function (t) {
                            var e = t.match(ot);
                            return e ? e[1].split(at) : [];
                          })(r),
                          n,
                        ),
                      ),
                    );
                  }
                  function Pi(t) {
                    var e = 0,
                      n = 0;
                    return function () {
                      var r = vn(),
                        i = 16 - (r - n);
                      if (((n = r), i > 0)) {
                        if (++e >= 800) return arguments[0];
                      } else e = 0;
                      return t.apply(s, arguments);
                    };
                  }
                  function ki(t, e) {
                    var n = -1,
                      r = t.length,
                      i = r - 1;
                    for (e = e === s ? r : e; ++n < e; ) {
                      var o = $r(n, i),
                        a = t[o];
                      (t[o] = t[n]), (t[n] = a);
                    }
                    return (t.length = e), t;
                  }
                  var Di,
                    Ii,
                    Mi =
                      ((Di = Io(
                        function (t) {
                          var e = [];
                          return (
                            46 === t.charCodeAt(0) && e.push(''),
                            t.replace(tt, function (t, n, r, s) {
                              e.push(r ? s.replace(ct, '$1') : n || t);
                            }),
                            e
                          );
                        },
                        function (t) {
                          return 500 === Ii.size && Ii.clear(), t;
                        },
                      )),
                      (Ii = Di.cache),
                      Di);
                  function Fi(t) {
                    if ('string' == typeof t || aa(t)) return t;
                    var e = t + '';
                    return '0' == e && 1 / t == -1 / 0 ? '-0' : e;
                  }
                  function Wi(t) {
                    if (null != t) {
                      try {
                        return Dt.call(t);
                      } catch (t) {}
                      try {
                        return t + '';
                      } catch (t) {}
                    }
                    return '';
                  }
                  function Ni(t) {
                    if (t instanceof Rn) return t.clone();
                    var e = new Hn(t.__wrapped__, t.__chain__);
                    return (
                      (e.__actions__ = ws(t.__actions__)), (e.__index__ = t.__index__), (e.__values__ = t.__values__), e
                    );
                  }
                  var ji = Kr(function (t, e) {
                      return Yo(t) ? ur(t, gr(e, 1, Yo, !0)) : [];
                    }),
                    zi = Kr(function (t, e) {
                      var n = Xi(e);
                      return Yo(n) && (n = s), Yo(t) ? ur(t, gr(e, 1, Yo, !0), ii(n, 2)) : [];
                    }),
                    Bi = Kr(function (t, e) {
                      var n = Xi(e);
                      return Yo(n) && (n = s), Yo(t) ? ur(t, gr(e, 1, Yo, !0), s, n) : [];
                    });
                  function Hi(t, e, n) {
                    var r = null == t ? 0 : t.length;
                    if (!r) return -1;
                    var s = null == n ? 0 : da(n);
                    return s < 0 && (s = pn(r + s, 0)), je(t, ii(e, 3), s);
                  }
                  function Ri(t, e, n) {
                    var r = null == t ? 0 : t.length;
                    if (!r) return -1;
                    var i = r - 1;
                    return n !== s && ((i = da(n)), (i = n < 0 ? pn(r + i, 0) : mn(i, r - 1))), je(t, ii(e, 3), i, !0);
                  }
                  function Ui(t) {
                    return null != t && t.length ? gr(t, 1) : [];
                  }
                  function Vi(t) {
                    return t && t.length ? t[0] : s;
                  }
                  var $i = Kr(function (t) {
                      var e = ke(t, _s);
                      return e.length && e[0] === t[0] ? Ar(e) : [];
                    }),
                    Yi = Kr(function (t) {
                      var e = Xi(t),
                        n = ke(t, _s);
                      return e === Xi(n) ? (e = s) : n.pop(), n.length && n[0] === t[0] ? Ar(n, ii(e, 2)) : [];
                    }),
                    Ki = Kr(function (t) {
                      var e = Xi(t),
                        n = ke(t, _s);
                      return (
                        (e = 'function' == typeof e ? e : s) && n.pop(), n.length && n[0] === t[0] ? Ar(n, s, e) : []
                      );
                    });
                  function Xi(t) {
                    var e = null == t ? 0 : t.length;
                    return e ? t[e - 1] : s;
                  }
                  var Gi = Kr(Zi);
                  function Zi(t, e) {
                    return t && t.length && e && e.length ? Ur(t, e) : t;
                  }
                  var qi = Qs(function (t, e) {
                    var n = null == t ? 0 : t.length,
                      r = sr(t, e);
                    return (
                      Vr(
                        t,
                        ke(e, function (t) {
                          return gi(t, n) ? +t : t;
                        }).sort(Ts),
                      ),
                      r
                    );
                  });
                  function Ji(t) {
                    return null == t ? t : bn.call(t);
                  }
                  var Qi = Kr(function (t) {
                      return as(gr(t, 1, Yo, !0));
                    }),
                    to = Kr(function (t) {
                      var e = Xi(t);
                      return Yo(e) && (e = s), as(gr(t, 1, Yo, !0), ii(e, 2));
                    }),
                    eo = Kr(function (t) {
                      var e = Xi(t);
                      return (e = 'function' == typeof e ? e : s), as(gr(t, 1, Yo, !0), s, e);
                    });
                  function no(t) {
                    if (!t || !t.length) return [];
                    var e = 0;
                    return (
                      (t = Le(t, function (t) {
                        if (Yo(t)) return (e = pn(t.length, e)), !0;
                      })),
                      Ke(e, function (e) {
                        return ke(t, Ue(e));
                      })
                    );
                  }
                  function ro(t, e) {
                    if (!t || !t.length) return [];
                    var n = no(t);
                    return null == e
                      ? n
                      : ke(n, function (t) {
                          return Te(e, s, t);
                        });
                  }
                  var so = Kr(function (t, e) {
                      return Yo(t) ? ur(t, e) : [];
                    }),
                    io = Kr(function (t) {
                      return hs(Le(t, Yo));
                    }),
                    oo = Kr(function (t) {
                      var e = Xi(t);
                      return Yo(e) && (e = s), hs(Le(t, Yo), ii(e, 2));
                    }),
                    ao = Kr(function (t) {
                      var e = Xi(t);
                      return (e = 'function' == typeof e ? e : s), hs(Le(t, Yo), s, e);
                    }),
                    lo = Kr(no),
                    uo = Kr(function (t) {
                      var e = t.length,
                        n = e > 1 ? t[e - 1] : s;
                      return (n = 'function' == typeof n ? (t.pop(), n) : s), ro(t, n);
                    });
                  function co(t) {
                    var e = jn(t);
                    return (e.__chain__ = !0), e;
                  }
                  function fo(t, e) {
                    return e(t);
                  }
                  var ho = Qs(function (t) {
                      var e = t.length,
                        n = e ? t[0] : 0,
                        r = this.__wrapped__,
                        i = function (e) {
                          return sr(e, t);
                        };
                      return !(e > 1 || this.__actions__.length) && r instanceof Rn && gi(n)
                        ? ((r = r.slice(n, +n + (e ? 1 : 0))).__actions__.push({ func: fo, args: [i], thisArg: s }),
                          new Hn(r, this.__chain__).thru(function (t) {
                            return e && !t.length && t.push(s), t;
                          }))
                        : this.thru(i);
                    }),
                    _o = Ls(function (t, e, n) {
                      It.call(t, n) ? ++t[n] : rr(t, n, 1);
                    }),
                    go = Fs(Hi),
                    po = Fs(Ri);
                  function mo(t, e) {
                    return (Uo(t) ? Se : cr)(t, ii(e, 3));
                  }
                  function vo(t, e) {
                    return (Uo(t) ? we : fr)(t, ii(e, 3));
                  }
                  var yo = Ls(function (t, e, n) {
                      It.call(t, n) ? t[n].push(e) : rr(t, n, [e]);
                    }),
                    Co = Kr(function (t, e, n) {
                      var s = -1,
                        i = 'function' == typeof e,
                        o = $o(t) ? r(t.length) : [];
                      return (
                        cr(t, function (t) {
                          o[++s] = i ? Te(e, t, n) : Lr(t, e, n);
                        }),
                        o
                      );
                    }),
                    bo = Ls(function (t, e, n) {
                      rr(t, n, e);
                    });
                  function xo(t, e) {
                    return (Uo(t) ? ke : Wr)(t, ii(e, 3));
                  }
                  var To = Ls(
                      function (t, e, n) {
                        t[n ? 0 : 1].push(e);
                      },
                      function () {
                        return [[], []];
                      },
                    ),
                    Oo = Kr(function (t, e) {
                      if (null == t) return [];
                      var n = e.length;
                      return (
                        n > 1 && pi(t, e[0], e[1]) ? (e = []) : n > 2 && pi(e[0], e[1], e[2]) && (e = [e[0]]),
                        Hr(t, gr(e, 1), [])
                      );
                    }),
                    So =
                      ue ||
                      function () {
                        return fe.Date.now();
                      };
                  function wo(t, e, n) {
                    return (e = n ? s : e), (e = t && null == e ? t.length : e), Xs(t, u, s, s, s, s, e);
                  }
                  function Ao(t, e) {
                    var n;
                    if ('function' != typeof e) throw new At(i);
                    return (
                      (t = da(t)),
                      function () {
                        return --t > 0 && (n = e.apply(this, arguments)), t <= 1 && (e = s), n;
                      }
                    );
                  }
                  var Lo = Kr(function (t, e, n) {
                      var r = 1;
                      if (n.length) {
                        var s = an(n, si(Lo));
                        r |= l;
                      }
                      return Xs(t, r, e, n, s);
                    }),
                    Eo = Kr(function (t, e, n) {
                      var r = 3;
                      if (n.length) {
                        var s = an(n, si(Eo));
                        r |= l;
                      }
                      return Xs(e, r, t, n, s);
                    });
                  function Po(t, e, n) {
                    var r,
                      o,
                      a,
                      l,
                      u,
                      c,
                      f = 0,
                      h = !1,
                      d = !1,
                      _ = !0;
                    if ('function' != typeof t) throw new At(i);
                    function g(e) {
                      var n = r,
                        i = o;
                      return (r = o = s), (f = e), (l = t.apply(i, n));
                    }
                    function p(t) {
                      var n = t - c;
                      return c === s || n >= e || n < 0 || (d && t - f >= a);
                    }
                    function m() {
                      var t = So();
                      if (p(t)) return v(t);
                      u = Ai(
                        m,
                        (function (t) {
                          var n = e - (t - c);
                          return d ? mn(n, a - (t - f)) : n;
                        })(t),
                      );
                    }
                    function v(t) {
                      return (u = s), _ && r ? g(t) : ((r = o = s), l);
                    }
                    function y() {
                      var t = So(),
                        n = p(t);
                      if (((r = arguments), (o = this), (c = t), n)) {
                        if (u === s)
                          return (function (t) {
                            return (f = t), (u = Ai(m, e)), h ? g(t) : l;
                          })(c);
                        if (d) return ys(u), (u = Ai(m, e)), g(c);
                      }
                      return u === s && (u = Ai(m, e)), l;
                    }
                    return (
                      (e = ga(e) || 0),
                      Qo(n) &&
                        ((h = !!n.leading),
                        (a = (d = 'maxWait' in n) ? pn(ga(n.maxWait) || 0, e) : a),
                        (_ = 'trailing' in n ? !!n.trailing : _)),
                      (y.cancel = function () {
                        u !== s && ys(u), (f = 0), (r = c = o = u = s);
                      }),
                      (y.flush = function () {
                        return u === s ? l : v(So());
                      }),
                      y
                    );
                  }
                  var ko = Kr(function (t, e) {
                      return lr(t, 1, e);
                    }),
                    Do = Kr(function (t, e, n) {
                      return lr(t, ga(e) || 0, n);
                    });
                  function Io(t, e) {
                    if ('function' != typeof t || (null != e && 'function' != typeof e)) throw new At(i);
                    var n = function () {
                      var r = arguments,
                        s = e ? e.apply(this, r) : r[0],
                        i = n.cache;
                      if (i.has(s)) return i.get(s);
                      var o = t.apply(this, r);
                      return (n.cache = i.set(s, o) || i), o;
                    };
                    return (n.cache = new (Io.Cache || $n)()), n;
                  }
                  function Mo(t) {
                    if ('function' != typeof t) throw new At(i);
                    return function () {
                      var e = arguments;
                      switch (e.length) {
                        case 0:
                          return !t.call(this);
                        case 1:
                          return !t.call(this, e[0]);
                        case 2:
                          return !t.call(this, e[0], e[1]);
                        case 3:
                          return !t.call(this, e[0], e[1], e[2]);
                      }
                      return !t.apply(this, e);
                    };
                  }
                  Io.Cache = $n;
                  var Fo = ms(function (t, e) {
                      var n = (e = 1 == e.length && Uo(e[0]) ? ke(e[0], Ge(ii())) : ke(gr(e, 1), Ge(ii()))).length;
                      return Kr(function (r) {
                        for (var s = -1, i = mn(r.length, n); ++s < i; ) r[s] = e[s].call(this, r[s]);
                        return Te(t, this, r);
                      });
                    }),
                    Wo = Kr(function (t, e) {
                      var n = an(e, si(Wo));
                      return Xs(t, l, s, e, n);
                    }),
                    No = Kr(function (t, e) {
                      var n = an(e, si(No));
                      return Xs(t, 64, s, e, n);
                    }),
                    jo = Qs(function (t, e) {
                      return Xs(t, 256, s, s, s, e);
                    });
                  function zo(t, e) {
                    return t === e || (t != t && e != e);
                  }
                  var Bo = Us(Or),
                    Ho = Us(function (t, e) {
                      return t >= e;
                    }),
                    Ro = Er(
                      (function () {
                        return arguments;
                      })(),
                    )
                      ? Er
                      : function (t) {
                          return ta(t) && It.call(t, 'callee') && !Yt.call(t, 'callee');
                        },
                    Uo = r.isArray,
                    Vo = me
                      ? Ge(me)
                      : function (t) {
                          return ta(t) && Tr(t) == k;
                        };
                  function $o(t) {
                    return null != t && Jo(t.length) && !Zo(t);
                  }
                  function Yo(t) {
                    return ta(t) && $o(t);
                  }
                  var Ko = pe || gl,
                    Xo = ve
                      ? Ge(ve)
                      : function (t) {
                          return ta(t) && Tr(t) == v;
                        };
                  function Go(t) {
                    if (!ta(t)) return !1;
                    var e = Tr(t);
                    return (
                      e == y ||
                      '[object DOMException]' == e ||
                      ('string' == typeof t.message && 'string' == typeof t.name && !ra(t))
                    );
                  }
                  function Zo(t) {
                    if (!Qo(t)) return !1;
                    var e = Tr(t);
                    return e == C || e == b || '[object AsyncFunction]' == e || '[object Proxy]' == e;
                  }
                  function qo(t) {
                    return 'number' == typeof t && t == da(t);
                  }
                  function Jo(t) {
                    return 'number' == typeof t && t > -1 && t % 1 == 0 && t <= f;
                  }
                  function Qo(t) {
                    var e = typeof t;
                    return null != t && ('object' == e || 'function' == e);
                  }
                  function ta(t) {
                    return null != t && 'object' == typeof t;
                  }
                  var ea = ye
                    ? Ge(ye)
                    : function (t) {
                        return ta(t) && fi(t) == x;
                      };
                  function na(t) {
                    return 'number' == typeof t || (ta(t) && Tr(t) == T);
                  }
                  function ra(t) {
                    if (!ta(t) || Tr(t) != O) return !1;
                    var e = Vt(t);
                    if (null === e) return !0;
                    var n = It.call(e, 'constructor') && e.constructor;
                    return 'function' == typeof n && n instanceof n && Dt.call(n) == Nt;
                  }
                  var sa = Ce
                      ? Ge(Ce)
                      : function (t) {
                          return ta(t) && Tr(t) == w;
                        },
                    ia = be
                      ? Ge(be)
                      : function (t) {
                          return ta(t) && fi(t) == A;
                        };
                  function oa(t) {
                    return 'string' == typeof t || (!Uo(t) && ta(t) && Tr(t) == L);
                  }
                  function aa(t) {
                    return 'symbol' == typeof t || (ta(t) && Tr(t) == E);
                  }
                  var la = xe
                      ? Ge(xe)
                      : function (t) {
                          return ta(t) && Jo(t.length) && !!se[Tr(t)];
                        },
                    ua = Us(Fr),
                    ca = Us(function (t, e) {
                      return t <= e;
                    });
                  function fa(t) {
                    if (!t) return [];
                    if ($o(t)) return oa(t) ? fn(t) : ws(t);
                    if (Gt && t[Gt])
                      return (function (t) {
                        for (var e, n = []; !(e = t.next()).done; ) n.push(e.value);
                        return n;
                      })(t[Gt]());
                    var e = fi(t);
                    return (e == x ? sn : e == A ? ln : za)(t);
                  }
                  function ha(t) {
                    return t
                      ? (t = ga(t)) === c || t === -1 / 0
                        ? 17976931348623157e292 * (t < 0 ? -1 : 1)
                        : t == t
                          ? t
                          : 0
                      : 0 === t
                        ? t
                        : 0;
                  }
                  function da(t) {
                    var e = ha(t),
                      n = e % 1;
                    return e == e ? (n ? e - n : e) : 0;
                  }
                  function _a(t) {
                    return t ? ir(da(t), 0, d) : 0;
                  }
                  function ga(t) {
                    if ('number' == typeof t) return t;
                    if (aa(t)) return h;
                    if (Qo(t)) {
                      var e = 'function' == typeof t.valueOf ? t.valueOf() : t;
                      t = Qo(e) ? e + '' : e;
                    }
                    if ('string' != typeof t) return 0 === t ? t : +t;
                    t = Xe(t);
                    var n = _t.test(t);
                    return n || pt.test(t) ? le(t.slice(2), n ? 2 : 8) : dt.test(t) ? h : +t;
                  }
                  function pa(t) {
                    return As(t, ka(t));
                  }
                  function ma(t) {
                    return null == t ? '' : os(t);
                  }
                  var va = Es(function (t, e) {
                      if (Ci(e) || $o(e)) As(e, Pa(e), t);
                      else for (var n in e) It.call(e, n) && Qn(t, n, e[n]);
                    }),
                    ya = Es(function (t, e) {
                      As(e, ka(e), t);
                    }),
                    Ca = Es(function (t, e, n, r) {
                      As(e, ka(e), t, r);
                    }),
                    ba = Es(function (t, e, n, r) {
                      As(e, Pa(e), t, r);
                    }),
                    xa = Qs(sr),
                    Ta = Kr(function (t, e) {
                      t = Ot(t);
                      var n = -1,
                        r = e.length,
                        i = r > 2 ? e[2] : s;
                      for (i && pi(e[0], e[1], i) && (r = 1); ++n < r; )
                        for (var o = e[n], a = ka(o), l = -1, u = a.length; ++l < u; ) {
                          var c = a[l],
                            f = t[c];
                          (f === s || (zo(f, Pt[c]) && !It.call(t, c))) && (t[c] = o[c]);
                        }
                      return t;
                    }),
                    Oa = Kr(function (t) {
                      return t.push(s, Zs), Te(Ia, s, t);
                    });
                  function Sa(t, e, n) {
                    var r = null == t ? s : br(t, e);
                    return r === s ? n : r;
                  }
                  function wa(t, e) {
                    return null != t && hi(t, e, wr);
                  }
                  var Aa = js(function (t, e, n) {
                      null != e && 'function' != typeof e.toString && (e = Wt.call(e)), (t[e] = n);
                    }, Qa(nl)),
                    La = js(function (t, e, n) {
                      null != e && 'function' != typeof e.toString && (e = Wt.call(e)),
                        It.call(t, e) ? t[e].push(n) : (t[e] = [n]);
                    }, ii),
                    Ea = Kr(Lr);
                  function Pa(t) {
                    return $o(t) ? Xn(t) : Mr(t);
                  }
                  function ka(t) {
                    return $o(t)
                      ? Xn(t, !0)
                      : (function (t) {
                          if (!Qo(t))
                            return (function (t) {
                              var e = [];
                              if (null != t) for (var n in Ot(t)) e.push(n);
                              return e;
                            })(t);
                          var e = Ci(t),
                            n = [];
                          for (var r in t) ('constructor' != r || (!e && It.call(t, r))) && n.push(r);
                          return n;
                        })(t);
                  }
                  var Da = Es(function (t, e, n) {
                      zr(t, e, n);
                    }),
                    Ia = Es(function (t, e, n, r) {
                      zr(t, e, n, r);
                    }),
                    Ma = Qs(function (t, e) {
                      var n = {};
                      if (null == t) return n;
                      var r = !1;
                      (e = ke(e, function (e) {
                        return (e = ps(e, t)), r || (r = e.length > 1), e;
                      })),
                        As(t, ei(t), n),
                        r && (n = or(n, 7, qs));
                      for (var s = e.length; s--; ) ls(n, e[s]);
                      return n;
                    }),
                    Fa = Qs(function (t, e) {
                      return null == t
                        ? {}
                        : (function (t, e) {
                            return Rr(t, e, function (e, n) {
                              return wa(t, n);
                            });
                          })(t, e);
                    });
                  function Wa(t, e) {
                    if (null == t) return {};
                    var n = ke(ei(t), function (t) {
                      return [t];
                    });
                    return (
                      (e = ii(e)),
                      Rr(t, n, function (t, n) {
                        return e(t, n[0]);
                      })
                    );
                  }
                  var Na = Ks(Pa),
                    ja = Ks(ka);
                  function za(t) {
                    return null == t ? [] : Ze(t, Pa(t));
                  }
                  var Ba = Is(function (t, e, n) {
                    return (e = e.toLowerCase()), t + (n ? Ha(e) : e);
                  });
                  function Ha(t) {
                    return Ga(ma(t).toLowerCase());
                  }
                  function Ra(t) {
                    return (t = ma(t)) && t.replace(vt, tn).replace(qt, '');
                  }
                  var Ua = Is(function (t, e, n) {
                      return t + (n ? '-' : '') + e.toLowerCase();
                    }),
                    Va = Is(function (t, e, n) {
                      return t + (n ? ' ' : '') + e.toLowerCase();
                    }),
                    $a = Ds('toLowerCase'),
                    Ya = Is(function (t, e, n) {
                      return t + (n ? '_' : '') + e.toLowerCase();
                    }),
                    Ka = Is(function (t, e, n) {
                      return t + (n ? ' ' : '') + Ga(e);
                    }),
                    Xa = Is(function (t, e, n) {
                      return t + (n ? ' ' : '') + e.toUpperCase();
                    }),
                    Ga = Ds('toUpperCase');
                  function Za(t, e, n) {
                    return (
                      (t = ma(t)),
                      (e = n ? s : e) === s
                        ? (function (t) {
                            return ee.test(t);
                          })(t)
                          ? (function (t) {
                              return t.match(Qt) || [];
                            })(t)
                          : (function (t) {
                              return t.match(lt) || [];
                            })(t)
                        : t.match(e) || []
                    );
                  }
                  var qa = Kr(function (t, e) {
                      try {
                        return Te(t, s, e);
                      } catch (t) {
                        return Go(t) ? t : new bt(t);
                      }
                    }),
                    Ja = Qs(function (t, e) {
                      return (
                        Se(e, function (e) {
                          (e = Fi(e)), rr(t, e, Lo(t[e], t));
                        }),
                        t
                      );
                    });
                  function Qa(t) {
                    return function () {
                      return t;
                    };
                  }
                  var tl = Ws(),
                    el = Ws(!0);
                  function nl(t) {
                    return t;
                  }
                  function rl(t) {
                    return Ir('function' == typeof t ? t : or(t, 1));
                  }
                  var sl = Kr(function (t, e) {
                      return function (n) {
                        return Lr(n, t, e);
                      };
                    }),
                    il = Kr(function (t, e) {
                      return function (n) {
                        return Lr(t, n, e);
                      };
                    });
                  function ol(t, e, n) {
                    var r = Pa(e),
                      s = Cr(e, r);
                    null != n ||
                      (Qo(e) && (s.length || !r.length)) ||
                      ((n = e), (e = t), (t = this), (s = Cr(e, Pa(e))));
                    var i = !(Qo(n) && 'chain' in n && !n.chain),
                      o = Zo(t);
                    return (
                      Se(s, function (n) {
                        var r = e[n];
                        (t[n] = r),
                          o &&
                            (t.prototype[n] = function () {
                              var e = this.__chain__;
                              if (i || e) {
                                var n = t(this.__wrapped__);
                                return (
                                  (n.__actions__ = ws(this.__actions__)).push({ func: r, args: arguments, thisArg: t }),
                                  (n.__chain__ = e),
                                  n
                                );
                              }
                              return r.apply(t, De([this.value()], arguments));
                            });
                      }),
                      t
                    );
                  }
                  function al() {}
                  var ll = Bs(ke),
                    ul = Bs(Ae),
                    cl = Bs(Fe);
                  function fl(t) {
                    return mi(t)
                      ? Ue(Fi(t))
                      : (function (t) {
                          return function (e) {
                            return br(e, t);
                          };
                        })(t);
                  }
                  var hl = Rs(),
                    dl = Rs(!0);
                  function _l() {
                    return [];
                  }
                  function gl() {
                    return !1;
                  }
                  var pl,
                    ml = zs(function (t, e) {
                      return t + e;
                    }, 0),
                    vl = $s('ceil'),
                    yl = zs(function (t, e) {
                      return t / e;
                    }, 1),
                    Cl = $s('floor'),
                    bl = zs(function (t, e) {
                      return t * e;
                    }, 1),
                    xl = $s('round'),
                    Tl = zs(function (t, e) {
                      return t - e;
                    }, 0);
                  return (
                    (jn.after = function (t, e) {
                      if ('function' != typeof e) throw new At(i);
                      return (
                        (t = da(t)),
                        function () {
                          if (--t < 1) return e.apply(this, arguments);
                        }
                      );
                    }),
                    (jn.ary = wo),
                    (jn.assign = va),
                    (jn.assignIn = ya),
                    (jn.assignInWith = Ca),
                    (jn.assignWith = ba),
                    (jn.at = xa),
                    (jn.before = Ao),
                    (jn.bind = Lo),
                    (jn.bindAll = Ja),
                    (jn.bindKey = Eo),
                    (jn.castArray = function () {
                      if (!arguments.length) return [];
                      var t = arguments[0];
                      return Uo(t) ? t : [t];
                    }),
                    (jn.chain = co),
                    (jn.chunk = function (t, e, n) {
                      e = (n ? pi(t, e, n) : e === s) ? 1 : pn(da(e), 0);
                      var i = null == t ? 0 : t.length;
                      if (!i || e < 1) return [];
                      for (var o = 0, a = 0, l = r(he(i / e)); o < i; ) l[a++] = ts(t, o, (o += e));
                      return l;
                    }),
                    (jn.compact = function (t) {
                      for (var e = -1, n = null == t ? 0 : t.length, r = 0, s = []; ++e < n; ) {
                        var i = t[e];
                        i && (s[r++] = i);
                      }
                      return s;
                    }),
                    (jn.concat = function () {
                      var t = arguments.length;
                      if (!t) return [];
                      for (var e = r(t - 1), n = arguments[0], s = t; s--; ) e[s - 1] = arguments[s];
                      return De(Uo(n) ? ws(n) : [n], gr(e, 1));
                    }),
                    (jn.cond = function (t) {
                      var e = null == t ? 0 : t.length,
                        n = ii();
                      return (
                        (t = e
                          ? ke(t, function (t) {
                              if ('function' != typeof t[1]) throw new At(i);
                              return [n(t[0]), t[1]];
                            })
                          : []),
                        Kr(function (n) {
                          for (var r = -1; ++r < e; ) {
                            var s = t[r];
                            if (Te(s[0], this, n)) return Te(s[1], this, n);
                          }
                        })
                      );
                    }),
                    (jn.conforms = function (t) {
                      return (function (t) {
                        var e = Pa(t);
                        return function (n) {
                          return ar(n, t, e);
                        };
                      })(or(t, 1));
                    }),
                    (jn.constant = Qa),
                    (jn.countBy = _o),
                    (jn.create = function (t, e) {
                      var n = zn(t);
                      return null == e ? n : nr(n, e);
                    }),
                    (jn.curry = function t(e, n, r) {
                      var i = Xs(e, 8, s, s, s, s, s, (n = r ? s : n));
                      return (i.placeholder = t.placeholder), i;
                    }),
                    (jn.curryRight = function t(e, n, r) {
                      var i = Xs(e, 16, s, s, s, s, s, (n = r ? s : n));
                      return (i.placeholder = t.placeholder), i;
                    }),
                    (jn.debounce = Po),
                    (jn.defaults = Ta),
                    (jn.defaultsDeep = Oa),
                    (jn.defer = ko),
                    (jn.delay = Do),
                    (jn.difference = ji),
                    (jn.differenceBy = zi),
                    (jn.differenceWith = Bi),
                    (jn.drop = function (t, e, n) {
                      var r = null == t ? 0 : t.length;
                      return r ? ts(t, (e = n || e === s ? 1 : da(e)) < 0 ? 0 : e, r) : [];
                    }),
                    (jn.dropRight = function (t, e, n) {
                      var r = null == t ? 0 : t.length;
                      return r ? ts(t, 0, (e = r - (e = n || e === s ? 1 : da(e))) < 0 ? 0 : e) : [];
                    }),
                    (jn.dropRightWhile = function (t, e) {
                      return t && t.length ? cs(t, ii(e, 3), !0, !0) : [];
                    }),
                    (jn.dropWhile = function (t, e) {
                      return t && t.length ? cs(t, ii(e, 3), !0) : [];
                    }),
                    (jn.fill = function (t, e, n, r) {
                      var i = null == t ? 0 : t.length;
                      return i
                        ? (n && 'number' != typeof n && pi(t, e, n) && ((n = 0), (r = i)),
                          (function (t, e, n, r) {
                            var i = t.length;
                            for (
                              (n = da(n)) < 0 && (n = -n > i ? 0 : i + n),
                                (r = r === s || r > i ? i : da(r)) < 0 && (r += i),
                                r = n > r ? 0 : _a(r);
                              n < r;

                            )
                              t[n++] = e;
                            return t;
                          })(t, e, n, r))
                        : [];
                    }),
                    (jn.filter = function (t, e) {
                      return (Uo(t) ? Le : _r)(t, ii(e, 3));
                    }),
                    (jn.flatMap = function (t, e) {
                      return gr(xo(t, e), 1);
                    }),
                    (jn.flatMapDeep = function (t, e) {
                      return gr(xo(t, e), c);
                    }),
                    (jn.flatMapDepth = function (t, e, n) {
                      return (n = n === s ? 1 : da(n)), gr(xo(t, e), n);
                    }),
                    (jn.flatten = Ui),
                    (jn.flattenDeep = function (t) {
                      return null != t && t.length ? gr(t, c) : [];
                    }),
                    (jn.flattenDepth = function (t, e) {
                      return null != t && t.length ? gr(t, (e = e === s ? 1 : da(e))) : [];
                    }),
                    (jn.flip = function (t) {
                      return Xs(t, 512);
                    }),
                    (jn.flow = tl),
                    (jn.flowRight = el),
                    (jn.fromPairs = function (t) {
                      for (var e = -1, n = null == t ? 0 : t.length, r = {}; ++e < n; ) {
                        var s = t[e];
                        r[s[0]] = s[1];
                      }
                      return r;
                    }),
                    (jn.functions = function (t) {
                      return null == t ? [] : Cr(t, Pa(t));
                    }),
                    (jn.functionsIn = function (t) {
                      return null == t ? [] : Cr(t, ka(t));
                    }),
                    (jn.groupBy = yo),
                    (jn.initial = function (t) {
                      return null != t && t.length ? ts(t, 0, -1) : [];
                    }),
                    (jn.intersection = $i),
                    (jn.intersectionBy = Yi),
                    (jn.intersectionWith = Ki),
                    (jn.invert = Aa),
                    (jn.invertBy = La),
                    (jn.invokeMap = Co),
                    (jn.iteratee = rl),
                    (jn.keyBy = bo),
                    (jn.keys = Pa),
                    (jn.keysIn = ka),
                    (jn.map = xo),
                    (jn.mapKeys = function (t, e) {
                      var n = {};
                      return (
                        (e = ii(e, 3)),
                        vr(t, function (t, r, s) {
                          rr(n, e(t, r, s), t);
                        }),
                        n
                      );
                    }),
                    (jn.mapValues = function (t, e) {
                      var n = {};
                      return (
                        (e = ii(e, 3)),
                        vr(t, function (t, r, s) {
                          rr(n, r, e(t, r, s));
                        }),
                        n
                      );
                    }),
                    (jn.matches = function (t) {
                      return Nr(or(t, 1));
                    }),
                    (jn.matchesProperty = function (t, e) {
                      return jr(t, or(e, 1));
                    }),
                    (jn.memoize = Io),
                    (jn.merge = Da),
                    (jn.mergeWith = Ia),
                    (jn.method = sl),
                    (jn.methodOf = il),
                    (jn.mixin = ol),
                    (jn.negate = Mo),
                    (jn.nthArg = function (t) {
                      return (
                        (t = da(t)),
                        Kr(function (e) {
                          return Br(e, t);
                        })
                      );
                    }),
                    (jn.omit = Ma),
                    (jn.omitBy = function (t, e) {
                      return Wa(t, Mo(ii(e)));
                    }),
                    (jn.once = function (t) {
                      return Ao(2, t);
                    }),
                    (jn.orderBy = function (t, e, n, r) {
                      return null == t
                        ? []
                        : (Uo(e) || (e = null == e ? [] : [e]),
                          Uo((n = r ? s : n)) || (n = null == n ? [] : [n]),
                          Hr(t, e, n));
                    }),
                    (jn.over = ll),
                    (jn.overArgs = Fo),
                    (jn.overEvery = ul),
                    (jn.overSome = cl),
                    (jn.partial = Wo),
                    (jn.partialRight = No),
                    (jn.partition = To),
                    (jn.pick = Fa),
                    (jn.pickBy = Wa),
                    (jn.property = fl),
                    (jn.propertyOf = function (t) {
                      return function (e) {
                        return null == t ? s : br(t, e);
                      };
                    }),
                    (jn.pull = Gi),
                    (jn.pullAll = Zi),
                    (jn.pullAllBy = function (t, e, n) {
                      return t && t.length && e && e.length ? Ur(t, e, ii(n, 2)) : t;
                    }),
                    (jn.pullAllWith = function (t, e, n) {
                      return t && t.length && e && e.length ? Ur(t, e, s, n) : t;
                    }),
                    (jn.pullAt = qi),
                    (jn.range = hl),
                    (jn.rangeRight = dl),
                    (jn.rearg = jo),
                    (jn.reject = function (t, e) {
                      return (Uo(t) ? Le : _r)(t, Mo(ii(e, 3)));
                    }),
                    (jn.remove = function (t, e) {
                      var n = [];
                      if (!t || !t.length) return n;
                      var r = -1,
                        s = [],
                        i = t.length;
                      for (e = ii(e, 3); ++r < i; ) {
                        var o = t[r];
                        e(o, r, t) && (n.push(o), s.push(r));
                      }
                      return Vr(t, s), n;
                    }),
                    (jn.rest = function (t, e) {
                      if ('function' != typeof t) throw new At(i);
                      return Kr(t, (e = e === s ? e : da(e)));
                    }),
                    (jn.reverse = Ji),
                    (jn.sampleSize = function (t, e, n) {
                      return (e = (n ? pi(t, e, n) : e === s) ? 1 : da(e)), (Uo(t) ? Zn : Gr)(t, e);
                    }),
                    (jn.set = function (t, e, n) {
                      return null == t ? t : Zr(t, e, n);
                    }),
                    (jn.setWith = function (t, e, n, r) {
                      return (r = 'function' == typeof r ? r : s), null == t ? t : Zr(t, e, n, r);
                    }),
                    (jn.shuffle = function (t) {
                      return (Uo(t) ? qn : Qr)(t);
                    }),
                    (jn.slice = function (t, e, n) {
                      var r = null == t ? 0 : t.length;
                      return r
                        ? (n && 'number' != typeof n && pi(t, e, n)
                            ? ((e = 0), (n = r))
                            : ((e = null == e ? 0 : da(e)), (n = n === s ? r : da(n))),
                          ts(t, e, n))
                        : [];
                    }),
                    (jn.sortBy = Oo),
                    (jn.sortedUniq = function (t) {
                      return t && t.length ? ss(t) : [];
                    }),
                    (jn.sortedUniqBy = function (t, e) {
                      return t && t.length ? ss(t, ii(e, 2)) : [];
                    }),
                    (jn.split = function (t, e, n) {
                      return (
                        n && 'number' != typeof n && pi(t, e, n) && (e = n = s),
                        (n = n === s ? d : n >>> 0)
                          ? (t = ma(t)) && ('string' == typeof e || (null != e && !sa(e))) && !(e = os(e)) && rn(t)
                            ? vs(fn(t), 0, n)
                            : t.split(e, n)
                          : []
                      );
                    }),
                    (jn.spread = function (t, e) {
                      if ('function' != typeof t) throw new At(i);
                      return (
                        (e = null == e ? 0 : pn(da(e), 0)),
                        Kr(function (n) {
                          var r = n[e],
                            s = vs(n, 0, e);
                          return r && De(s, r), Te(t, this, s);
                        })
                      );
                    }),
                    (jn.tail = function (t) {
                      var e = null == t ? 0 : t.length;
                      return e ? ts(t, 1, e) : [];
                    }),
                    (jn.take = function (t, e, n) {
                      return t && t.length ? ts(t, 0, (e = n || e === s ? 1 : da(e)) < 0 ? 0 : e) : [];
                    }),
                    (jn.takeRight = function (t, e, n) {
                      var r = null == t ? 0 : t.length;
                      return r ? ts(t, (e = r - (e = n || e === s ? 1 : da(e))) < 0 ? 0 : e, r) : [];
                    }),
                    (jn.takeRightWhile = function (t, e) {
                      return t && t.length ? cs(t, ii(e, 3), !1, !0) : [];
                    }),
                    (jn.takeWhile = function (t, e) {
                      return t && t.length ? cs(t, ii(e, 3)) : [];
                    }),
                    (jn.tap = function (t, e) {
                      return e(t), t;
                    }),
                    (jn.throttle = function (t, e, n) {
                      var r = !0,
                        s = !0;
                      if ('function' != typeof t) throw new At(i);
                      return (
                        Qo(n) && ((r = 'leading' in n ? !!n.leading : r), (s = 'trailing' in n ? !!n.trailing : s)),
                        Po(t, e, { leading: r, maxWait: e, trailing: s })
                      );
                    }),
                    (jn.thru = fo),
                    (jn.toArray = fa),
                    (jn.toPairs = Na),
                    (jn.toPairsIn = ja),
                    (jn.toPath = function (t) {
                      return Uo(t) ? ke(t, Fi) : aa(t) ? [t] : ws(Mi(ma(t)));
                    }),
                    (jn.toPlainObject = pa),
                    (jn.transform = function (t, e, n) {
                      var r = Uo(t),
                        s = r || Ko(t) || la(t);
                      if (((e = ii(e, 4)), null == n)) {
                        var i = t && t.constructor;
                        n = s ? (r ? new i() : []) : Qo(t) && Zo(i) ? zn(Vt(t)) : {};
                      }
                      return (
                        (s ? Se : vr)(t, function (t, r, s) {
                          return e(n, t, r, s);
                        }),
                        n
                      );
                    }),
                    (jn.unary = function (t) {
                      return wo(t, 1);
                    }),
                    (jn.union = Qi),
                    (jn.unionBy = to),
                    (jn.unionWith = eo),
                    (jn.uniq = function (t) {
                      return t && t.length ? as(t) : [];
                    }),
                    (jn.uniqBy = function (t, e) {
                      return t && t.length ? as(t, ii(e, 2)) : [];
                    }),
                    (jn.uniqWith = function (t, e) {
                      return (e = 'function' == typeof e ? e : s), t && t.length ? as(t, s, e) : [];
                    }),
                    (jn.unset = function (t, e) {
                      return null == t || ls(t, e);
                    }),
                    (jn.unzip = no),
                    (jn.unzipWith = ro),
                    (jn.update = function (t, e, n) {
                      return null == t ? t : us(t, e, gs(n));
                    }),
                    (jn.updateWith = function (t, e, n, r) {
                      return (r = 'function' == typeof r ? r : s), null == t ? t : us(t, e, gs(n), r);
                    }),
                    (jn.values = za),
                    (jn.valuesIn = function (t) {
                      return null == t ? [] : Ze(t, ka(t));
                    }),
                    (jn.without = so),
                    (jn.words = Za),
                    (jn.wrap = function (t, e) {
                      return Wo(gs(e), t);
                    }),
                    (jn.xor = io),
                    (jn.xorBy = oo),
                    (jn.xorWith = ao),
                    (jn.zip = lo),
                    (jn.zipObject = function (t, e) {
                      return ds(t || [], e || [], Qn);
                    }),
                    (jn.zipObjectDeep = function (t, e) {
                      return ds(t || [], e || [], Zr);
                    }),
                    (jn.zipWith = uo),
                    (jn.entries = Na),
                    (jn.entriesIn = ja),
                    (jn.extend = ya),
                    (jn.extendWith = Ca),
                    ol(jn, jn),
                    (jn.add = ml),
                    (jn.attempt = qa),
                    (jn.camelCase = Ba),
                    (jn.capitalize = Ha),
                    (jn.ceil = vl),
                    (jn.clamp = function (t, e, n) {
                      return (
                        n === s && ((n = e), (e = s)),
                        n !== s && (n = (n = ga(n)) == n ? n : 0),
                        e !== s && (e = (e = ga(e)) == e ? e : 0),
                        ir(ga(t), e, n)
                      );
                    }),
                    (jn.clone = function (t) {
                      return or(t, 4);
                    }),
                    (jn.cloneDeep = function (t) {
                      return or(t, 5);
                    }),
                    (jn.cloneDeepWith = function (t, e) {
                      return or(t, 5, (e = 'function' == typeof e ? e : s));
                    }),
                    (jn.cloneWith = function (t, e) {
                      return or(t, 4, (e = 'function' == typeof e ? e : s));
                    }),
                    (jn.conformsTo = function (t, e) {
                      return null == e || ar(t, e, Pa(e));
                    }),
                    (jn.deburr = Ra),
                    (jn.defaultTo = function (t, e) {
                      return null == t || t != t ? e : t;
                    }),
                    (jn.divide = yl),
                    (jn.endsWith = function (t, e, n) {
                      (t = ma(t)), (e = os(e));
                      var r = t.length,
                        i = (n = n === s ? r : ir(da(n), 0, r));
                      return (n -= e.length) >= 0 && t.slice(n, i) == e;
                    }),
                    (jn.eq = zo),
                    (jn.escape = function (t) {
                      return (t = ma(t)) && X.test(t) ? t.replace(Y, en) : t;
                    }),
                    (jn.escapeRegExp = function (t) {
                      return (t = ma(t)) && nt.test(t) ? t.replace(et, '\\$&') : t;
                    }),
                    (jn.every = function (t, e, n) {
                      var r = Uo(t) ? Ae : hr;
                      return n && pi(t, e, n) && (e = s), r(t, ii(e, 3));
                    }),
                    (jn.find = go),
                    (jn.findIndex = Hi),
                    (jn.findKey = function (t, e) {
                      return Ne(t, ii(e, 3), vr);
                    }),
                    (jn.findLast = po),
                    (jn.findLastIndex = Ri),
                    (jn.findLastKey = function (t, e) {
                      return Ne(t, ii(e, 3), yr);
                    }),
                    (jn.floor = Cl),
                    (jn.forEach = mo),
                    (jn.forEachRight = vo),
                    (jn.forIn = function (t, e) {
                      return null == t ? t : pr(t, ii(e, 3), ka);
                    }),
                    (jn.forInRight = function (t, e) {
                      return null == t ? t : mr(t, ii(e, 3), ka);
                    }),
                    (jn.forOwn = function (t, e) {
                      return t && vr(t, ii(e, 3));
                    }),
                    (jn.forOwnRight = function (t, e) {
                      return t && yr(t, ii(e, 3));
                    }),
                    (jn.get = Sa),
                    (jn.gt = Bo),
                    (jn.gte = Ho),
                    (jn.has = function (t, e) {
                      return null != t && hi(t, e, Sr);
                    }),
                    (jn.hasIn = wa),
                    (jn.head = Vi),
                    (jn.identity = nl),
                    (jn.includes = function (t, e, n, r) {
                      (t = $o(t) ? t : za(t)), (n = n && !r ? da(n) : 0);
                      var s = t.length;
                      return (
                        n < 0 && (n = pn(s + n, 0)), oa(t) ? n <= s && t.indexOf(e, n) > -1 : !!s && ze(t, e, n) > -1
                      );
                    }),
                    (jn.indexOf = function (t, e, n) {
                      var r = null == t ? 0 : t.length;
                      if (!r) return -1;
                      var s = null == n ? 0 : da(n);
                      return s < 0 && (s = pn(r + s, 0)), ze(t, e, s);
                    }),
                    (jn.inRange = function (t, e, n) {
                      return (
                        (e = ha(e)),
                        n === s ? ((n = e), (e = 0)) : (n = ha(n)),
                        (function (t, e, n) {
                          return t >= mn(e, n) && t < pn(e, n);
                        })((t = ga(t)), e, n)
                      );
                    }),
                    (jn.invoke = Ea),
                    (jn.isArguments = Ro),
                    (jn.isArray = Uo),
                    (jn.isArrayBuffer = Vo),
                    (jn.isArrayLike = $o),
                    (jn.isArrayLikeObject = Yo),
                    (jn.isBoolean = function (t) {
                      return !0 === t || !1 === t || (ta(t) && Tr(t) == m);
                    }),
                    (jn.isBuffer = Ko),
                    (jn.isDate = Xo),
                    (jn.isElement = function (t) {
                      return ta(t) && 1 === t.nodeType && !ra(t);
                    }),
                    (jn.isEmpty = function (t) {
                      if (null == t) return !0;
                      if (
                        $o(t) &&
                        (Uo(t) || 'string' == typeof t || 'function' == typeof t.splice || Ko(t) || la(t) || Ro(t))
                      )
                        return !t.length;
                      var e = fi(t);
                      if (e == x || e == A) return !t.size;
                      if (Ci(t)) return !Mr(t).length;
                      for (var n in t) if (It.call(t, n)) return !1;
                      return !0;
                    }),
                    (jn.isEqual = function (t, e) {
                      return Pr(t, e);
                    }),
                    (jn.isEqualWith = function (t, e, n) {
                      var r = (n = 'function' == typeof n ? n : s) ? n(t, e) : s;
                      return r === s ? Pr(t, e, s, n) : !!r;
                    }),
                    (jn.isError = Go),
                    (jn.isFinite = function (t) {
                      return 'number' == typeof t && We(t);
                    }),
                    (jn.isFunction = Zo),
                    (jn.isInteger = qo),
                    (jn.isLength = Jo),
                    (jn.isMap = ea),
                    (jn.isMatch = function (t, e) {
                      return t === e || kr(t, e, ai(e));
                    }),
                    (jn.isMatchWith = function (t, e, n) {
                      return (n = 'function' == typeof n ? n : s), kr(t, e, ai(e), n);
                    }),
                    (jn.isNaN = function (t) {
                      return na(t) && t != +t;
                    }),
                    (jn.isNative = function (t) {
                      if (yi(t)) throw new bt('Unsupported core-js use. Try https://npms.io/search?q=ponyfill.');
                      return Dr(t);
                    }),
                    (jn.isNil = function (t) {
                      return null == t;
                    }),
                    (jn.isNull = function (t) {
                      return null === t;
                    }),
                    (jn.isNumber = na),
                    (jn.isObject = Qo),
                    (jn.isObjectLike = ta),
                    (jn.isPlainObject = ra),
                    (jn.isRegExp = sa),
                    (jn.isSafeInteger = function (t) {
                      return qo(t) && t >= -9007199254740991 && t <= f;
                    }),
                    (jn.isSet = ia),
                    (jn.isString = oa),
                    (jn.isSymbol = aa),
                    (jn.isTypedArray = la),
                    (jn.isUndefined = function (t) {
                      return t === s;
                    }),
                    (jn.isWeakMap = function (t) {
                      return ta(t) && fi(t) == P;
                    }),
                    (jn.isWeakSet = function (t) {
                      return ta(t) && '[object WeakSet]' == Tr(t);
                    }),
                    (jn.join = function (t, e) {
                      return null == t ? '' : Ve.call(t, e);
                    }),
                    (jn.kebabCase = Ua),
                    (jn.last = Xi),
                    (jn.lastIndexOf = function (t, e, n) {
                      var r = null == t ? 0 : t.length;
                      if (!r) return -1;
                      var i = r;
                      return (
                        n !== s && (i = (i = da(n)) < 0 ? pn(r + i, 0) : mn(i, r - 1)),
                        e == e
                          ? (function (t, e, n) {
                              for (var r = n + 1; r--; ) if (t[r] === e) return r;
                              return r;
                            })(t, e, i)
                          : je(t, He, i, !0)
                      );
                    }),
                    (jn.lowerCase = Va),
                    (jn.lowerFirst = $a),
                    (jn.lt = ua),
                    (jn.lte = ca),
                    (jn.max = function (t) {
                      return t && t.length ? dr(t, nl, Or) : s;
                    }),
                    (jn.maxBy = function (t, e) {
                      return t && t.length ? dr(t, ii(e, 2), Or) : s;
                    }),
                    (jn.mean = function (t) {
                      return Re(t, nl);
                    }),
                    (jn.meanBy = function (t, e) {
                      return Re(t, ii(e, 2));
                    }),
                    (jn.min = function (t) {
                      return t && t.length ? dr(t, nl, Fr) : s;
                    }),
                    (jn.minBy = function (t, e) {
                      return t && t.length ? dr(t, ii(e, 2), Fr) : s;
                    }),
                    (jn.stubArray = _l),
                    (jn.stubFalse = gl),
                    (jn.stubObject = function () {
                      return {};
                    }),
                    (jn.stubString = function () {
                      return '';
                    }),
                    (jn.stubTrue = function () {
                      return !0;
                    }),
                    (jn.multiply = bl),
                    (jn.nth = function (t, e) {
                      return t && t.length ? Br(t, da(e)) : s;
                    }),
                    (jn.noConflict = function () {
                      return fe._ === this && (fe._ = jt), this;
                    }),
                    (jn.noop = al),
                    (jn.now = So),
                    (jn.pad = function (t, e, n) {
                      t = ma(t);
                      var r = (e = da(e)) ? cn(t) : 0;
                      if (!e || r >= e) return t;
                      var s = (e - r) / 2;
                      return Hs(de(s), n) + t + Hs(he(s), n);
                    }),
                    (jn.padEnd = function (t, e, n) {
                      t = ma(t);
                      var r = (e = da(e)) ? cn(t) : 0;
                      return e && r < e ? t + Hs(e - r, n) : t;
                    }),
                    (jn.padStart = function (t, e, n) {
                      t = ma(t);
                      var r = (e = da(e)) ? cn(t) : 0;
                      return e && r < e ? Hs(e - r, n) + t : t;
                    }),
                    (jn.parseInt = function (t, e, n) {
                      return n || null == e ? (e = 0) : e && (e = +e), yn(ma(t).replace(rt, ''), e || 0);
                    }),
                    (jn.random = function (t, e, n) {
                      if (
                        (n && 'boolean' != typeof n && pi(t, e, n) && (e = n = s),
                        n === s &&
                          ('boolean' == typeof e ? ((n = e), (e = s)) : 'boolean' == typeof t && ((n = t), (t = s))),
                        t === s && e === s
                          ? ((t = 0), (e = 1))
                          : ((t = ha(t)), e === s ? ((e = t), (t = 0)) : (e = ha(e))),
                        t > e)
                      ) {
                        var r = t;
                        (t = e), (e = r);
                      }
                      if (n || t % 1 || e % 1) {
                        var i = Cn();
                        return mn(t + i * (e - t + ae('1e-' + ((i + '').length - 1))), e);
                      }
                      return $r(t, e);
                    }),
                    (jn.reduce = function (t, e, n) {
                      var r = Uo(t) ? Ie : $e,
                        s = arguments.length < 3;
                      return r(t, ii(e, 4), n, s, cr);
                    }),
                    (jn.reduceRight = function (t, e, n) {
                      var r = Uo(t) ? Me : $e,
                        s = arguments.length < 3;
                      return r(t, ii(e, 4), n, s, fr);
                    }),
                    (jn.repeat = function (t, e, n) {
                      return (e = (n ? pi(t, e, n) : e === s) ? 1 : da(e)), Yr(ma(t), e);
                    }),
                    (jn.replace = function () {
                      var t = arguments,
                        e = ma(t[0]);
                      return t.length < 3 ? e : e.replace(t[1], t[2]);
                    }),
                    (jn.result = function (t, e, n) {
                      var r = -1,
                        i = (e = ps(e, t)).length;
                      for (i || ((i = 1), (t = s)); ++r < i; ) {
                        var o = null == t ? s : t[Fi(e[r])];
                        o === s && ((r = i), (o = n)), (t = Zo(o) ? o.call(t) : o);
                      }
                      return t;
                    }),
                    (jn.round = xl),
                    (jn.runInContext = t),
                    (jn.sample = function (t) {
                      return (Uo(t) ? Gn : Xr)(t);
                    }),
                    (jn.size = function (t) {
                      if (null == t) return 0;
                      if ($o(t)) return oa(t) ? cn(t) : t.length;
                      var e = fi(t);
                      return e == x || e == A ? t.size : Mr(t).length;
                    }),
                    (jn.snakeCase = Ya),
                    (jn.some = function (t, e, n) {
                      var r = Uo(t) ? Fe : es;
                      return n && pi(t, e, n) && (e = s), r(t, ii(e, 3));
                    }),
                    (jn.sortedIndex = function (t, e) {
                      return ns(t, e);
                    }),
                    (jn.sortedIndexBy = function (t, e, n) {
                      return rs(t, e, ii(n, 2));
                    }),
                    (jn.sortedIndexOf = function (t, e) {
                      var n = null == t ? 0 : t.length;
                      if (n) {
                        var r = ns(t, e);
                        if (r < n && zo(t[r], e)) return r;
                      }
                      return -1;
                    }),
                    (jn.sortedLastIndex = function (t, e) {
                      return ns(t, e, !0);
                    }),
                    (jn.sortedLastIndexBy = function (t, e, n) {
                      return rs(t, e, ii(n, 2), !0);
                    }),
                    (jn.sortedLastIndexOf = function (t, e) {
                      if (null != t && t.length) {
                        var n = ns(t, e, !0) - 1;
                        if (zo(t[n], e)) return n;
                      }
                      return -1;
                    }),
                    (jn.startCase = Ka),
                    (jn.startsWith = function (t, e, n) {
                      return (
                        (t = ma(t)),
                        (n = null == n ? 0 : ir(da(n), 0, t.length)),
                        (e = os(e)),
                        t.slice(n, n + e.length) == e
                      );
                    }),
                    (jn.subtract = Tl),
                    (jn.sum = function (t) {
                      return t && t.length ? Ye(t, nl) : 0;
                    }),
                    (jn.sumBy = function (t, e) {
                      return t && t.length ? Ye(t, ii(e, 2)) : 0;
                    }),
                    (jn.template = function (t, e, n) {
                      var r = jn.templateSettings;
                      n && pi(t, e, n) && (e = s), (t = ma(t)), (e = Ca({}, e, r, Gs));
                      var i,
                        o,
                        a = Ca({}, e.imports, r.imports, Gs),
                        l = Pa(a),
                        u = Ze(a, l),
                        c = 0,
                        f = e.interpolate || yt,
                        h = "__p += '",
                        d = St(
                          (e.escape || yt).source +
                            '|' +
                            f.source +
                            '|' +
                            (f === q ? ft : yt).source +
                            '|' +
                            (e.evaluate || yt).source +
                            '|$',
                          'g',
                        ),
                        _ =
                          '//# sourceURL=' +
                          (It.call(e, 'sourceURL')
                            ? (e.sourceURL + '').replace(/\s/g, ' ')
                            : 'lodash.templateSources[' + ++re + ']') +
                          '\n';
                      t.replace(d, function (e, n, r, s, a, l) {
                        return (
                          r || (r = s),
                          (h += t.slice(c, l).replace(Ct, nn)),
                          n && ((i = !0), (h += "' +\n__e(" + n + ") +\n'")),
                          a && ((o = !0), (h += "';\n" + a + ";\n__p += '")),
                          r && (h += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"),
                          (c = l + e.length),
                          e
                        );
                      }),
                        (h += "';\n");
                      var g = It.call(e, 'variable') && e.variable;
                      if (g) {
                        if (ut.test(g)) throw new bt('Invalid `variable` option passed into `_.template`');
                      } else h = 'with (obj) {\n' + h + '\n}\n';
                      (h = (o ? h.replace(R, '') : h).replace(U, '$1').replace(V, '$1;')),
                        (h =
                          'function(' +
                          (g || 'obj') +
                          ') {\n' +
                          (g ? '' : 'obj || (obj = {});\n') +
                          "var __t, __p = ''" +
                          (i ? ', __e = _.escape' : '') +
                          (o
                            ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n"
                            : ';\n') +
                          h +
                          'return __p\n}');
                      var p = qa(function () {
                        return xt(l, _ + 'return ' + h).apply(s, u);
                      });
                      if (((p.source = h), Go(p))) throw p;
                      return p;
                    }),
                    (jn.times = function (t, e) {
                      if ((t = da(t)) < 1 || t > f) return [];
                      var n = d,
                        r = mn(t, d);
                      (e = ii(e)), (t -= d);
                      for (var s = Ke(r, e); ++n < t; ) e(n);
                      return s;
                    }),
                    (jn.toFinite = ha),
                    (jn.toInteger = da),
                    (jn.toLength = _a),
                    (jn.toLower = function (t) {
                      return ma(t).toLowerCase();
                    }),
                    (jn.toNumber = ga),
                    (jn.toSafeInteger = function (t) {
                      return t ? ir(da(t), -9007199254740991, f) : 0 === t ? t : 0;
                    }),
                    (jn.toString = ma),
                    (jn.toUpper = function (t) {
                      return ma(t).toUpperCase();
                    }),
                    (jn.trim = function (t, e, n) {
                      if ((t = ma(t)) && (n || e === s)) return Xe(t);
                      if (!t || !(e = os(e))) return t;
                      var r = fn(t),
                        i = fn(e);
                      return vs(r, Je(r, i), Qe(r, i) + 1).join('');
                    }),
                    (jn.trimEnd = function (t, e, n) {
                      if ((t = ma(t)) && (n || e === s)) return t.slice(0, hn(t) + 1);
                      if (!t || !(e = os(e))) return t;
                      var r = fn(t);
                      return vs(r, 0, Qe(r, fn(e)) + 1).join('');
                    }),
                    (jn.trimStart = function (t, e, n) {
                      if ((t = ma(t)) && (n || e === s)) return t.replace(rt, '');
                      if (!t || !(e = os(e))) return t;
                      var r = fn(t);
                      return vs(r, Je(r, fn(e))).join('');
                    }),
                    (jn.truncate = function (t, e) {
                      var n = 30,
                        r = '...';
                      if (Qo(e)) {
                        var i = 'separator' in e ? e.separator : i;
                        (n = 'length' in e ? da(e.length) : n), (r = 'omission' in e ? os(e.omission) : r);
                      }
                      var o = (t = ma(t)).length;
                      if (rn(t)) {
                        var a = fn(t);
                        o = a.length;
                      }
                      if (n >= o) return t;
                      var l = n - cn(r);
                      if (l < 1) return r;
                      var u = a ? vs(a, 0, l).join('') : t.slice(0, l);
                      if (i === s) return u + r;
                      if ((a && (l += u.length - l), sa(i))) {
                        if (t.slice(l).search(i)) {
                          var c,
                            f = u;
                          for (i.global || (i = St(i.source, ma(ht.exec(i)) + 'g')), i.lastIndex = 0; (c = i.exec(f)); )
                            var h = c.index;
                          u = u.slice(0, h === s ? l : h);
                        }
                      } else if (t.indexOf(os(i), l) != l) {
                        var d = u.lastIndexOf(i);
                        d > -1 && (u = u.slice(0, d));
                      }
                      return u + r;
                    }),
                    (jn.unescape = function (t) {
                      return (t = ma(t)) && K.test(t) ? t.replace($, dn) : t;
                    }),
                    (jn.uniqueId = function (t) {
                      var e = ++Mt;
                      return ma(t) + e;
                    }),
                    (jn.upperCase = Xa),
                    (jn.upperFirst = Ga),
                    (jn.each = mo),
                    (jn.eachRight = vo),
                    (jn.first = Vi),
                    ol(
                      jn,
                      ((pl = {}),
                      vr(jn, function (t, e) {
                        It.call(jn.prototype, e) || (pl[e] = t);
                      }),
                      pl),
                      { chain: !1 },
                    ),
                    (jn.VERSION = '4.17.21'),
                    Se(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function (t) {
                      jn[t].placeholder = jn;
                    }),
                    Se(['drop', 'take'], function (t, e) {
                      (Rn.prototype[t] = function (n) {
                        n = n === s ? 1 : pn(da(n), 0);
                        var r = this.__filtered__ && !e ? new Rn(this) : this.clone();
                        return (
                          r.__filtered__
                            ? (r.__takeCount__ = mn(n, r.__takeCount__))
                            : r.__views__.push({ size: mn(n, d), type: t + (r.__dir__ < 0 ? 'Right' : '') }),
                          r
                        );
                      }),
                        (Rn.prototype[t + 'Right'] = function (e) {
                          return this.reverse()[t](e).reverse();
                        });
                    }),
                    Se(['filter', 'map', 'takeWhile'], function (t, e) {
                      var n = e + 1,
                        r = 1 == n || 3 == n;
                      Rn.prototype[t] = function (t) {
                        var e = this.clone();
                        return (
                          e.__iteratees__.push({ iteratee: ii(t, 3), type: n }),
                          (e.__filtered__ = e.__filtered__ || r),
                          e
                        );
                      };
                    }),
                    Se(['head', 'last'], function (t, e) {
                      var n = 'take' + (e ? 'Right' : '');
                      Rn.prototype[t] = function () {
                        return this[n](1).value()[0];
                      };
                    }),
                    Se(['initial', 'tail'], function (t, e) {
                      var n = 'drop' + (e ? '' : 'Right');
                      Rn.prototype[t] = function () {
                        return this.__filtered__ ? new Rn(this) : this[n](1);
                      };
                    }),
                    (Rn.prototype.compact = function () {
                      return this.filter(nl);
                    }),
                    (Rn.prototype.find = function (t) {
                      return this.filter(t).head();
                    }),
                    (Rn.prototype.findLast = function (t) {
                      return this.reverse().find(t);
                    }),
                    (Rn.prototype.invokeMap = Kr(function (t, e) {
                      return 'function' == typeof t
                        ? new Rn(this)
                        : this.map(function (n) {
                            return Lr(n, t, e);
                          });
                    })),
                    (Rn.prototype.reject = function (t) {
                      return this.filter(Mo(ii(t)));
                    }),
                    (Rn.prototype.slice = function (t, e) {
                      t = da(t);
                      var n = this;
                      return n.__filtered__ && (t > 0 || e < 0)
                        ? new Rn(n)
                        : (t < 0 ? (n = n.takeRight(-t)) : t && (n = n.drop(t)),
                          e !== s && (n = (e = da(e)) < 0 ? n.dropRight(-e) : n.take(e - t)),
                          n);
                    }),
                    (Rn.prototype.takeRightWhile = function (t) {
                      return this.reverse().takeWhile(t).reverse();
                    }),
                    (Rn.prototype.toArray = function () {
                      return this.take(d);
                    }),
                    vr(Rn.prototype, function (t, e) {
                      var n = /^(?:filter|find|map|reject)|While$/.test(e),
                        r = /^(?:head|last)$/.test(e),
                        i = jn[r ? 'take' + ('last' == e ? 'Right' : '') : e],
                        o = r || /^find/.test(e);
                      i &&
                        (jn.prototype[e] = function () {
                          var e = this.__wrapped__,
                            a = r ? [1] : arguments,
                            l = e instanceof Rn,
                            u = a[0],
                            c = l || Uo(e),
                            f = function (t) {
                              var e = i.apply(jn, De([t], a));
                              return r && h ? e[0] : e;
                            };
                          c && n && 'function' == typeof u && 1 != u.length && (l = c = !1);
                          var h = this.__chain__,
                            d = !!this.__actions__.length,
                            _ = o && !h,
                            g = l && !d;
                          if (!o && c) {
                            e = g ? e : new Rn(this);
                            var p = t.apply(e, a);
                            return p.__actions__.push({ func: fo, args: [f], thisArg: s }), new Hn(p, h);
                          }
                          return _ && g
                            ? t.apply(this, a)
                            : ((p = this.thru(f)), _ ? (r ? p.value()[0] : p.value()) : p);
                        });
                    }),
                    Se(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function (t) {
                      var e = Lt[t],
                        n = /^(?:push|sort|unshift)$/.test(t) ? 'tap' : 'thru',
                        r = /^(?:pop|shift)$/.test(t);
                      jn.prototype[t] = function () {
                        var t = arguments;
                        if (r && !this.__chain__) {
                          var s = this.value();
                          return e.apply(Uo(s) ? s : [], t);
                        }
                        return this[n](function (n) {
                          return e.apply(Uo(n) ? n : [], t);
                        });
                      };
                    }),
                    vr(Rn.prototype, function (t, e) {
                      var n = jn[e];
                      if (n) {
                        var r = n.name + '';
                        It.call(En, r) || (En[r] = []), En[r].push({ name: e, func: n });
                      }
                    }),
                    (En[Ns(s, 2).name] = [{ name: 'wrapper', func: s }]),
                    (Rn.prototype.clone = function () {
                      var t = new Rn(this.__wrapped__);
                      return (
                        (t.__actions__ = ws(this.__actions__)),
                        (t.__dir__ = this.__dir__),
                        (t.__filtered__ = this.__filtered__),
                        (t.__iteratees__ = ws(this.__iteratees__)),
                        (t.__takeCount__ = this.__takeCount__),
                        (t.__views__ = ws(this.__views__)),
                        t
                      );
                    }),
                    (Rn.prototype.reverse = function () {
                      if (this.__filtered__) {
                        var t = new Rn(this);
                        (t.__dir__ = -1), (t.__filtered__ = !0);
                      } else (t = this.clone()).__dir__ *= -1;
                      return t;
                    }),
                    (Rn.prototype.value = function () {
                      var t = this.__wrapped__.value(),
                        e = this.__dir__,
                        n = Uo(t),
                        r = e < 0,
                        s = n ? t.length : 0,
                        i = (function (t, e, n) {
                          for (var r = -1, s = n.length; ++r < s; ) {
                            var i = n[r],
                              o = i.size;
                            switch (i.type) {
                              case 'drop':
                                t += o;
                                break;
                              case 'dropRight':
                                e -= o;
                                break;
                              case 'take':
                                e = mn(e, t + o);
                                break;
                              case 'takeRight':
                                t = pn(t, e - o);
                            }
                          }
                          return { start: t, end: e };
                        })(0, s, this.__views__),
                        o = i.start,
                        a = i.end,
                        l = a - o,
                        u = r ? a : o - 1,
                        c = this.__iteratees__,
                        f = c.length,
                        h = 0,
                        d = mn(l, this.__takeCount__);
                      if (!n || (!r && s == l && d == l)) return fs(t, this.__actions__);
                      var _ = [];
                      t: for (; l-- && h < d; ) {
                        for (var g = -1, p = t[(u += e)]; ++g < f; ) {
                          var m = c[g],
                            v = m.iteratee,
                            y = m.type,
                            C = v(p);
                          if (2 == y) p = C;
                          else if (!C) {
                            if (1 == y) continue t;
                            break t;
                          }
                        }
                        _[h++] = p;
                      }
                      return _;
                    }),
                    (jn.prototype.at = ho),
                    (jn.prototype.chain = function () {
                      return co(this);
                    }),
                    (jn.prototype.commit = function () {
                      return new Hn(this.value(), this.__chain__);
                    }),
                    (jn.prototype.next = function () {
                      this.__values__ === s && (this.__values__ = fa(this.value()));
                      var t = this.__index__ >= this.__values__.length;
                      return { done: t, value: t ? s : this.__values__[this.__index__++] };
                    }),
                    (jn.prototype.plant = function (t) {
                      for (var e, n = this; n instanceof Bn; ) {
                        var r = Ni(n);
                        (r.__index__ = 0), (r.__values__ = s), e ? (i.__wrapped__ = r) : (e = r);
                        var i = r;
                        n = n.__wrapped__;
                      }
                      return (i.__wrapped__ = t), e;
                    }),
                    (jn.prototype.reverse = function () {
                      var t = this.__wrapped__;
                      if (t instanceof Rn) {
                        var e = t;
                        return (
                          this.__actions__.length && (e = new Rn(this)),
                          (e = e.reverse()).__actions__.push({ func: fo, args: [Ji], thisArg: s }),
                          new Hn(e, this.__chain__)
                        );
                      }
                      return this.thru(Ji);
                    }),
                    (jn.prototype.toJSON =
                      jn.prototype.valueOf =
                      jn.prototype.value =
                        function () {
                          return fs(this.__wrapped__, this.__actions__);
                        }),
                    (jn.prototype.first = jn.prototype.head),
                    Gt &&
                      (jn.prototype[Gt] = function () {
                        return this;
                      }),
                    jn
                  );
                })();
              (fe._ = _n),
                (r = function () {
                  return _n;
                }.call(e, n, e, t)) === s || (t.exports = r);
            }.call(this);
        },
      },
      e = {};
    function n(r) {
      var s = e[r];
      if (void 0 !== s) return s.exports;
      var i = (e[r] = { id: r, loaded: !1, exports: {} });
      return t[r].call(i.exports, i, i.exports, n), (i.loaded = !0), i.exports;
    }
    (n.d = (t, e) => {
      for (var r in e) n.o(e, r) && !n.o(t, r) && Object.defineProperty(t, r, { enumerable: !0, get: e[r] });
    }),
      (n.g = (function () {
        if ('object' == typeof globalThis) return globalThis;
        try {
          return this || new Function('return this')();
        } catch (t) {
          if ('object' == typeof window) return window;
        }
      })()),
      (n.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e)),
      (n.nmd = (t) => ((t.paths = []), t.children || (t.children = []), t));
    var r = {};
    return (
      (() => {
        'use strict';
        n.d(r, { default: () => c });
        var t = n(167);
        function e(t, e) {
          var n = ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
          if (!n) {
            if (Array.isArray(t) || (n = i(t)) || (e && t && 'number' == typeof t.length)) {
              n && (t = n);
              var r = 0,
                s = function () {};
              return {
                s,
                n: function () {
                  return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
                },
                e: function (t) {
                  throw t;
                },
                f: s,
              };
            }
            throw new TypeError(
              'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
            );
          }
          var o,
            a = !0,
            l = !1;
          return {
            s: function () {
              n = n.call(t);
            },
            n: function () {
              var t = n.next();
              return (a = t.done), t;
            },
            e: function (t) {
              (l = !0), (o = t);
            },
            f: function () {
              try {
                a || null == n.return || n.return();
              } finally {
                if (l) throw o;
              }
            },
          };
        }
        function s(t) {
          return (
            (function (t) {
              if (Array.isArray(t)) return o(t);
            })(t) ||
            (function (t) {
              if (('undefined' != typeof Symbol && null != t[Symbol.iterator]) || null != t['@@iterator'])
                return Array.from(t);
            })(t) ||
            i(t) ||
            (function () {
              throw new TypeError(
                'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
              );
            })()
          );
        }
        function i(t, e) {
          if (t) {
            if ('string' == typeof t) return o(t, e);
            var n = {}.toString.call(t).slice(8, -1);
            return (
              'Object' === n && t.constructor && (n = t.constructor.name),
              'Map' === n || 'Set' === n
                ? Array.from(t)
                : 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                  ? o(t, e)
                  : void 0
            );
          }
        }
        function o(t, e) {
          (null == e || e > t.length) && (e = t.length);
          for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
          return r;
        }
        var a,
          l,
          u =
            (((l = (a = { ui: { common: {}, style: {} } }).ui.common).lang = 'ko'),
            (l.__fieldSeparator = '@@>>'),
            (l.__regexpComma = /(\d{1})(\d{3}[,.])/),
            (l.__regexpText = /\D/gi),
            (l.SELECT_MODE = { ONESIDE: 'ONESIDE', SINGLE: 'SINGLE', MULTI: 'MULTI' }),
            (l.DATA_COL_MODE = { TOP: 'TOP', LEFT: 'LEFT' }),
            (l.SORT_COL_MODE = { NONE: 'NONE', ASC: 'ASC', DESC: 'DESC' }),
            (l.capitalize = function (t) {
              return 'string' != typeof t ? '' : t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
            }),
            (l.attributesString = function (t, e) {
              if (e) {
                var n = [];
                for (var r in e) e.hasOwnProperty(r) && n.push(r + ':' + e[r] + ';');
                t.style = n.join('');
              }
              var s = [];
              for (var i in t) t.hasOwnProperty(i) && s.push(i + '="' + String(t[i]).replace(/\"/gi, '&quot;') + '"');
              return s.join(' ');
            }),
            (l.hasCssClass = function (t, e) {
              return -1 !== (' ' + t.className + ' ').indexOf(' ' + e + ' ');
            }),
            (l.removeCssClass = function (t, e) {
              var n = ' ' + t.className + ' ',
                r = n.indexOf(' ' + e + ' ');
              return (
                -1 !== r &&
                ((t.className = (n.substr(0, r) + ' ' + n.substring(r + e.length + 1, n.length).trim()).trim()), !0)
              );
            }),
            (l.addCssClass = function (t, e) {
              this.hasCssClass(t, e) || (t.className ? (t.className += ' ' + e) : (t.className = e));
            }),
            (l.format = function (t, e) {
              var n = function (t, e) {
                do {
                  t = t.replace(e.__regexpComma, '$1,$2');
                } while (e.__regexpComma.test(t));
                return t;
              };
              if ((void 0 === e && (e = 2), 'number' != typeof t)) return t;
              if (null == t || isNaN(t)) return '';
              var r = String(t).split('.');
              return (
                (r[0] += '.'),
                (r[0] = n(r[0], this)),
                r.length > 1 ? (r[1].length > e ? n(t.toFixed(2), this) : r[0] + r[1]) : r[0].substr(0, r[0].length - 1)
              );
            }),
            (l.roundFloat = function (t, e) {
              var n = t;
              return (
                'exponent10' !== e.type &&
                  (n = Math.round(Number(t) * Math.pow(10, e.decimal)) / Math.pow(10, e.decimal)),
                n.toFixed(e.decimal)
              );
            }),
            (l.numberFormat = function (t, e, n) {
              if (null != t && e) {
                if ('number' != typeof t) return t;
                var r = JSON.parse(JSON.stringify(e));
                n && 'INTEGER' === n.toUpperCase() && (r.decimal = 0);
                var s = r.customSymbol,
                  i = _.cloneDeep(t);
                if (r.abbr && 'exponent10' != r.type)
                  switch (r.abbr) {
                    case 'AUTO':
                      t =
                        'ko' === l.lang
                          ? t > 1e8
                            ? Number(t) / 1e8
                            : t > 1e4
                              ? Number(t) / 1e4
                              : t > 1e3
                                ? Number(t) / 1e3
                                : t
                          : t > 1e9
                            ? Number(t) / 1e9
                            : t > 1e6
                              ? Number(t) / 1e6
                              : t > 1e3
                                ? Number(t) / 1e3
                                : t;
                      break;
                    case 'KILO':
                    case 'KILO_KOR':
                      t = Number(t) / 1e3;
                      break;
                    case 'MEGA':
                      t = Number(t) / 1e6;
                      break;
                    case 'GIGA':
                      t = Number(t) / 1e9;
                      break;
                    case 'MEGA_KOR':
                      t = Number(t) / 1e4;
                      break;
                    case 'GIGA_KOR':
                      t = Number(t) / 1e8;
                  }
                else s || 'percent' != r.type || (t *= 100);
                if (((t = this.roundFloat(t, r)), 'exponent10' !== r.type && r.useThousandsSep)) {
                  var o = String(t).split('.'),
                    a = '';
                  1 < o.length && (a = o[1]),
                    (t = o[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')),
                    '' !== a && (t += '.' + a);
                }
                if (t && 'exponent10' != r.type && r.decimal > 0) {
                  var u = t + '';
                  if (-1 == u.indexOf('.')) {
                    t += '.';
                    for (var c = 0; c < r.decimal; c++) t += '0';
                  } else for (var f = u.split('.')[1].length; f < r.decimal; f++) t += '0';
                }
                if (r.abbr && 'exponent10' != r.type)
                  switch (r.abbr) {
                    case 'AUTO':
                      'ko' === l.lang
                        ? (t += i > 1e8 ? '억' : i > 1e4 ? '만' : i > 1e3 ? '천' : '')
                        : (t += i > 1e9 ? 'B' : i > 1e6 ? 'M' : i > 1e3 ? 'K' : '');
                      break;
                    case 'KILO':
                      t += 'K';
                      break;
                    case 'MEGA':
                      t += 'M';
                      break;
                    case 'GIGA':
                      t += 'B';
                      break;
                    case 'KILO_KOR':
                      t += '천';
                      break;
                    case 'MEGA_KOR':
                      t += '만';
                      break;
                    case 'GIGA_KOR':
                      t += '억';
                  }
                if ((s && 0 != s.value.trim().length) || 'currency' != r.type)
                  (s && 0 != s.value.trim().length) || 'percent' != r.type
                    ? 'exponent10' == r.type && (t = Number(t).toExponential(r.decimal))
                    : (t += '%');
                else
                  switch (r.sign) {
                    case 'RUB':
                    case 'RUB':
                      t = '₽ ' + t;
                      break;
                    case 'KRW':
                      t = '₩ ' + t;
                      break;
                    case 'USD':
                      t = '$ ' + t;
                      break;
                    case 'USCENT':
                      t = '￠ ' + t;
                      break;
                    case 'GBP':
                      t = '£ ' + t;
                      break;
                    case 'JPY':
                    case 'CNY':
                      t = '¥ ' + t;
                      break;
                    case 'EUR':
                      t = '€ ' + t;
                  }
                if (s && s.value.trim().length > 0) {
                  var h = s.value.trim();
                  t = 'BEFORE' == s.pos ? h + t : t + h;
                }
                return t;
              }
            }),
            (function (e) {
              var n = e.ui.style,
                r = e.ui.common;
              return (
                (n.summaryLabel = { SUM: 'Total', AVERAGE: 'Average', MAX: 'Max', MIN: 'Min', COUNT: 'Count' }),
                (n.subSummaryLabel = {
                  SUM: 'Sub Total',
                  AVERAGE: 'Sub Average',
                  MAX: 'Sub Max',
                  MIN: 'Sub Min',
                  COUNT: 'Sub Count',
                }),
                (n.cssClass = {
                  container: 'pivot-view',
                  head: 'pivot-view-head',
                  headWrap: 'pivot-view-wrap',
                  headFrozen: 'pivot-view-frozen',
                  headRow: 'pivot-view-row',
                  headCell: 'pivot-view-cell',
                  body: 'pivot-view-body',
                  bodyWrap: 'pivot-view-wrap',
                  bodyFrozen: 'pivot-view-frozen',
                  bodyRow: 'pivot-view-row',
                  bodyCell: 'pivot-view-cell',
                  axisX: 'pivot-axis-x',
                  axisY: 'pivot-axis-y',
                  axisDisable: 'pivot-axis-disable',
                  axisSelected: 'pivot-axis-selected',
                  axisSelectedBody: 'pivot-axis-selected-body',
                  bodySelected: 'pivot-body-selected',
                  bodyHover: 'pivot-body-hover',
                  numeric: 'numeric',
                  totalValue: 'pivot-total',
                  totalValueFrozen: 'pivot-total-frozen',
                  totalValueWrap: 'pivot-total-wrap',
                  txtLeft: 'ddp-txt-left',
                  txtCenter: 'ddp-txt-center',
                  txtRight: 'ddp-txt-right',
                  txtTop: 'ddp-valign-top',
                  txtMiddle: 'ddp-valign-middle',
                  txtBottom: 'ddp-valign-bottom',
                  resizeHandle: 'pivot-resizable-handle',
                  axisXSort: 'pivot-axis-x-sort',
                }),
                (n.setStyleVerticalCells = function (t, e, n) {
                  var r = t.attr('data-parent-vals'),
                    s = t.attr('title'),
                    i = r ? r + '||' + s : s;
                  e.find('[data-parent-vals^="' + i + '"]').addClass(n);
                }),
                (n.setStyleHorizontalCells = function (t, e, n) {
                  var s = this._settings.cellHeight,
                    i = t.parent().prevAll().length,
                    o = i + t.css('height').replace(r.__regexpText, '') / s,
                    a = t.css('height').replace(r.__regexpText, '') / s;
                  t.nextAll().each(function (t, e) {
                    for (var i = $(e), o = i.attr('data-key'), l = a; 0 < l && 0 < i.length; ) {
                      i.addClass(n);
                      var u = i.css('height').replace(r.__regexpText, '') / s;
                      (l -= u), (i = i.parent());
                      for (var c = 0; c < u; c++) i = i.next();
                      i = i.find("[data-key='" + o + "']");
                    }
                  });
                  for (var l = i; l < o; l++) e.eq(l).addClass(n);
                }),
                (n.setClickStyle = function () {
                  var t = this,
                    e = n.cssClass.bodySelected,
                    s = n.cssClass.axisSelected,
                    i = n.cssClass.axisSelectedBody,
                    o = n.cssClass.axisDisable,
                    a = $(this._element);
                  a.find('.' + i).removeClass(i),
                    a.find('.' + s).removeClass(s),
                    a.find('.' + o).removeClass(o),
                    a.find('.' + e).removeClass(e),
                    a.find('[data-selected]').removeAttr('data-selected');
                  var l = a.find('.' + n.cssClass.body + ' .' + n.cssClass.bodyWrap + ' .' + n.cssClass.bodyRow),
                    u = a.find('.' + n.cssClass.head),
                    c = a.find('.' + n.cssClass.bodyFrozen);
                  function f(t, e, n) {
                    var r = $(e),
                      s = !0;
                    if (n.data === r.text() && n.key === r.attr('data-key')) {
                      if (r.is('[data-parent-keys]'))
                        for (
                          var i = r.attr('data-parent-keys').split('||'),
                            o = r.attr('data-parent-vals').split('||'),
                            a = 0,
                            l = i.length;
                          a < l;
                          a++
                        )
                          if (o[a] !== n.parentData[i[a]]) {
                            s = !1;
                            break;
                          }
                    } else s = !1;
                    return s;
                  }
                  if (
                    (this._settings.useSelectStyle && a.find('[data-disabled=Y]').addClass(o),
                    r.SELECT_MODE.MULTI === this._settings.axisSelectMode)
                  ) {
                    for (
                      var h = function () {
                          var e = t._axisDataset[d],
                            r = u.find('.' + n.cssClass.headCell).filter(function (t, n) {
                              return f(0, n, e);
                            });
                          0 < r.length &&
                            (r.attr('data-selected', 'Y'),
                            t._settings.useSelectStyle && (r.addClass(s), n.setStyleVerticalCells.apply(t, [r, l, i])));
                        },
                        d = 0,
                        _ = t._axisDataset.length;
                      d < _;
                      d++
                    )
                      h();
                    for (
                      var g = function () {
                          var e = t._axisDataset[p],
                            r = c.find('.' + n.cssClass.bodyCell).filter(function (t, n) {
                              return f(0, n, e);
                            });
                          0 < r.length &&
                            (r.attr('data-selected', 'Y'),
                            t._settings.useSelectStyle &&
                              (r.addClass(s), n.setStyleHorizontalCells.apply(t, [r, l, i])));
                        },
                        p = 0,
                        m = t._axisDataset.length;
                      p < m;
                      p++
                    )
                      g();
                  } else if ('X' === this._selectedAxis)
                    for (
                      var v = function () {
                          var e = t._axisDataset[y],
                            r = u.find('.' + n.cssClass.headCell).filter(function (t, n) {
                              return f(0, n, e);
                            });
                          0 < r.length &&
                            (r.attr('data-selected', 'Y'),
                            t._settings.useSelectStyle && (r.addClass(s), n.setStyleVerticalCells.apply(t, [r, l, i])));
                        },
                        y = 0,
                        C = t._axisDataset.length;
                      y < C;
                      y++
                    )
                      v();
                  else if ('Y' === this._selectedAxis)
                    for (
                      var b = function () {
                          var e = t._axisDataset[x],
                            r = c.find('.' + n.cssClass.bodyCell).filter(function (t, n) {
                              return f(0, n, e);
                            });
                          0 < r.length &&
                            (r.attr('data-selected', 'Y'),
                            t._settings.useSelectStyle &&
                              (r.addClass(s), n.setStyleHorizontalCells.apply(t, [r, l, i])));
                        },
                        x = 0,
                        T = t._axisDataset.length;
                      x < T;
                      x++
                    )
                      b();
                  for (
                    var O = this._settings.zProperties,
                      S = a.find('.' + n.cssClass.body + ' .' + n.cssClass.bodyWrap),
                      w = 0,
                      A = this._items.length;
                    w < A;
                    w++
                  )
                    for (var L = this._items[w], E = 0, P = O.length; E < P; E++) {
                      var k = O[E].name;
                      L.selectInfo &&
                        L.selectInfo[k] &&
                        S.find('.' + n.cssClass.bodyCell + '[data-idx=' + w + '][data-key="' + k + '"]').addClass(e);
                    }
                  for (
                    var D = r.DATA_COL_MODE.LEFT === this._settings.dataColumnMode ? 1 : 0,
                      I = r.DATA_COL_MODE.TOP === this._settings.dataColumnMode ? 1 : 0,
                      M = D * this._xItems.length + I * this._xItems.length * this._settings.zProperties.length,
                      F = I * this._yItems.length + D * this._yItems.length * this._settings.zProperties.length,
                      W = 0;
                    W < M;
                    W++
                  )
                    for (var N = 0; N < F; N++)
                      this._bodyCellSelectInfo[W][N] &&
                        (S.find('[data-rowIdx=' + N + ']').addClass(i),
                        S.find('[data-colIdx=' + W + ']').addClass(i),
                        u.find('[data-colIdx=' + W + ']').addClass(i),
                        c.find('[data-rowIdx=' + N + ']').addClass(i));
                }),
                (n.getSelectedAxisData = function (e, s, i, o) {
                  var a = null,
                    l = e.attr('data-key'),
                    u = e.attr('title'),
                    c = !1;
                  if (
                    t.isEmpty(
                      t.find(this._settings.zProperties, function (e) {
                        return t.eq(e.name, u);
                      }),
                    )
                  ) {
                    var f = {},
                      h = !1;
                    if (e.is('[data-parent-keys]')) {
                      h = !0;
                      for (
                        var d = e.attr('data-parent-keys').split('||'),
                          _ = e.attr('data-parent-vals').split('||'),
                          g = 0,
                          p = d.length;
                        g < p;
                        g++
                      )
                        f[d[g]] = _[g];
                    }
                    if (
                      (r.SELECT_MODE.SINGLE === this._settings.axisSelectMode &&
                        s !== this._selectedAxis &&
                        (this._axisDataset = []),
                      (this._selectedAxis = s),
                      'Y' === e.attr('data-selected'))
                    ) {
                      c = !1;
                      for (var m = -1, v = 0, y = this._axisDataset.length; v < y; v++) {
                        var C = this._axisDataset[v];
                        if (C.data === u && t.isMatch(C.parentData, f)) {
                          m = v;
                          break;
                        }
                      }
                      -1 < m && this._axisDataset.splice(m, 1);
                    } else {
                      c = !0;
                      for (var b = !1, x = 0, T = this._axisDataset.length; x < T; x++) {
                        var O = this._axisDataset[x];
                        if (O.data === u && t.isMatch(O.parentData, f)) {
                          b = !0;
                          break;
                        }
                      }
                      b || this._axisDataset.push({ key: l, data: u, parentData: h ? f : null });
                    }
                    return (
                      r.SELECT_MODE.ONESIDE === this._settings.axisSelectMode &&
                        (0 < this._axisDataset.length
                          ? ((this._selectedAxis = s), o.attr('data-disabled', 'Y'))
                          : ((this._axisDataset = []), (this._selectedAxis = null), o.removeAttr('data-disabled'))),
                      (a = this._settings.cumulativeClick
                        ? { selectData: this._axisDataset }
                        : { key: l, data: u, isSelect: c, parentData: h ? f : null }),
                      n.setClickStyle.apply(this),
                      a
                    );
                  }
                }),
                e
              );
            })(a));
        !(function (t) {
          var n = t.ui,
            r = void 0,
            i = n.pivot || (n.pivot = {}),
            o = n.common,
            a = n.style;
          i.Viewer = (function () {
            function t(e) {
              var n = this;
              (this._itemsContext = {}),
                (this._itemsRange = {}),
                (this._element = e),
                o.addCssClass(this._element, a.cssClass.container),
                (this._elementHead = document.createElement('div')),
                o.addCssClass(this._elementHead, a.cssClass.head),
                (this._elementHeadWrap = document.createElement('div')),
                o.addCssClass(this._elementHeadWrap, a.cssClass.headWrap),
                (this._elementHeadFrozen = document.createElement('div')),
                o.addCssClass(this._elementHeadFrozen, a.cssClass.headFrozen),
                (this._elementHeadCalculatedColumn = document.createElement('div')),
                o.addCssClass(this._elementHeadCalculatedColumn, a.cssClass.headFrozen),
                (this._elementBody = document.createElement('div')),
                o.addCssClass(this._elementBody, a.cssClass.body),
                (this._elementBodyWrap = document.createElement('div')),
                o.addCssClass(this._elementBodyWrap, a.cssClass.bodyWrap),
                (this._elementBodyFrozen = document.createElement('div')),
                o.addCssClass(this._elementBodyFrozen, a.cssClass.bodyFrozen),
                (this._elementBodyCalculatedColumn = document.createElement('div')),
                o.addCssClass(this._elementBodyCalculatedColumn, a.cssClass.bodyFrozen),
                (this._elementBodyScrollListener = function (t) {
                  return n.onScroll(t);
                }),
                this._elementBody.addEventListener('scroll', this._elementBodyScrollListener, !1),
                (this._scrollTop = 0),
                (this._scrollTopMax = 0),
                (this._scrollLeft = 0),
                (this._scrollLeftMax = 0),
                (this._scrollVertical = !1),
                (this._scrollHorizontal = !1),
                (this.SELECT_MODE = t.SELECT_MODE),
                (this.DATA_COL_MODE = t.DATA_COL_MODE),
                (this.IS_FILL_WIDTH = !0);
              var s,
                i,
                l,
                u = navigator.userAgent.toLowerCase();
              (this.isIE =
                ('Netscape' === navigator.appName && -1 !== u.indexOf('trident')) || -1 !== u.indexOf('msie')),
                r ||
                  (((s = document.createElement('DIV')).style.width = '200px'),
                  (s.style.height = '200px'),
                  ((i = document.createElement('DIV')).style.visibility = 'hidden'),
                  (i.style.width = '100px'),
                  (i.style.height = '100px'),
                  (i.style.overflow = 'scroll'),
                  (i.style.msOverflowStyle = 'scrollbar'),
                  i.appendChild(s),
                  document.body.appendChild(i),
                  (l = i.offsetWidth - i.clientWidth),
                  i.parentNode.removeChild(i),
                  (r = l)),
                t.instances.push(this);
            }
            function n(t) {
              var e = void 0;
              for (var n in t)
                if (t.hasOwnProperty(n) && 'TOTAL' === t[n]) {
                  e = n;
                  break;
                }
              return e;
            }
            function i(t, e) {
              if ('TOP' === e) {
                var n = [];
                for (var r in t) t.hasOwnProperty(r) && 'SUB-TOTAL' === t[r] && n.push(r);
                return n;
              }
              var s = void 0;
              for (var i in t)
                if (t.hasOwnProperty(i) && 'SUB-TOTAL' === t[i]) {
                  s = i;
                  break;
                }
              return s;
            }
            function l(t) {
              return '$$empty$$' === t ? '' : t;
            }
            return (
              (t.instances = []),
              (t.SELECT_MODE = o.SELECT_MODE),
              (t.DATA_COL_MODE = o.DATA_COL_MODE),
              (t.SORT_COL_MODE = o.SORT_COL_MODE),
              (t.FROZEN_COLUMN_ADDITIONAL_KEY = 'additional'),
              (t.SHOW_CALCULATED_COLUMN_WIDTH = 120),
              (t.COLUMN_WIDTH_MIN = 17),
              (t.EMPTY_Y_AXIS_DIMENSION_KEY = 'empty_y_axis_dimension'),
              (t.prototype.initialize = function (n, i) {
                var l = this,
                  u = this,
                  c = JSON.parse(JSON.stringify(n));
                for (var f in ((this._settings = {
                  xProperties: null,
                  yProperties: null,
                  zProperties: null,
                  cellWidth: 100,
                  cellHeight: 24,
                  leftAxisWidth: null,
                  columnWidth: {},
                  cumulativeClick: !1,
                  axisSelectMode: t.SELECT_MODE.ONESIDE,
                  useSelectStyle: !0,
                  onAxisXClick: void 0,
                  onAxisYClick: void 0,
                  onAxisZClick: void 0,
                  onBodyCellClick: void 0,
                  dataColumnMode: t.DATA_COL_MODE.LEFT,
                  yAxisAutoSort: !1,
                  yAxisSort: !1,
                  sortColumnParentKeys: null,
                  sortColumnParentVals: null,
                  sortColumnMeasure: null,
                  sortType: 'NONE',
                  header: {
                    showHeader: !0,
                    align: { hAlign: 'auto', vAlign: 'center' },
                    font: { size: 13, color: '', styles: [] },
                    backgroundColor: '',
                  },
                  body: {
                    showAxisZ: !1,
                    align: { hAlign: 'auto', vAlign: 'center' },
                    font: { size: 13, styles: [] },
                    color: {
                      showColorStep: !0,
                      stepColors: [
                        '#a1e1f8',
                        '#89cdeb',
                        '#59a4d2',
                        '#418fc5',
                        '#297bb8',
                        '#246ea5',
                        '#1e6191',
                        '#19537e',
                        '#13466b',
                      ],
                      stepTextColors: [
                        '#297bb8',
                        '#297bb8',
                        '#FFFFFF',
                        '#FFFFFF',
                        '#FFFFFF',
                        '#FFFFFF',
                        '#FFFFFF',
                        '#FFFFFF',
                        '#FFFFFF',
                      ],
                      stepRangeColors: [],
                      measureCellColors: [],
                      colorTarget: 'TEXT',
                    },
                  },
                  remark: { pos: '', label: '' },
                  measureFormat: {},
                  format: {
                    abbr: '',
                    decimal: 0,
                    type: '',
                    sign: '',
                    useThousandsSep: !1,
                    customSymbol: { value: '', pos: '' },
                  },
                }),
                i.isSelectOneSideAxis || (this._settings.axisSelectMode = t.SELECT_MODE.SINGLE),
                i.body && i.body.showAxisZ && (this._settings.dataColumnMode = t.DATA_COL_MODE.LEFT),
                i))
                  i.hasOwnProperty(f) && (this._settings[f] = i[f]);
                if (
                  (this._settings.leftAxisWidth || (this._settings.leftAxisWidth = this._settings.cellWidth),
                  0 === this._settings.zProperties.length &&
                    this._settings.zProperties.push({ name: 'COUNT(__count)' }),
                  (this._pivotData = c),
                  (this._isPivot = !0),
                  (this._items = []),
                  (this._itemsContext = {}),
                  (this._xItems = []),
                  (this._yItems = []),
                  (this._dataCriteria = {}),
                  (this._rangeDataCriteria = {}),
                  (this._leafColumnWidth = {}),
                  (this._leafFrozenColumnWidth = {}),
                  (this._leafCalculatedColumnWidth = {}),
                  (this._axisDataset = []),
                  (this._selectedAxis = null),
                  (this._xAxisGroup = {}),
                  (this._yAxisGroup = {}),
                  (this._bodyCellSelectInfo = {}),
                  c.rows && 0 < c.rows.length)
                )
                  if (this._settings.subCalcCellStyle) {
                    var h = Object.keys(this._settings.subCalcCellStyle).map(function (t) {
                        return t.toLowerCase();
                      }),
                      d = this._settings.xProperties.map(function (t) {
                        return t.name.toLowerCase();
                      }),
                      g = this._settings.yProperties.map(function (t) {
                        return t.name.toLowerCase();
                      });
                    if (
                      this._settings.dataColumnMode === t.DATA_COL_MODE.LEFT ||
                      (this._settings.dataColumnMode === t.DATA_COL_MODE.TOP && h.includes.apply(h, s(g)))
                    ) {
                      for (
                        var p = this._settings.yProperties.map(function (t) {
                            return l._settings.subCalcCellStyle[t.name.toLowerCase()];
                          }),
                          m = c.rows.map(function (t) {
                            return t.split('―');
                          }),
                          v = m[0],
                          y = 0,
                          C = m.length;
                        y < C;
                        y++
                      ) {
                        for (var b = m[y], x = p.length - 1; x >= 0; x--)
                          if (p[x] && v.slice(0, x).join('>') !== b.slice(0, x).join('>')) {
                            var T = m.slice(0, y),
                              O = m.slice(y, m.length),
                              S = [].concat(v.slice(0, x));
                            S.push('SUB-TOTAL'),
                              T.push(S),
                              C !== (m = T.concat(O)).length && ((y += m.length - C), (C = m.length));
                          }
                        v = m[y];
                      }
                      if ('TOTAL' !== v[0])
                        for (var w = p.length - 1; w >= 0; w--)
                          if (p[w]) {
                            var A = m,
                              L = [].concat(v.slice(0, w));
                            0 < L.length && (L.push('SUB-TOTAL'), A.push(L), (m = [].concat(A)));
                          }
                      (c.rows = m.map(function (t) {
                        return t.join(o.__fieldSeparator);
                      })),
                        c.columns.forEach(function (t) {
                          c.rows.forEach(function (e, n) {
                            if (-1 < e.indexOf('SUB-TOTAL')) {
                              for (
                                var r = e.split(o.__fieldSeparator),
                                  s = r.slice(0, r.length - 1).join(o.__fieldSeparator),
                                  i = [],
                                  a = n - 1;
                                a >= 0 && 0 === c.rows[a].indexOf(s);
                                a--
                              )
                                -1 < c.rows[a].indexOf('SUB-TOTAL') || i.push(t.value[a]);
                              var u = t.value.slice(0, n),
                                f = t.value.slice(n, t.value.length);
                              u.push(l.getSummaryValue(i, p[r.length - 2])),
                                (t.value = u.concat(f)),
                                n > t.seriesName.length
                                  ? t.seriesName.push(t.seriesName.slice(-1)[0].split('―')[0] + '―SUB-TOTAL')
                                  : t.seriesName.splice(n, 0, e.split(o.__fieldSeparator).join('―'));
                            }
                          });
                        });
                    }
                    if (
                      this._settings.dataColumnMode === t.DATA_COL_MODE.TOP ||
                      (this._settings.dataColumnMode === t.DATA_COL_MODE.LEFT && h.includes.apply(h, s(d)))
                    ) {
                      var E = this._settings.xProperties
                          .map(function (t) {
                            return l._settings.subCalcCellStyle[t.name.toLowerCase()];
                          })
                          .filter(function (t) {
                            return void 0 !== t;
                          }),
                        P = c.rows.map(function (t) {
                          return t.split('―');
                        }),
                        k = c.columns;
                      k.filter(function (t) {
                        return t.name.indexOf('TOTAL') > 0;
                      }).length > 0 &&
                        ((k = k.filter(function (t) {
                          return t.name.indexOf('TOTAL') < 0;
                        })),
                        k.forEach(function (t) {
                          t.name = t.name.split(o.__fieldSeparator).join('―');
                        }));
                      for (var D = k[0], I = 0, M = k.length; I < M; I++) {
                        for (var F = k[I], W = E.length - 1; W >= 0; W--)
                          if (
                            E[W] &&
                            D.name.split('―').slice(0, W).join('>') !== F.name.split('―').slice(0, W).join('>')
                          ) {
                            for (
                              var N = k.slice(0, I), j = k.slice(I, k.length), z = 0;
                              z < this._settings.zProperties.length;
                              z++
                            ) {
                              var B = _.cloneDeep(N.slice(-1)[0]);
                              B.name = D.name.split('―').slice(0, W).join('―');
                              for (var H = 0; H < this._settings.xProperties.length - W; H++) B.name += '―SUB-TOTAL';
                              (B.name += '―' + this._settings.zProperties[z].name),
                                B.value.fill(null),
                                B.seriesValue.fill(null),
                                N.push(B);
                            }
                            M !== (k = N.concat(j)).length && ((I += k.length - M), (M = k.length));
                          }
                        D = k[I];
                      }
                      if (D.name.indexOf('TOTAL') < 0)
                        for (var R = E.length - 1; R > 0; R--)
                          if (E[R])
                            for (var U = 0; U < this._settings.zProperties.length; U++) {
                              var V = _.cloneDeep(D);
                              V.name = D.name.split('―').slice(0, R).join('―');
                              for (var Y = 0; Y < this._settings.xProperties.length - R; Y++) V.name += '―SUB-TOTAL';
                              (V.name += '―' + this._settings.zProperties[U].name),
                                V.value.fill(null),
                                V.seriesValue.fill(null),
                                k.push(V);
                            }
                      (c.rows = P.map(function (t) {
                        return t.join(o.__fieldSeparator);
                      })),
                        (c.columns = k),
                        c.columns.forEach(function (t, e) {
                          if (-1 < t.name.indexOf('SUB-TOTAL')) {
                            var n = t.name.split('―'),
                              r = n.slice(0, n.indexOf('SUB-TOTAL')).join('―'),
                              s = n.slice(-1).join(''),
                              i = c.columns.filter(function (t) {
                                return (
                                  t &&
                                  t.name.indexOf(r) > -1 &&
                                  t.name.indexOf(s) > -1 &&
                                  t.name.indexOf('SUB-TOTAL') < 0
                                );
                              });
                            t.value.forEach(function (e, r) {
                              var s = [];
                              i.forEach(function (t) {
                                t.value[r] && s.push(t.value[r]);
                              }),
                                (t.value[r] = l.getSummaryValue(s, E[n.length - 2]));
                            });
                          }
                        });
                    }
                  } else
                    c.rows = c.rows.map(function (t) {
                      return t.split('―').join(o.__fieldSeparator);
                    });
                c.columns &&
                  0 < c.columns.length &&
                  c.columns.forEach(function (t) {
                    t.name = t.name.split('―').join(o.__fieldSeparator);
                  }),
                  (this.summaryMap = {});
                var K = this._settings.min ? this._settings.min : 0,
                  X = this._settings.max ? this._settings.max : 0,
                  G = this._settings.zProperties,
                  Z =
                    this._settings.body.color && this._settings.body.color.showColorStep
                      ? this._settings.body.color.showColorStep
                      : null,
                  q = 0,
                  J = 0;
                if (c.columns)
                  (q = this._settings.zProperties.filter(function (t) {
                    return (
                      t.fieldFormat &&
                      t.fieldFormat.font &&
                      t.fieldFormat.font.rangeColor &&
                      t.fieldFormat.font.rangeColor.length > 0
                    );
                  }).length),
                    (J = this._settings.zProperties.filter(function (t) {
                      return (
                        t.fieldFormat &&
                        t.fieldFormat.rangeBackgroundColor &&
                        t.fieldFormat.rangeBackgroundColor.length > 0
                      );
                    }).length);
                else if (G.length > 0 && G[0].fieldFormat && G[0].fieldFormat.length > 0) {
                  var Q = G[0].fieldFormat;
                  (q = Q.filter(function (t) {
                    return t.font && t.font.rangeColor && t.font.rangeColor.length > 0;
                  }).length),
                    (J = Q.filter(function (t) {
                      return t.rangeBackgroundColor && t.rangeBackgroundColor.length > 0;
                    }).length);
                }
                if (G) {
                  if (Z) {
                    var tt,
                      et = this._settings.body.color.stepColors,
                      nt = ['#000000'],
                      rt = this._settings.body.color.measureCellColors;
                    rt && rt.length && delete this._settings.body.color.stepRangeColors,
                      G.forEach(function (t, n) {
                        (tt = rt && rt.length ? rt[n] : nt),
                          (u._dataCriteria[t.name] = {
                            max: X,
                            min: K,
                            range: 0,
                            step: et && et.length > 0 ? et.length : nt.length,
                            color: et,
                            textColor: tt,
                            getStep: function (t) {
                              var e = 0 === this.range ? this.range : Math.floor((t - this.min) / this.range);
                              return this.step <= e && (e = this.step - 1), e;
                            },
                            getTextColor: function (t) {
                              return this.textColor ? this.textColor[this.getStep(t)] : null;
                            },
                            getColor: function (t) {
                              return this.color ? this.color[this.getStep(t)] : null;
                            },
                            getMeasureColors: function () {
                              if (rt) return rt[n];
                            },
                            getUserRangeColor: function (t, n) {
                              var r,
                                s = '',
                                i = e(n);
                              try {
                                for (i.s(); !(r = i.n()).done; ) {
                                  var o = r.value;
                                  if (o.min <= t && o.max >= t) {
                                    s = o.color;
                                    break;
                                  }
                                }
                              } catch (t) {
                                i.e(t);
                              } finally {
                                i.f();
                              }
                              return '' === s && (s = '#3c4950'), s;
                            },
                          });
                      });
                  }
                  (q || J) &&
                    (!c.columns && G.length > 0 && G[0].fieldFormat.length > 0 && (G = G[0].fieldFormat),
                    G.forEach(function (t) {
                      var n = [],
                        r = [];
                      c.columns
                        ? t.fieldFormat &&
                          ('TEXT' === u._settings.body.color.colorTarget
                            ? (r =
                                t.fieldFormat.font && t.fieldFormat.font.rangeColor
                                  ? t.fieldFormat.font.rangeColor
                                  : [])
                            : (n = t.fieldFormat.rangeBackgroundColor ? t.fieldFormat.rangeBackgroundColor : []))
                        : 'TEXT' === u._settings.body.color.colorTarget
                          ? (r = t.font && t.font.rangeColor ? t.font.rangeColor : [])
                          : (n = t.rangeBackgroundColor ? t.rangeBackgroundColor : []),
                        (u._rangeDataCriteria[c.columns ? t.name : t.aggrColumn] = {
                          max: X,
                          min: K,
                          range: 0,
                          step: n && n.length > 0 ? n.length : r.length,
                          color: n,
                          textColor: r,
                          measureCellColors: rt,
                          getStep: function (t) {
                            var e = 0 === this.range ? this.range : Math.floor((t - this.min) / this.range);
                            return this.step <= e && (e = this.step - 1), e;
                          },
                          getTextColor: function (t) {
                            return this.textColor ? this.textColor[this.getStep(t)] : null;
                          },
                          getColor: function (t) {
                            return this.color ? this.color[this.getStep(t)] : null;
                          },
                          getUserRangeColor: function (t, n) {
                            var r,
                              s = '',
                              i = e(n);
                            try {
                              for (i.s(); !(r = i.n()).done; ) {
                                var o = r.value;
                                if (o.gt <= t && o.lte >= t) {
                                  s = o.color;
                                  break;
                                }
                              }
                            } catch (t) {
                              i.e(t);
                            } finally {
                              i.f();
                            }
                            return '' === s && (s = '#3c4950'), s;
                          },
                        });
                    }));
                }
                if (((this._isPivot = !!c.columns), this._isPivot)) {
                  var st = G.length,
                    it = this._settings.xProperties,
                    ot = this._settings.yProperties,
                    at = this._settings.zProperties;
                  c.columns.forEach(function (n, r) {
                    var s = n.name ? n.name.split(o.__fieldSeparator) : [''];
                    u._settings.showCalculatedColumnStyle &&
                      n.name.indexOf('SUB-TOTAL') < 0 &&
                      t.prototype.appendCalculatedColumnDataToSummaryMap(
                        n,
                        u.summaryMap,
                        u._settings.zProperties,
                        u._settings.dataColumnMode,
                      ),
                      r % st == 0 &&
                        n.value.forEach(function (t, n) {
                          for (
                            var i = u._itemsContext,
                              a = u._xAxisGroup,
                              l = u._yAxisGroup,
                              f = {},
                              h = [],
                              d = [],
                              _ = 0,
                              g = it.length;
                            _ < g;
                            _++
                          ) {
                            var p = it[_].name,
                              m = s[_];
                            '' === m && (m = '$$empty$$'),
                              (f[p] = m),
                              h.push(m),
                              i.hasOwnProperty(m) || (i[m] = {}),
                              (i = i[m]),
                              a.hasOwnProperty(m) || (a[m] = {}),
                              (a = a[m]);
                          }
                          for (
                            var v = c.rows[n] ? c.rows[n].split(o.__fieldSeparator) : [''], y = 0, C = ot.length;
                            y < C;
                            y++
                          ) {
                            var b = ot[y].name,
                              x = v[y];
                            (f[b] = x),
                              i.hasOwnProperty(x) || (i[x] = {}),
                              (i = i[x]),
                              l.hasOwnProperty(x) || (l[x] = {}),
                              (l = l[x]),
                              d.push[x];
                          }
                          for (var T = 0, O = at.length; T < O; T++) {
                            var S = at[T].name;
                            if (c.columns.length <= r + T) return;
                            var w = c.columns[r + T].value[n];
                            f[S] = 'number' == typeof w ? w : w || null;
                            var A = 0 < h.length ? h.join('||') + '||' + S : S;
                            u.summaryMap[A] || (u.summaryMap[A] = []), 'number' == typeof w && u.summaryMap[A].push(w);
                          }
                          if ((a.item || u._xItems.push((a.item = f)), !l.item))
                            if (u._settings.yAxisSort) {
                              var L = u._settings.sortColumnParentKeys.split(o.__fieldSeparator),
                                E = u._settings.sortColumnParentVals.split(o.__fieldSeparator);
                              if (L.join('').trim().length > 0) {
                                var P,
                                  k = !1,
                                  D = e(L);
                                try {
                                  for (D.s(); !(P = D.n()).done; ) {
                                    var I = P.value;
                                    if (!(k = f.hasOwnProperty(I) && E.indexOf(f[I]) > -1)) break;
                                  }
                                } catch (t) {
                                  D.e(t);
                                } finally {
                                  D.f();
                                }
                                k && u._yItems.push((l.item = f));
                              } else u._yItems.push((l.item = f));
                            } else u._yItems.push((l.item = f));
                          if ((u._items.push(f), (i.item = f), Z))
                            for (var M in f) {
                              var F = u._dataCriteria[M];
                              if (F && f.hasOwnProperty(M)) {
                                var W = f[M];
                                (F.min = W < F.min ? W : F.min), (F.max = W > F.max ? W : F.max);
                              }
                            }
                          if ((q || J) && (q || J))
                            for (var N in f) {
                              var j = u._rangeDataCriteria[N];
                              if (j && f.hasOwnProperty(N)) {
                                var z = f[N];
                                (j.min = z < j.min ? z : j.min), (j.max = z > j.max ? z : j.max);
                              }
                            }
                        });
                  });
                } else
                  c.forEach(function (t) {
                    for (
                      var n = u._itemsContext,
                        r = u._settings.xProperties,
                        s = u._settings.yProperties,
                        i = u._xAxisGroup,
                        a = u._yAxisGroup,
                        l = 0,
                        c = r.length;
                      l < c;
                      l++
                    ) {
                      var f = t[r[l].name];
                      n.hasOwnProperty(f) || (n[f] = {}), (n = n[f]), i.hasOwnProperty(f) || (i[f] = {}), (i = i[f]);
                    }
                    i.item || u._xItems.push((i.item = t));
                    for (var h = 0, d = s.length; h < d; h++) {
                      var _ = t[s[h].name];
                      n.hasOwnProperty(_) || (n[_] = {}), (n = n[_]), a.hasOwnProperty(_) || (a[_] = {}), (a = a[_]);
                    }
                    if (!a.item)
                      if (u._settings.yAxisSort) {
                        var g = u._settings.sortColumnParentKeys.split(o.__fieldSeparator),
                          p = u._settings.sortColumnParentVals.split(o.__fieldSeparator);
                        if (g.join('').trim().length > 0) {
                          var m,
                            v = !1,
                            y = e(g);
                          try {
                            for (y.s(); !(m = y.n()).done; ) {
                              var C = m.value;
                              if (!(v = t.hasOwnProperty(C) && p.indexOf(t[C]) > -1)) break;
                            }
                          } catch (t) {
                            y.e(t);
                          } finally {
                            y.f();
                          }
                          v && u._yItems.push((a.item = t));
                        } else u._yItems.push((a.item = t));
                      } else u._yItems.push((a.item = t));
                    if (((n.item = t), Z))
                      for (var b in t) {
                        var x = u._dataCriteria[b];
                        if (x && t.hasOwnProperty(b)) {
                          var T = t[b];
                          (x.min = T < x.min ? T : x.min), (x.max = T > x.max ? T : x.max);
                        }
                      }
                    if (q || J)
                      for (var O in t) {
                        var S = u._rangeDataCriteria[O];
                        if (S && t.hasOwnProperty(O)) {
                          var w = t[O];
                          (S.min = w < S.min ? w : S.min), (S.max = w > S.max ? w : S.max);
                        }
                      }
                  });
                u._settings.yAxisAutoSort &&
                  this._yItems.sort(function (t, e) {
                    var n = u._settings.yProperties,
                      r = 0;
                    try {
                      for (var s = 0, i = n.length; s < i; s++) {
                        var a = n[s].name,
                          l = t[a] ? t[a] : (t[a] = 'null'),
                          c = e[a] ? e[a] : (e[a] = 'null');
                        if (
                          ('number' === n[s].type &&
                            ((l = Number(t[a].replace(o.__regexpText, ''))),
                            (c = Number(e[a].replace(o.__regexpText, '')))),
                          l < c)
                        ) {
                          r = -1;
                          break;
                        }
                        if (l > c) {
                          r = 1;
                          break;
                        }
                      }
                    } catch (t) {
                      console.error(t);
                    }
                    return r;
                  }),
                  u._settings.yAxisSort &&
                    this._yItems.sort(function (e, n) {
                      var r = 0;
                      try {
                        var s = u._settings.sortColumnMeasure,
                          i = e[s] ? e[s] : 0,
                          o = n[s] ? n[s] : 0;
                        i < o
                          ? (r = u._settings.sortType === t.SORT_COL_MODE.ASC ? -1 : 1)
                          : i > o && (r = u._settings.sortType === t.SORT_COL_MODE.ASC ? 1 : -1);
                      } catch (t) {
                        console.error(t);
                      }
                      return r;
                    });
                var lt,
                  ut = null,
                  ct = e(this._yItems);
                try {
                  for (ct.s(); !(lt = ct.n()).done; ) {
                    var ft,
                      ht = lt.value,
                      dt = e(this._settings.yProperties);
                    try {
                      for (dt.s(); !(ft = dt.n()).done; )
                        if ('TOTAL' === ht[ft.value.name]) {
                          ut = ht;
                          break;
                        }
                    } catch (t) {
                      dt.e(t);
                    } finally {
                      dt.f();
                    }
                  }
                } catch (t) {
                  ct.e(t);
                } finally {
                  ct.f();
                }
                if ((ut && (this._yItems.splice(this._yItems.indexOf(ut), 1), this._yItems.push(ut)), Z))
                  for (var _t in this._dataCriteria)
                    if (this._dataCriteria.hasOwnProperty(_t)) {
                      var gt = this._dataCriteria[_t];
                      gt.range = (gt.max - gt.min) / gt.step;
                    }
                if (q || J)
                  for (var pt in this._rangeDataCriteria)
                    if (this._rangeDataCriteria.hasOwnProperty(pt)) {
                      var mt = this._rangeDataCriteria[pt];
                      mt.range = (mt.max - mt.min) / mt.step;
                    }
                for (
                  var vt = t.DATA_COL_MODE.LEFT === this._settings.dataColumnMode ? 1 : 0,
                    yt = t.DATA_COL_MODE.TOP === this._settings.dataColumnMode ? 1 : 0,
                    Ct = vt * this._xItems.length + yt * this._xItems.length * this._settings.zProperties.length,
                    bt = yt * this._yItems.length + vt * this._yItems.length * this._settings.zProperties.length,
                    xt = 0;
                  xt < Ct;
                  xt++
                ) {
                  this._bodyCellSelectInfo[xt] = {};
                  for (var Tt = 0; Tt < bt; Tt++) this._bodyCellSelectInfo[xt][Tt] = !1;
                }
                (this._element.innerHTML = ''),
                  (this._elementHead.innerHTML = ''),
                  (this._elementHeadWrap.innerHTML = ''),
                  (this._elementHeadFrozen.innerHTML = ''),
                  (this._elementHeadCalculatedColumn.innerHTML = ''),
                  (this._elementBody.innerHTML = ''),
                  (this._elementBodyWrap.innerHTML = ''),
                  (this._elementBodyFrozen.innerHTML = ''),
                  (this._elementBodyCalculatedColumn.innerHTML = ''),
                  this._element.appendChild(this._elementHead),
                  this._element.appendChild(this._elementBody),
                  this._elementHead.appendChild(this._elementHeadFrozen),
                  this._elementHead.appendChild(this._elementHeadWrap),
                  this._elementBody.appendChild(this._elementBodyFrozen),
                  this._elementBody.appendChild(this._elementBodyWrap),
                  this.addRemark(this._settings.remark),
                  this._settings.showCalculatedColumnStyle &&
                    (this._elementHead.appendChild(this._elementHeadCalculatedColumn),
                    this._elementBody.appendChild(this._elementBodyCalculatedColumn));
                var Ot = {};
                this._xItems.forEach(function (e) {
                  var n = l._settings.xProperties.reduce(function (t, n) {
                    return (t = '' === t ? t : t + '||') + e[n.name];
                  }, '');
                  l._settings.dataColumnMode === t.DATA_COL_MODE.TOP
                    ? l._settings.zProperties.forEach(function (t) {
                        var e = '' !== n ? n + '||' + t.name : t.name;
                        void 0 === Ot[e] && (Ot[e] = l._settings.cellWidth);
                      })
                    : void 0 === Ot[n] && (Ot[n] = l._settings.cellWidth);
                }),
                  this._settings.yProperties
                    .map(function (t) {
                      return t.name;
                    })
                    .forEach(function (t) {
                      Ot[t] = l._settings.cellWidth;
                    }),
                  this._settings.showCalculatedColumnStyle &&
                    (this._settings.dataColumnMode === t.DATA_COL_MODE.TOP
                      ? this._settings.zProperties
                          .map(function (t) {
                            return t.name;
                          })
                          .forEach(function (e) {
                            Ot['TOTAL||' + e] = t.SHOW_CALCULATED_COLUMN_WIDTH;
                          })
                      : (Ot.TOTAL = t.SHOW_CALCULATED_COLUMN_WIDTH)),
                  this._settings.dataColumnMode === t.DATA_COL_MODE.LEFT &&
                    this._settings.body.showAxisZ &&
                    (Ot[t.FROZEN_COLUMN_ADDITIONAL_KEY + this._settings.yProperties.length] = this._settings.cellWidth);
                var St = Object.keys(this._settings.columnWidth),
                  wt = Object.keys(Ot);
                if (Object.keys(this._settings.columnWidth).length > 0 && St.sort().join('') === wt.sort().join('')) {
                  var At = this._settings.columnWidth,
                    Lt = Object.keys(At);
                  Lt.length > 0 &&
                    Lt.forEach(function (e) {
                      e &&
                      l._settings.yProperties.findIndex(function (t) {
                        return t.name === e;
                      }) < 0
                        ? l._settings.dataColumnMode === t.DATA_COL_MODE.LEFT
                          ? l._settings.body.showAxisZ &&
                            e === t.FROZEN_COLUMN_ADDITIONAL_KEY + l._settings.yProperties.length
                            ? (l._leafFrozenColumnWidth[e] = Number(At[e]))
                            : l._settings.showCalculatedColumnStyle && e && 'TOTAL' === e
                              ? (l._leafCalculatedColumnWidth[e] = Number(At[e]))
                              : (l._leafColumnWidth[e] = Number(At[e]))
                          : l._settings.dataColumnMode === t.DATA_COL_MODE.TOP &&
                            (l._settings.showCalculatedColumnStyle &&
                            e &&
                            l._settings.zProperties.findIndex(function (t) {
                              return 'TOTAL||' + t.name === e;
                            }) > -1
                              ? (l._leafCalculatedColumnWidth[e] = Number(At[e]))
                              : (l._leafColumnWidth[e] = Number(At[e])))
                        : e &&
                          l._settings.yProperties.findIndex(function (t) {
                            return t.name === e;
                          }) > -1 &&
                          (l._leafFrozenColumnWidth[e] = Number(At[e]));
                    });
                }
                this.arrange(), this._settings.header && this.showHeader(this._settings.header.showHeader);
                var Et = '.' + a.cssClass.axisX,
                  Pt = '.' + a.cssClass.axisY,
                  kt = '.' + a.cssClass.resizeHandle,
                  Dt = '.' + a.cssClass.body + ' .' + a.cssClass.bodyWrap + ' .' + a.cssClass.bodyCell,
                  It = $(this._element),
                  Mt = It.find('.' + a.cssClass.head),
                  Ft = It.find('.' + a.cssClass.bodyFrozen),
                  Wt = It.find('.' + a.cssClass.body + ' .' + a.cssClass.bodyWrap),
                  Nt = '.' + a.cssClass.axisXSort;
                $(this._element)
                  .off('mouseenter', Et)
                  .off('mouseleave', Et)
                  .off('click', Et)
                  .off('mouseenter', Pt)
                  .off('mouseleave', Pt)
                  .off('click', Pt)
                  .off('click', Dt)
                  .off('drag', kt)
                  .off('dragend', kt)
                  .on('mouseenter', Et, function () {
                    0 === $(this).closest('.' + a.cssClass.axisDisable).length &&
                      a.setStyleVerticalCells.apply(u, [
                        $(this),
                        Wt.find(' .' + a.cssClass.bodyRow),
                        a.cssClass.bodyHover,
                      ]);
                  })
                  .on('mouseleave', Et, function () {
                    It.find('.' + a.cssClass.bodyHover).removeClass(a.cssClass.bodyHover);
                  })
                  .on('mouseenter', Pt, function () {
                    0 === $(this).closest('.' + a.cssClass.axisDisable).length &&
                      a.setStyleHorizontalCells.apply(u, [
                        $(this),
                        Wt.find(' .' + a.cssClass.bodyRow),
                        a.cssClass.bodyHover,
                      ]);
                  })
                  .on('mouseleave', Pt, function () {
                    It.find('.' + a.cssClass.bodyHover).removeClass(a.cssClass.bodyHover);
                  })
                  .on('click', Et, function (t) {
                    if ('function' == typeof u._settings.onAxisXClick && 0 === Mt.filter('[data-disabled=Y]').length) {
                      var e = a.getSelectedAxisData.apply(u, [$(this), 'X', Mt, Ft]);
                      u._settings.onAxisXClick(e);
                    }
                  })
                  .on('click', Nt, function (e) {
                    if ((e.stopImmediatePropagation(), u._settings.subCalcCellStyle)) {
                      var n = Object.keys(u._settings.subCalcCellStyle).map(function (t) {
                          return t.toLowerCase();
                        }),
                        r = u._settings.xProperties.map(function (t) {
                          return t.name.toLowerCase();
                        }),
                        i = u._settings.yProperties.map(function (t) {
                          return t.name.toLowerCase();
                        });
                      if (n.includes.apply(n, s(r)) && n.includes.apply(n, s(i))) return;
                    }
                    var a = $(this).attr('title'),
                      l = $(this).attr('data-parent-keys'),
                      c = $(this).attr('data-parent-vals'),
                      f = $(this).attr('data-sort'),
                      h = u._settings.zProperties.length,
                      d = u._settings.subCalcCellStyle
                        ? u._settings.yProperties.filter(function (t) {
                            return u._settings.subCalcCellStyle[t.name.toLowerCase()];
                          }).length
                        : 0;
                    if (
                      ((u._settings.sortType =
                        f === t.SORT_COL_MODE.NONE
                          ? t.SORT_COL_MODE.ASC
                          : f === t.SORT_COL_MODE.ASC
                            ? t.SORT_COL_MODE.DESC
                            : t.SORT_COL_MODE.NONE),
                      (u._settings.yAxisSort = u._settings.sortType !== t.SORT_COL_MODE.NONE),
                      (u._settings.sortColumnParentKeys = l.split('||').join(o.__fieldSeparator)),
                      (u._settings.sortColumnParentVals = c.split('||').join(o.__fieldSeparator)),
                      u._isPivot && 'TOP' !== u._settings.dataColumnMode)
                    ) {
                      if ('LEFT' === u._settings.dataColumnMode && 1 === h && !d) {
                        u._settings.sortColumnMeasure = u._settings.zProperties[0].name;
                        var g = u._settings;
                        return (g.columnWidth = u.getLeafColumnWidth()), void u.update(g);
                      }
                    } else {
                      if (!u._isPivot) {
                        u._settings.sortColumnMeasure = u._settings.zProperties[0].name;
                        var p = u._pivotData,
                          m = u._settings;
                        return (m.columnWidth = u.getLeafColumnWidth()), void u.initialize(p, m);
                      }
                      if (!u._settings.body.showAxisZ) {
                        u._settings.sortColumnMeasure = 1 === h ? u._settings.zProperties[0].name : a;
                        var v = u._settings;
                        return (v.columnWidth = u.getLeafColumnWidth()), void u.update(v);
                      }
                      if (
                        u._settings.body.showAxisZ &&
                        !_.isEmpty(
                          _.find(u._settings.zProperties, function (t) {
                            return _.eq(t.name, a);
                          }),
                        )
                      ) {
                        u._settings.sortColumnMeasure = a;
                        var y = u._settings;
                        return (y.columnWidth = u.getLeafColumnWidth()), void u.update(y);
                      }
                    }
                  })
                  .on('click', Pt, function () {
                    if ('function' == typeof u._settings.onAxisYClick && 0 === Ft.filter('[data-disabled=Y]').length) {
                      var t = a.getSelectedAxisData.apply(u, [$(this), 'Y', Ft, Mt]);
                      u._settings.onAxisYClick(t);
                    }
                  })
                  .on('click', Dt, function (t) {
                    if ('function' == typeof u._settings.onBodyCellClick) {
                      var e = $(t.currentTarget),
                        n = {};
                      e.each(function () {
                        $.each(this.attributes, function () {
                          if (this.specified && -1 < this.name.indexOf('data-item'))
                            if (u._isPivot) {
                              var t = this.value ? this.value.split(o.__fieldSeparator) : [''];
                              n[t[0]] = t[1];
                            } else n[this.name.replace(/data-item-/gi, '')] = this.value;
                        });
                      });
                      var r = e.attr('data-key');
                      if (r) {
                        var s = e.attr('data-idx'),
                          i = e.attr('data-colIdx'),
                          l = e.attr('data-rowIdx'),
                          c = u._items[s];
                        if (!c) return;
                        if (u._isPivot && null == c[r]) return;
                        c.selectInfo || (c.selectInfo = {}),
                          c.selectInfo[r]
                            ? ((c.selectInfo[r] = !1), (n.isSelect = !1), (u._bodyCellSelectInfo[i][l] = !1))
                            : ((c.selectInfo[r] = !0), (n.isSelect = !0), (u._bodyCellSelectInfo[i][l] = !0)),
                          a.setClickStyle.apply(u),
                          u._settings.onBodyCellClick(n);
                      }
                    }
                  })
                  .on('drag', kt, function (t) {
                    t.stopPropagation();
                    var e =
                      1 * t.target.parentElement.style.width.replace(/px/gi, '') +
                      (u.isIE ? t.originalEvent.offsetX : t.originalEvent.layerX);
                    e >= 1 && (t.target.parentElement.style.width = e + 'px');
                  })
                  .on('dragend', kt, function (e) {
                    e.stopPropagation();
                    var n = $(e.target.parentElement),
                      s = n.attr('data-parent-vals'),
                      i = n.attr('title'),
                      o = s ? s + (i ? '||' + i : '') : i || '',
                      a = 1 * n.css('width').replace(/px/, ''),
                      l = 1 * n.attr('data-colidx'),
                      c = u.getColumnTextWidth(
                        u._leafCalculatedColumnWidth[o] ? i.split('||').slice(-1).join('') : i,
                        e.target.parentElement,
                      );
                    c > a && (a = Math.ceil(c)),
                      u._leafFrozenColumnWidth[o] && (u._leafFrozenColumnWidth[o] = a),
                      u._leafCalculatedColumnWidth[o] && (u._leafCalculatedColumnWidth[o] = a);
                    var f = Object.keys(u._leafColumnWidth),
                      h = f.reduce(function (t, e) {
                        return t + Number(u._leafColumnWidth[e]);
                      }, 0),
                      d = Object.keys(u._leafCalculatedColumnWidth),
                      _ = d.reduce(function (t, e) {
                        return t + Number(u._leafCalculatedColumnWidth[e]);
                      }, 0),
                      g =
                        1 * u._elementBody.style.width.replace(/px/gi, '') -
                        1 * u._elementBodyFrozen.style.width.replace(/px/gi, '') -
                        _ -
                        (u._scrollVertical && !u._scrollHorizontal ? r : 0);
                    if (g < h)
                      if ('TOTAL' !== i)
                        if (u._leafColumnWidth[o]) u._leafColumnWidth[o] = a;
                        else {
                          var p = f.filter(function (t) {
                            return -1 < t.indexOf(o + '||');
                          });
                          if (p && 0 < p.length) {
                            var m = a / p.length;
                            p.forEach(function (t) {
                              u._leafColumnWidth[t] = m;
                            });
                          }
                        }
                      else if (u._leafCalculatedColumnWidth[o]) u._leafCalculatedColumnWidth[o] = a;
                      else {
                        var v = d.filter(function (t) {
                          return -1 < t.indexOf(o + '||');
                        });
                        if (v && 0 < v.length) {
                          var y = a / v.length;
                          v.forEach(function (t) {
                            u._leafCalculatedColumnWidth[t] = y;
                          });
                        }
                      }
                    else if ('TOTAL' !== i) {
                      var C = Number(u._leafColumnWidth[f[0]]),
                        b = Number(u._leafColumnWidth[f.slice(-1).join('')]),
                        x = f.reduce(function (t, e) {
                          return t + (e !== o ? Number(u._leafColumnWidth[e]) : 0);
                        }, 0),
                        T = g - a - (l < f.length - 1 ? x - b : x - C);
                      if (
                        (u._leafColumnWidth[o] &&
                          (l < f.length - 1
                            ? (u._leafColumnWidth[f.slice(-1).join('')] = T)
                            : (u._leafColumnWidth[f[0]] = T)),
                        u._leafColumnWidth[o])
                      )
                        u._leafColumnWidth[o] = a;
                      else {
                        var O = f.filter(function (t) {
                          return -1 < t.indexOf(o + '||');
                        });
                        if (O && 0 < O.length) {
                          var S = a / O.length;
                          O.forEach(function (t) {
                            u._leafColumnWidth[t] = S;
                          });
                        }
                      }
                    } else if (u._leafCalculatedColumnWidth[o]) u._leafCalculatedColumnWidth[o] = a;
                    else {
                      var w = d.filter(function (t) {
                        return -1 < t.indexOf(o + '||');
                      });
                      if (w && 0 < w.length) {
                        var A = a / w.length;
                        w.forEach(function (t) {
                          u._leafCalculatedColumnWidth[t] = A;
                        });
                      }
                    }
                    t.DATA_COL_MODE.TOP === u._settings.dataColumnMode
                      ? u.renderDataToVertical(!0)
                      : u.renderDataToHorizontal(!0);
                  });
              }),
              (t.prototype.update = function (t) {
                var e = this._isPivot ? this._pivotData : this._items,
                  n = this._settings;
                for (var r in t) t.hasOwnProperty(r) && (n[r] = t[r]);
                this.initialize(e, n);
              }),
              (t.prototype.addClassFontStyle = function (t, n) {
                if (n) {
                  if (n.styles) {
                    var r,
                      s = e(n.styles);
                    try {
                      for (s.s(); !(r = s.n()).done; ) t = t + ' ddp-font-' + r.value.toLowerCase();
                    } catch (t) {
                      s.e(t);
                    } finally {
                      s.f();
                    }
                  }
                  0 < n.size && (t = t + ' ddp-font' + n.size);
                }
                return t;
              }),
              (t.prototype.addClassTextAlign = function (t, e, n) {
                if (e) {
                  var r = '';
                  switch (
                    (e.hAlign && (r = e.hAlign.toLowerCase()),
                    this.isDefaultTextAlign(e) && n && (r = n.toLowerCase()),
                    r)
                  ) {
                    case 'left':
                      t = t + ' ' + a.cssClass.txtLeft;
                      break;
                    case 'center':
                      t = t + ' ' + a.cssClass.txtCenter;
                      break;
                    case 'right':
                      t = t + ' ' + a.cssClass.txtRight;
                  }
                  if (e.vAlign)
                    switch (e.vAlign.toLowerCase()) {
                      case 'top':
                        t = t + ' ' + a.cssClass.txtTop;
                        break;
                      case 'middle':
                        t = t + ' ' + a.cssClass.txtMiddle;
                        break;
                      case 'bottom':
                        t = t + ' ' + a.cssClass.txtBottom;
                    }
                }
                return t;
              }),
              (t.prototype.isDefaultTextAlign = function (t) {
                return !t.hAlign || 'auto' === t.hAlign.toLowerCase() || 'default' === t.hAlign.toLowerCase();
              }),
              (t.prototype.getLineHeightForValign = function (t, e, n) {
                var r = e;
                if (t && t.hAlign)
                  switch (t.hAlign.toLowerCase()) {
                    case 'middle':
                      r = e;
                      break;
                    case 'bottom':
                      r = e + this._settings.cellHeight * (n / 2);
                      break;
                    default:
                      r = e - this._settings.cellHeight * (n / 2);
                  }
                return r;
              }),
              (t.prototype.showHeader = function (t) {
                t
                  ? (o.removeCssClass(this._elementHead, 'ddp-header-hide'),
                    o.removeCssClass(this._elementBody, 'header-none'),
                    o.removeCssClass(this._elementBodyFrozen, 'ddp-header-hide'),
                    o.removeCssClass(this._elementBodyWrap, 'header-none'))
                  : (o.addCssClass(this._elementHead, 'ddp-header-hide'),
                    o.addCssClass(this._elementBody, 'header-none'),
                    o.addCssClass(this._elementBodyFrozen, 'ddp-header-hide'),
                    o.addCssClass(this._elementBodyWrap, 'header-none'));
              }),
              (t.prototype.addRemark = function (t) {
                t &&
                  ((this._elementAnnotation = document.createElement('span')),
                  (this._elementAnnotation.innerHTML = t.label),
                  t.pos && -1 !== t.pos.toLowerCase().indexOf('top')
                    ? this._element.insertBefore(this._elementAnnotation, this._element.firstChild)
                    : this._element.appendChild(this._elementAnnotation),
                  t.pos && -1 !== t.pos.toLowerCase().indexOf('right')
                    ? o.addCssClass(this._elementAnnotation, 'remark-right')
                    : o.addCssClass(this._elementAnnotation, 'remark-left'));
              }),
              (t.prototype.arrange = function () {
                if (this._settings) {
                  for (
                    var e = this._isPivot ? this._settings.xProperties.length : 0,
                      n = this._settings.yProperties.length,
                      s = this._settings.zProperties.length,
                      i = this._settings.remark && '' !== this._settings.remark.pos ? 1 : 0,
                      a = this._settings.remark && -1 < this._settings.remark.pos.toLowerCase().indexOf('top') ? 1 : 0,
                      l = t.DATA_COL_MODE.LEFT === this._settings.dataColumnMode ? 1 : 0,
                      u = t.DATA_COL_MODE.TOP === this._settings.dataColumnMode ? 1 : 0,
                      c = this._settings.body.showAxisZ ? 1 : 0,
                      f = 30 * i,
                      h = this._settings.leftAxisWidth ? this._settings.leftAxisWidth : this._settings.cellWidth,
                      d = this._element.clientWidth,
                      _ = this._settings.cellHeight * (0 < e ? 1 + e + u * c : 1),
                      g = { width: this._element.clientWidth, height: this._element.clientHeight - (_ + f) },
                      p = { width: g.width, height: g.height },
                      m = this._settings.cellWidth * this._xItems.length * ((s - 1) * u + 1) + h * (n + l * c),
                      v =
                        this._settings.cellHeight * this._yItems.length * ((s - 1) * l + 1) +
                        (this._settings.totalValueStyle ? Number(this._settings.cellHeight) : 0),
                      y = !1,
                      C = !1;
                    ;

                  ) {
                    var b = !1,
                      x = !1;
                    v > p.height ? ((b = !0), (p.width = g.width - r)) : (p.width = g.width),
                      m > p.width ? ((x = !0), (p.height = g.height - r)) : (p.height = g.height);
                    var T = y === b && C === x;
                    if (((y = b), (C = x), T)) {
                      (this._scrollVertical = y),
                        (this._scrollHorizontal = C),
                        o.removeCssClass(this._element, 'pivot-view-scroll-vertical'),
                        o.removeCssClass(this._element, 'pivot-view-scroll-horizontal'),
                        this._scrollVertical && this._scrollHorizontal
                          ? (o.addCssClass(this._element, 'pivot-view-scroll-vertical'),
                            o.addCssClass(this._element, 'pivot-view-scroll-horizontal'))
                          : this._scrollVertical
                            ? o.addCssClass(this._element, 'pivot-view-scroll-vertical')
                            : this._scrollHorizontal && o.addCssClass(this._element, 'pivot-view-scroll-horizontal');
                      break;
                    }
                  }
                  this._elementBody.style.overflowX = 'hidden';
                  var O = h * (this._settings.yProperties.length + l * c),
                    S = 0;
                  this._settings.showCalculatedColumnStyle &&
                    ((s = s || 1),
                    (S =
                      this._settings.dataColumnMode === t.DATA_COL_MODE.TOP
                        ? t.SHOW_CALCULATED_COLUMN_WIDTH * s
                        : t.SHOW_CALCULATED_COLUMN_WIDTH));
                  var w = this._scrollVertical && !this._scrollHorizontal ? m - O - r : m - O,
                    A = w,
                    L = O + w + S,
                    E = O + A + S;
                  (this._elementHead.style.top = a * f + 'px'),
                    (this._elementHead.style.width = L + 'px'),
                    (this._elementHead.style.height = _ + 'px'),
                    (this._elementBody.style.top = _ + a * f + 'px'),
                    (this._elementBody.style.width = E + 'px'),
                    (this._elementBody.style.height = g.height + 'px'),
                    (this._element.style.overflow = 'auto'),
                    (this._elementHeadWrap.style.width = w + 'px'),
                    (this._elementHeadWrap.style.height = _ - 1 + 'px'),
                    (this._elementHeadWrap.style.left = O + 'px'),
                    (this._elementHeadFrozen.style.width = O + 'px'),
                    (this._elementHeadFrozen.style.height = _ - 1 + 'px'),
                    this._settings.showCalculatedColumnStyle &&
                      ((this._elementHeadCalculatedColumn.style.width = S + 'px'),
                      (this._elementHeadCalculatedColumn.style.height = _ - 1 + 'px'),
                      (this._elementBodyCalculatedColumn.style.width = S + 'px'),
                      (this._elementBodyCalculatedColumn.style.height = v + 'px')),
                    (this._elementBodyWrap.style.width = A + 'px'),
                    (this._elementBodyWrap.style.height = v + 'px'),
                    (this._elementBodyWrap.style.left = O + 'px'),
                    (this._elementBodyFrozen.style.width = O + 'px'),
                    (this._elementBodyFrozen.style.height = v + 'px'),
                    (this._scrollTopMax = v - this._elementBody.clientHeight),
                    (this._scrollLeftMax = m - this._elementBody.clientWidth),
                    (this._scrollLeft = 0),
                    (this._scrollTop = 0),
                    (this._elementBody.scrollLeft = 0),
                    (this._elementBody.scrollTop = 0),
                    (this._elementHead.scrollLeft = this._scrollLeft),
                    (this._elementHeadFrozen.style.left = this._scrollLeft + 'px'),
                    (this._elementBodyFrozen.style.left = this._scrollLeft + 'px'),
                    (this._elementBodyFrozen.style.left = '0px'),
                    (this._elementBodyFrozen.style.position = 'sticky'),
                    (this._elementBodyFrozen.style.display = 'inline-block'),
                    (this._elementBodyWrap.style.display = 'inline-block'),
                    (this._elementBodyCalculatedColumn.style.display = 'inline-block'),
                    i &&
                      ((this._elementAnnotation.style.width = d + 'px'),
                      a ||
                        (this._elementAnnotation.style.top = Math.min(this._element.clientHeight - f, _ + v) + 'px')),
                    (this._itemsRange.top = -1),
                    (this._itemsRange.bottom = -1),
                    (this._itemsRange.left = -1),
                    (this._itemsRange.right = -1),
                    t.DATA_COL_MODE.TOP === this._settings.dataColumnMode
                      ? this.renderDataToVertical(!0)
                      : this.renderDataToHorizontal(!0);
                }
              }),
              (t.prototype.renderDataToHorizontal = function (e) {
                var u = this,
                  c = this,
                  f = this._settings.body.showAxisZ ? 1 : 0,
                  h = [],
                  d = this._leafColumnWidth,
                  g = this._leafFrozenColumnWidth,
                  p = this._leafCalculatedColumnWidth,
                  m = this._settings.cellWidth,
                  v = this._settings.cellHeight,
                  y = this._settings.xProperties.length,
                  C = this._settings.yProperties.length,
                  b = this._settings.zProperties.length,
                  x = v * b,
                  T = this._settings.leftAxisWidth ? this._settings.leftAxisWidth : this._settings.cellWidth,
                  O = (this._isPivot ? 1 : 0) + y,
                  S = Object.keys(g).length
                    ? T * f +
                      this._settings.yProperties.reduce(function (t, e) {
                        return t + Number(g[e.name]);
                      }, 0)
                    : T * (C + f),
                  w = Object.keys(p).length
                    ? Number(p.TOTAL)
                    : this._settings.showCalculatedColumnStyle
                      ? t.SHOW_CALCULATED_COLUMN_WIDTH
                      : 0,
                  A = Object.keys(this._leafColumnWidth);
                if (0 < A.length) {
                  var L = A.reduce(function (t, e) {
                      return t + Number(u._leafColumnWidth[e]);
                    }, 0),
                    E =
                      1 * this._elementBody.style.width.replace(/px/gi, '') -
                      S -
                      w -
                      (this._scrollVertical && !this._scrollHorizontal ? r : 0);
                  if (this.IS_FILL_WIDTH && L <= E) {
                    var P = (E - L) / A.length;
                    A.forEach(function (t) {
                      return (u._leafColumnWidth[t] = u._leafColumnWidth[t] + P);
                    }),
                      (L = A.reduce(function (t, e) {
                        return t + Number(u._leafColumnWidth[e]);
                      }, 0)),
                      (this._elementBody.style.overflowX = 'hidden');
                  } else this._elementBody.style.overflowX = 'auto';
                  (this._elementHeadWrap.style.width = L + 'px'), (this._elementBodyWrap.style.width = L + 'px');
                } else if (this.IS_FILL_WIDTH) {
                  var k = this._xItems.length;
                  0 === k && (k = 1);
                  var D =
                    1 * this._elementBody.style.width.replace(/px/gi, '') -
                    S -
                    w -
                    (this._scrollVertical && !this._scrollHorizontal ? r : 0);
                  D > k * m &&
                    ((m = D / k),
                    (this._elementHeadWrap.style.width = D + 'px'),
                    (this._elementBodyWrap.style.width = D + 'px'),
                    this._elementAnnotation && (this._elementAnnotation.style.width = this._elementBody.style.width));
                }
                var I = {};
                (I.top = Math.floor(this._scrollTop / x)),
                  (I.bottom = Math.min(
                    this._yItems.length - 1,
                    I.top + Math.ceil((this._elementBody.clientHeight + (this._scrollTop - I.top * x)) / x) - 1,
                  )),
                  (I.left = 0);
                for (
                  var M = 0,
                    F = function () {
                      var t = u._xItems[W],
                        e = u._settings.xProperties.reduce(function (e, n) {
                          var r = t[n.name];
                          return r && (e += '' === e ? r : '||' + r), e;
                        }, '');
                      if (
                        ((M += Object.keys(d).reduce(function (t, n) {
                          return n && -1 < n.indexOf(e) && (t += Number(d[n])), t;
                        }, 0)),
                        u._scrollLeft < M)
                      )
                        return (I.left = 0 > W - 1 ? 0 : W - 1), I.left && ++I.left, 1;
                    },
                    W = 0,
                    N = this._xItems.length;
                  W < N && !F();
                  W++
                );
                I.right = Math.min(
                  this._xItems.length - 1,
                  I.left + Math.ceil((this._elementBody.clientWidth - S + (this._scrollLeft - I.left * m)) / m) - 1,
                );
                for (
                  var j = 0,
                    z = this._elementBody.clientWidth,
                    B = function () {
                      var t = u._xItems[H],
                        e = u._settings.xProperties.reduce(function (e, n) {
                          var r = t[n.name];
                          return r && (e += '' === e ? r : '||' + r), e;
                        }, '');
                      (j += Object.keys(d).reduce(function (t, n) {
                        return n && -1 < n.indexOf(e) && (t += Number(d[n])), t;
                      }, 0)) &&
                        (I.left > 0 ? j - S : j) < z &&
                        I.right < u._xItems.length - 1 &&
                        H === I.right &&
                        ++I.right;
                    },
                    H = I.left;
                  H <= I.right;
                  H++
                )
                  B();
                if (
                  e ||
                  !this._isPivot ||
                  I.top !== this._itemsRange.top ||
                  I.bottom !== this._itemsRange.bottom ||
                  I.left !== this._itemsRange.left ||
                  I.right !== this._itemsRange.right
                ) {
                  (this._itemsRange.top = I.top),
                    (this._itemsRange.bottom = I.bottom),
                    (this._itemsRange.left = I.left),
                    (this._itemsRange.right = I.right);
                  var R = void 0,
                    U = void 0,
                    V = void 0,
                    $ = void 0;
                  h.length = 0;
                  for (var Y = 0; Y < O; Y++) {
                    ((R = {}).class = a.cssClass.headRow),
                      (R.class = this.addClassFontStyle(R.class, this._settings.header.font)),
                      (R.class = this.addClassTextAlign(R.class, this._settings.header.align, 'LEFT')),
                      ((U = {}).width = '100%'),
                      (U.height = v + 'px'),
                      (U.top = Y * v + 'px'),
                      h.push('<div ' + o.attributesString(R, U) + '>');
                    for (var K = 0, X = 0, G = this._settings.yProperties.length + f; X < G; X++) {
                      ((V = {}).class = a.cssClass.headCell), ($ = {});
                      var Z;
                      (Z =
                        X > this._settings.yProperties.length - 1
                          ? t.FROZEN_COLUMN_ADDITIONAL_KEY + X
                          : this._settings.yProperties[X].name),
                        (V.title = Z),
                        g[Z] || (g[Z] = T);
                      var q = g[Z];
                      ($.width = q + 'px'),
                        ($.height = v + 'px'),
                        ($.left = K + 'px'),
                        ($.color = this._settings.header.font.color),
                        ($['background-color'] = this._settings.header.backgroundColor),
                        ($.top = '0px'),
                        h.push('<div ' + o.attributesString(V, $) + '>'),
                        X < C && Y === y && h.push(this._settings.yProperties[X].name),
                        ((V = {}).class = a.cssClass.resizeHandle),
                        (V.draggable = 'true'),
                        ($ = {}),
                        h.push('<div ' + o.attributesString(V, $) + '></div>'),
                        h.push('</div>'),
                        (K += Number(q));
                    }
                    h.push('</div>');
                  }
                  if (((this._elementHeadFrozen.innerHTML = h.join('')), this._settings.showCalculatedColumnStyle)) {
                    void 0 === p.TOTAL && (p.TOTAL = t.SHOW_CALCULATED_COLUMN_WIDTH);
                    var J = Object.keys(p),
                      Q = J.reduce(function (t, e) {
                        return t + Number(p[e]);
                      }, 0);
                    J &&
                      Q &&
                      ((this._elementHeadCalculatedColumn.style.width = Q + 'px'),
                      (this._elementBodyCalculatedColumn.style.width = Q + 'px')),
                      (h.length = 0);
                    for (var tt = 0; tt < O; tt++) this.appendHeadCalculatedColumnToHtml(tt, v, h, O);
                    this._elementHeadCalculatedColumn.innerHTML = h.join('');
                  }
                  (h.length = 0),
                    ((R = {}).class = a.cssClass.headRow),
                    (R.class = this.addClassFontStyle(R.class, this._settings.header.font)),
                    (R.class = this.addClassTextAlign(R.class, this._settings.header.align, 'LEFT')),
                    ((U = {}).width = '100%'),
                    (U.height = v + 'px'),
                    (U.top = '0px;'),
                    h.push('<div ' + o.attributesString(R, U) + '>'),
                    ((V = {}).class = a.cssClass.headCell),
                    (V.title = this._settings.xProperties
                      .map(function (t) {
                        return t.name;
                      })
                      .join(' / ')),
                    (($ = {}).height = v + 'px'),
                    ($.left = this._elementBody.scrollLeft + 'px'),
                    ($.color = this._settings.header.font.color),
                    ($['background-color'] = this._settings.header.backgroundColor);
                  var et = 0;
                  this._xItems.forEach(function (t) {
                    var e = u._settings.xProperties.reduce(function (e, n) {
                      return (e = '' === e ? e : e + '||') + t[n.name];
                    }, '');
                    d[e] || (d[e] = m), (et += Number(d[e]));
                  }),
                    ($.width = Math.min(et, this._elementHead.offsetWidth - S) + 'px'),
                    this._isPivot &&
                      (h.push('<div ' + o.attributesString(V, $) + '>'),
                      h.push(V.title),
                      0 === y &&
                        ((V.class = a.cssClass.axisXSort),
                        (V['data-parent-keys'] = ''),
                        (V['data-parent-vals'] = ''),
                        this._settings.sortColumnParentVals + o.__fieldSeparator + this._settings.sortColumnMeasure ===
                        V['data-parent-vals'].split('||').join(o.__fieldSeparator) +
                          o.__fieldSeparator +
                          this._settings.zProperties[0].name
                          ? (V['data-sort'] = this._settings.sortType)
                          : (V['data-sort'] = t.SORT_COL_MODE.NONE),
                        (($ = {}).display = 'flex'),
                        ($['align-items'] = 'center'),
                        h.push('<div ' + o.attributesString(V, $) + '>'),
                        h.push(
                          V['data-sort'] === t.SORT_COL_MODE.NONE
                            ? ''
                            : V['data-sort'] === t.SORT_COL_MODE.ASC
                              ? '▲'
                              : '▼',
                        ),
                        h.push('</div>')),
                      h.push('</div>'),
                      h.push('</div>'));
                  for (
                    var nt = function (e) {
                        ((R = {}).class = a.cssClass.headRow),
                          (R.class = u.addClassFontStyle(R.class, u._settings.body.font)),
                          (R.class = u.addClassTextAlign(R.class, u._settings.body.align, 'LEFT')),
                          ((U = {}).width = '100%'),
                          (U.height = v + 'px'),
                          (U.top = (e + (u._isPivot ? 1 : 0)) * v + 'px;'),
                          h.push('<div ' + o.attributesString(R, U) + '>');
                        for (
                          var n = '',
                            r = function () {
                              for (
                                var r = u._xItems[s],
                                  c = u._settings.xProperties[e],
                                  f = u._settings.xProperties[e].name,
                                  _ = o.format(r[f], u._settings.xProperties[e].digits),
                                  g = '',
                                  p = 0;
                                p <= e;
                                p++
                              )
                                g += o.format(r[u._settings.xProperties[p].name], u._settings.xProperties[p].digits);
                              if (n === g) return 0;
                              (n = g),
                                ((V = {}).class = a.cssClass.headCell + ' ' + a.cssClass.axisX),
                                (V.title = l(_)),
                                (V['data-key'] = f),
                                (V['data-colIdx'] = s);
                              for (var m = [], C = [], x = 0; x < e; x++)
                                m.push(u._settings.xProperties[x].name), C.push(r[u._settings.xProperties[x].name]);
                              if (C.indexOf('SUB-TOTAL') > -1) return 0;
                              0 < m.length &&
                                ((V['data-parent-keys'] = m.join('||')), (V['data-parent-vals'] = C.join('||')));
                              for (
                                var T = '', O = i(r, t.DATA_COL_MODE.TOP), S = 0;
                                S < u._settings.xProperties.length;
                                S++
                              )
                                if (O.indexOf(u._settings.xProperties[S].name) > -1) {
                                  T = u._settings.xProperties[S].name;
                                  break;
                                }
                              if ((($ = {}), 'SUB-TOTAL' === _ && u._settings.subCalcCellStyle && '' !== T)) {
                                var w = u._settings.subCalcCellStyle[T.toLowerCase()];
                                if (
                                  ((_ = w.label && '' !== w.label ? w.label : a.subSummaryLabel[w.aggregationType]),
                                  (V.class = u.addClassFontStyle(V.class, w.font)),
                                  (V.class = u.addClassTextAlign(V.class, w.align, 'CENTER')),
                                  ($.color = w.font.color),
                                  ($['background-color'] = w.backgroundColor),
                                  ($.height = (u._settings.xProperties.length - C.length) * v + 'px'),
                                  ($['font-style'] = 'normal'),
                                  ($['font-weight'] = 'normal'),
                                  ($['font-size'] = w.font.size + 'px'),
                                  w.font.styles.forEach(function (t) {
                                    'BOLD' === t ? ($['font-weight'] = t) : 'ITALIC' === t && ($['font-style'] = t);
                                  }),
                                  w.align.hAlign)
                                )
                                  switch ((($.display = 'flex'), w.align.hAlign)) {
                                    case 'LEFT':
                                      $['justify-content'] = 'flex-start';
                                      break;
                                    case 'CENTER':
                                      $['justify-content'] = 'center';
                                      break;
                                    case 'RIGHT':
                                      $['justify-content'] = 'flex-end';
                                      break;
                                    case 'DEFAULT':
                                      delete $['justify-content'];
                                  }
                                if (w.align.vAlign)
                                  switch ((($.display = 'flex'), w.align.vAlign)) {
                                    case 'TOP':
                                      $['align-items'] = 'flex-start';
                                      break;
                                    case 'MIDDLE':
                                      $['align-items'] = 'center';
                                      break;
                                    case 'BOTTOM':
                                      $['align-items'] = 'flex-end';
                                      break;
                                    default:
                                      delete $['align-items'];
                                  }
                              } else
                                ($.color = u._settings.header.font.color),
                                  ($['background-color'] = u._settings.header.backgroundColor),
                                  ($.height = v + 'px'),
                                  c.fieldFormat &&
                                    (($.color =
                                      c.fieldFormat.font && c.fieldFormat.font.color
                                        ? c.fieldFormat.font.color
                                        : $.color),
                                    ($['background-color'] = c.fieldFormat.backgroundColor
                                      ? c.fieldFormat.backgroundColor
                                      : $['background-color']));
                              var A = 0,
                                L = V['data-parent-vals'] ? V['data-parent-vals'] + '||' + r[f] : r[f];
                              if (
                                (u._xItems
                                  .slice(0, s)
                                  .map(function (t) {
                                    return u._settings.xProperties
                                      .slice(0, e + 1)
                                      .map(function (e) {
                                        return t[e.name];
                                      })
                                      .join('||');
                                  })
                                  .reduce(function (t, e) {
                                    return -1 === t.indexOf(e) && t.push(e), t;
                                  }, [])
                                  .filter(function (t) {
                                    return t !== L;
                                  })
                                  .forEach(function (t) {
                                    A += Object.keys(d).reduce(function (e, n) {
                                      return n && (n === t || -1 < n.indexOf(t + '||')) && (e += Number(d[n])), e;
                                    }, 0);
                                  }),
                                ($.left = A + 'px'),
                                ($.width =
                                  Object.keys(d).reduce(function (t, e) {
                                    return e && (e === L || -1 < e.indexOf(L + '||')) && (t += Number(d[e])), t;
                                  }, 0) + 'px'),
                                !u._isPivot && c.fieldFormat)
                              ) {
                                var E = c.fieldFormat.filter(function (t) {
                                  return t.name.toLowerCase() === _.toLowerCase();
                                })
                                  ? c.fieldFormat.filter(function (t) {
                                      return t.name.toLowerCase() === _.toLowerCase();
                                    })[0]
                                  : void 0;
                                E &&
                                  (($.color = E.font && E.font.color ? E.font.color : $.color),
                                  ($['background-color'] = E.backgroundColor
                                    ? E.backgroundColor
                                    : $['background-color']));
                              }
                              h.push('<div ' + o.attributesString(V, $) + '>'), h.push(l(_));
                              var P = u._settings.subCalcCellStyle
                                ? u._settings.yProperties.filter(function (t) {
                                    return u._settings.subCalcCellStyle[t.name.toLowerCase()];
                                  }).length
                                : 0;
                              if (!u._isPivot || (1 === b && !P)) {
                                V.class = a.cssClass.axisXSort;
                                for (var k = [], D = [], I = 0; I < e; I++)
                                  k.push(u._settings.xProperties[I].name), D.push(r[u._settings.xProperties[I].name]);
                                k.push(V['data-key']),
                                  D.push(V.title),
                                  0 < k.length &&
                                    ((V['data-parent-keys'] = k.join('||')), (V['data-parent-vals'] = D.join('||'))),
                                  u._settings.sortColumnParentVals +
                                    o.__fieldSeparator +
                                    u._settings.sortColumnMeasure ===
                                  V['data-parent-vals'].split('||').join(o.__fieldSeparator) +
                                    o.__fieldSeparator +
                                    u._settings.zProperties[0].name
                                    ? (V['data-sort'] = u._settings.sortType)
                                    : (V['data-sort'] = t.SORT_COL_MODE.NONE),
                                  (($ = {}).display = 'flex'),
                                  ($['align-items'] = 'center'),
                                  h.push('<div ' + o.attributesString(V, $) + '>'),
                                  h.push(
                                    V['data-sort'] === t.SORT_COL_MODE.NONE
                                      ? ''
                                      : V['data-sort'] === t.SORT_COL_MODE.ASC
                                        ? '▲'
                                        : '▼',
                                  ),
                                  h.push('</div>');
                              }
                              e === y - 1 &&
                                (((V = {}).class = a.cssClass.resizeHandle),
                                (V.draggable = 'true'),
                                ($ = {}),
                                h.push('<div ' + o.attributesString(V, $) + '></div>')),
                                h.push('</div>');
                            },
                            s = I.left;
                          s <= I.right;
                          s++
                        )
                          r();
                        h.push('</div>');
                      },
                      rt = 0;
                    rt < y;
                    rt++
                  )
                    nt(rt);
                  (this._elementHeadWrap.innerHTML = h.join('')),
                    this.arrangeFrozenColumnRelatedElements(),
                    (h.length = 0);
                  for (
                    var st = [],
                      it = function (t, e, n) {
                        for (var r = n; r >= 0; r--) {
                          var s = c._settings.yProperties[r].name;
                          if (t[s] !== e[s]) return !1;
                        }
                        return !0;
                      },
                      ot = I.top;
                    ot <= I.bottom;
                    ot++
                  ) {
                    for (
                      var at = function (e) {
                          var r = ot * b + e,
                            s = b * ot + e;
                          (R = {}).class = a.cssClass.headRow;
                          var c = u._yItems[ot],
                            f = i(c, t.DATA_COL_MODE.LEFT);
                          if (u._settings.calcCellStyle && void 0 !== n(c))
                            (R.class = u.addClassFontStyle(R.class, u._settings.calcCellStyle.font)),
                              (R.class = u.addClassTextAlign(R.class, u._settings.calcCellStyle.align, 'CENTER'));
                          else if (u._settings.subCalcCellStyle && void 0 !== f) {
                            var d = u._settings.subCalcCellStyle[f.toLowerCase()];
                            (R.class = u.addClassFontStyle(R.class, d.font)),
                              (R.class = u.addClassTextAlign(R.class, d.align, 'CENTER'));
                          } else
                            (R.class = u.addClassFontStyle(R.class, u._settings.body.font)),
                              (R.class = u.addClassTextAlign(R.class, u._settings.body.align, 'LEFT'));
                          ((U = {}).width = '100%'),
                            (U.height = v + 'px'),
                            (U.top = r * v + 'px;'),
                            h.push('<div ' + o.attributesString(R, U) + '>');
                          var _ = 0;
                          if (0 === e)
                            for (
                              var p = u._yItems[ot],
                                m = function () {
                                  var t = u._settings.yProperties[y],
                                    n = u._settings.yProperties[y].name;
                                  if (void 0 === p[n]) return 0;
                                  var i = o.format(p[n], u._settings.yProperties[y].digits),
                                    c = 1;
                                  if (
                                    r > I.top &&
                                    u._yItems[ot - 1] &&
                                    it(u._yItems[ot - 1], p, y) &&
                                    h.indexOf(i) > -1
                                  )
                                    return (_ += Number(g[n])), 0;
                                  for (var f = ot + 1; f < u._yItems.length && it(u._yItems[f], p, y); f++) c++;
                                  ((V = {}).class = a.cssClass.headCell + ' ' + a.cssClass.axisY),
                                    (V.title = l(i)),
                                    (V['data-key'] = n),
                                    1 === b && (V['data-rowIdx'] = s);
                                  for (var d = [], m = [], C = 0; C < y; C++)
                                    d.push(u._settings.yProperties[C].name), m.push(p[u._settings.yProperties[C].name]);
                                  0 < d.length &&
                                    ((V['data-parent-keys'] = d.join('||')), (V['data-parent-vals'] = m.join('||'))),
                                    (($ = {}).left = _ + 'px'),
                                    (T = g[n]),
                                    ($.width = T + 'px');
                                  var x = c * u._settings.zProperties.length * v,
                                    O = (I.bottom - I.top) * u._settings.zProperties.length * v + v;
                                  if (
                                    (($.height = (x > O ? O : x) + 'px'), ($['z-index'] = I.bottom - ot), 'TOTAL' === i)
                                  )
                                    (i =
                                      u._settings.calcCellStyle.label && '' !== u._settings.calcCellStyle.label
                                        ? u._settings.calcCellStyle.label
                                        : a.summaryLabel[u._settings.calcCellStyle.aggregationType]),
                                      ($.width =
                                        u._settings.yProperties.reduce(function (t, e) {
                                          return t + Number(g[e.name]);
                                        }, 0) + 'px'),
                                      ($.color = u._settings.calcCellStyle.font.color),
                                      ($['background-color'] = u._settings.calcCellStyle.backgroundColor);
                                  else if ('SUB-TOTAL' === i) {
                                    var S = u._settings.yProperties[y - 1].name,
                                      w = u._settings.subCalcCellStyle[S.toLowerCase()];
                                    (i = w.label && '' !== w.label ? w.label : a.subSummaryLabel[w.aggregationType]),
                                      ($.width =
                                        u._settings.yProperties.reduce(function (t, e, n) {
                                          return n >
                                            u._settings.yProperties.findIndex(function (t) {
                                              return t.name === S;
                                            })
                                            ? t + Number(g[e.name])
                                            : t;
                                        }, 0) + 'px'),
                                      ($.color = w.font.color),
                                      ($['background-color'] = w.backgroundColor);
                                  } else
                                    ($.width = T + 'px'),
                                      ($.color = u._settings.body.color.stepTextColors[0]),
                                      t.fieldFormat &&
                                        (($.color =
                                          t.fieldFormat.font && t.fieldFormat.font.color
                                            ? t.fieldFormat.font.color
                                            : $.color),
                                        ($['background-color'] = t.fieldFormat.backgroundColor
                                          ? t.fieldFormat.backgroundColor
                                          : $['background-color']));
                                  h.push('<div ' + o.attributesString(V, $) + '>'),
                                    h.push(l(i)),
                                    h.push('</div>'),
                                    (_ += Number(g[n])),
                                    u._settings.showCalculatedColumnStyle &&
                                      y <= u._settings.yProperties.length - 1 &&
                                      i &&
                                      st.push({
                                        summaryMapKey:
                                          m.concat([i]).join('||') + '||' + u._settings.zProperties[e].name,
                                        top: r * v,
                                      });
                                },
                                y = 0;
                              y < u._settings.yProperties.length;
                              y++
                            )
                              m();
                          for (
                            var C = function () {
                                for (
                                  var t = u._settings.yProperties[x].name,
                                    n = o.format(c[t], u._settings.yProperties[x].digits),
                                    s = [],
                                    i = 0;
                                  i < x;
                                  i++
                                )
                                  s.push(c[u._settings.yProperties[i].name]);
                                u._settings.showCalculatedColumnStyle &&
                                  x <= u._settings.yProperties.length - 1 &&
                                  n &&
                                  !st.filter(function (t) {
                                    return (
                                      t.summaryMapKey ===
                                      s.concat([n]).join('||') + '||' + u._settings.zProperties[e].name
                                    );
                                  }).length &&
                                  st.push({
                                    summaryMapKey: s.concat([n]).join('||') + '||' + u._settings.zProperties[e].name,
                                    top: r * v,
                                  });
                              },
                              x = 0;
                            x < u._settings.yProperties.length;
                            x++
                          )
                            C();
                          u._settings.body.showAxisZ &&
                            (((V = {}).class = a.cssClass.headCell),
                            (V.title = u._settings.zProperties[e].name),
                            (V['data-key'] = 'dataAxis'),
                            (V['data-rowIdx'] = s),
                            (($ = {}).width =
                              g[t.FROZEN_COLUMN_ADDITIONAL_KEY + u._settings.yProperties.length] + 'px'),
                            ($.left =
                              u._settings.yProperties.reduce(function (t, e) {
                                return t + Number(g[e.name]);
                              }, 0) + 'px'),
                            ($.height = v + 'px'),
                            ($.color = u._settings.header.font.color),
                            ($['background-color'] = u._settings.header.backgroundColor),
                            h.push('<div ' + o.attributesString(V, $) + '>'),
                            h.push(u._settings.zProperties[e].name),
                            h.push('</div>')),
                            h.push('</div>');
                        },
                        lt = 0;
                      lt < b;
                      lt++
                    )
                      at(lt);
                    if (this._settings.totalValueStyle && ot === this._yItems.length - 1)
                      for (var ut = 0; ut < b; ut++) {
                        if (
                          (((R = {}).class = a.cssClass.headRow),
                          (R.class = this.addClassFontStyle(R.class, this._settings.totalValueStyle.font)),
                          (R.class = this.addClassTextAlign(R.class, this._settings.totalValueStyle.align, 'LEFT')),
                          ((U = {}).width = '100%'),
                          (U.height = v + 'px'),
                          (U.top = this._yItems.length * b * v + ut * v + 'px;'),
                          h.push('<div ' + o.attributesString(R, U) + '>'),
                          0 === ut && 0 < this._settings.yProperties.length)
                        ) {
                          ((V = {}).class = a.cssClass.headCell),
                            (($ = {}).left = '0px'),
                            ($.width =
                              this._settings.yProperties.reduce(function (t, e) {
                                return t + Number(g[e.name]);
                              }, 0) + 'px');
                          var ct = v * b;
                          ($.height = ct + 'px'),
                            ($.color = this._settings.totalValueStyle.font.color),
                            ($['background-color'] = this._settings.totalValueStyle.backgroundColor),
                            h.push('<div ' + o.attributesString(V, $) + '>'),
                            h.push(
                              this._settings.totalValueStyle.label && '' !== this._settings.totalValueStyle.label
                                ? this._settings.totalValueStyle.label
                                : a.summaryLabel[this._settings.totalValueStyle.aggregationType],
                            ),
                            h.push('</div>');
                        }
                        this._settings.body.showAxisZ &&
                          (((V = {}).class = a.cssClass.headCell),
                          (V.title = this._settings.zProperties[ut].name),
                          (($ = {}).width =
                            g[t.FROZEN_COLUMN_ADDITIONAL_KEY + this._settings.yProperties.length] + 'px'),
                          ($.left =
                            this._settings.yProperties.reduce(function (t, e) {
                              return t + Number(g[e.name]);
                            }, 0) + 'px'),
                          ($.height = v + 'px'),
                          ($.color = this._settings.totalValueStyle.font.color),
                          ($['background-color'] = this._settings.totalValueStyle.backgroundColor),
                          h.push('<div ' + o.attributesString(V, $) + '>'),
                          h.push(this._settings.zProperties[ut].name),
                          h.push('</div>')),
                          h.push('</div>');
                      }
                  }
                  if (((this._elementBodyFrozen.innerHTML = h.join('')), this._settings.showCalculatedColumnStyle)) {
                    if (
                      ((h.length = 0), Object.keys(this.summaryMap).join('').indexOf(t.EMPTY_Y_AXIS_DIMENSION_KEY) > -1)
                    )
                      this._settings.zProperties.forEach(function (e, n) {
                        u.appendBodyCalculatedColumnToHtml(t.EMPTY_Y_AXIS_DIMENSION_KEY, n * v, v, h, e.name);
                      });
                    else
                      for (var ft = 0; ft < st.length; ft++)
                        this.appendBodyCalculatedColumnToHtml(st[ft].summaryMapKey, st[ft].top, v, h, null);
                    this._elementBodyCalculatedColumn.innerHTML = h.join('');
                  }
                  h.length = 0;
                  for (
                    var ht =
                        this._settings.body.color && this._settings.body.color.showColorStep
                          ? this._settings.body.color.showColorStep
                          : null,
                      dt = this._items,
                      _t =
                        (this._settings.body.color &&
                          this._settings.body.color.stepRangeColors &&
                          this._settings.body.color.stepRangeColors,
                        I.top);
                    _t <= I.bottom;
                    _t++
                  ) {
                    for (
                      var gt,
                        pt,
                        mt = this._yItems[_t],
                        vt = i(mt, t.DATA_COL_MODE.LEFT),
                        yt = this._settings.calcCellStyle && void 0 !== n(mt),
                        Ct = function () {
                          var e = _t * b + bt,
                            n = b * _t + bt,
                            r = u._settings.zProperties[bt],
                            l = null;
                          ht && (l = u._dataCriteria[r.name]);
                          var f = null;
                          if (
                            (r.fieldFormat &&
                              u._settings.body.color &&
                              u._settings.body.color.colorTarget &&
                              (('TEXT' === u._settings.body.color.colorTarget &&
                                r.fieldFormat.font &&
                                r.fieldFormat.font.rangeColor) ||
                                ('BACKGROUND' === u._settings.body.color.colorTarget &&
                                  r.fieldFormat.rangeBackgroundColor)) &&
                              (f = u._rangeDataCriteria[r.name]),
                            ((R = {})['data-rowIdx'] = n),
                            (R.class = a.cssClass.bodyRow + (e % 2 == 0 ? ' odd' : '')),
                            yt)
                          )
                            (R.class = u.addClassFontStyle(R.class, u._settings.calcCellStyle.font)),
                              (R.class = u.addClassTextAlign(R.class, u._settings.calcCellStyle.align));
                          else if (void 0 !== vt) {
                            var _ = u._settings.subCalcCellStyle[vt.toLowerCase()];
                            (R.class = u.addClassFontStyle(R.class, _.font)),
                              (R.class = u.addClassTextAlign(R.class, _.align));
                          } else
                            (R.class = u.addClassFontStyle(R.class, u._settings.body.font)),
                              (R.class = u.addClassTextAlign(R.class, u._settings.body.align));
                          ((U = {}).width = '100%'),
                            (U.height = v + 'px'),
                            (U.top = e * v + 'px;'),
                            h.push('<div ' + o.attributesString(R, U) + '>');
                          for (
                            var g = function () {
                                var e = u._xItems[p],
                                  _ = u._itemsContext,
                                  g = !1;
                                ((V = {}).class = a.cssClass.bodyCell),
                                  (V['data-rowIdx'] = n),
                                  (V['data-colIdx'] = p),
                                  (($ = {}).height = v + 'px');
                                for (
                                  var m = 0,
                                    y = function () {
                                      var t = u._xItems[C],
                                        e = u._settings.xProperties
                                          .map(function (e) {
                                            return t[e.name];
                                          })
                                          .join('||');
                                      m += Number(d[e]);
                                    },
                                    C = 0;
                                  C < p;
                                  C++
                                )
                                  y();
                                $.left = m + 'px';
                                var b = '';
                                u._settings.xProperties.forEach(function (t) {
                                  var n = e[t.name];
                                  n && (b += '' === b ? n : '||' + n);
                                }),
                                  ($.width = d[b] + 'px');
                                for (var x = [], T = [], O = 0; O < u._settings.xProperties.length; O++) {
                                  var S = u._settings.xProperties[O].name;
                                  (_ = _[e[S]]), x.push(S), T.push(e[S]);
                                }
                                (V['data-parent-keys'] = x.join('||')), (V['data-parent-vals'] = T.join('||'));
                                for (var w = 0; w < u._settings.yProperties.length; w++)
                                  _ = _[mt[u._settings.yProperties[w].name]];
                                try {
                                  if (_) {
                                    var A = _.item[r.name];
                                    for (var L in ((V['data-key'] = r.name),
                                    (V.title = r.name + ':' + (A || '')),
                                    _.item))
                                      if (_.item.hasOwnProperty(L)) {
                                        var E = _.item[L];
                                        V['data-item-' + L] = u._isPivot ? L + o.__fieldSeparator + E : E;
                                      }
                                    for (var P = -1, k = 0, D = dt.length; k < D; k++) {
                                      var I = dt[k],
                                        M = !1;
                                      for (var F in _.item)
                                        if (_.item.hasOwnProperty(F) && I[F] !== _.item[F]) {
                                          M = !0;
                                          break;
                                        }
                                      if (!M) {
                                        P = k;
                                        break;
                                      }
                                    }
                                    if (
                                      (-1 < P && (V['data-idx'] = P),
                                      (u._settings.subCalcCellStyle && !vt) ||
                                        (_.item.hasOwnProperty(vt) && 'SUB-TOTAL' !== _.item[vt]))
                                    ) {
                                      var W = Object.keys(u._settings.subCalcCellStyle).map(function (t) {
                                          return t.toLowerCase();
                                        }),
                                        N = u._settings.xProperties.map(function (t) {
                                          return t.name.toLowerCase();
                                        });
                                      if (
                                        u._settings.dataColumnMode === t.DATA_COL_MODE.LEFT &&
                                        W.includes.apply(W, s(N)) &&
                                        T.indexOf('SUB-TOTAL') > -1
                                      )
                                        for (
                                          var j = i(e, t.DATA_COL_MODE.TOP), z = 0;
                                          z < u._settings.xProperties.length;
                                          z++
                                        )
                                          if (j.indexOf(u._settings.xProperties[z].name) > -1) {
                                            vt = u._settings.xProperties[z].name;
                                            break;
                                          }
                                    }
                                    if (yt)
                                      u.isDefaultTextAlign(u._settings.calcCellStyle.align) &&
                                        (V.class += ' ' + a.cssClass.txtRight),
                                        (V.class += ' ' + a.cssClass.numeric),
                                        ($.color = u._settings.calcCellStyle.font.color),
                                        ($['background-color'] = u._settings.calcCellStyle.backgroundColor);
                                    else if (void 0 !== vt) {
                                      var B = u._settings.subCalcCellStyle[vt.toLowerCase()];
                                      if (
                                        (u.isDefaultTextAlign(B.align) && (V.class += ' ' + a.cssClass.txtRight),
                                        (V.class += ' ' + a.cssClass.numeric),
                                        ($.color = B.font.color),
                                        ($['background-color'] = B.backgroundColor),
                                        ($['font-style'] = 'normal'),
                                        ($['font-weight'] = 'normal'),
                                        ($['font-size'] = B.font.size + 'px'),
                                        B.font.styles.forEach(function (t) {
                                          'BOLD' === t
                                            ? ($['font-weight'] = t)
                                            : 'ITALIC' === t && ($['font-style'] = t);
                                        }),
                                        B.align.hAlign)
                                      )
                                        switch ((($.display = 'flex'), B.align.hAlign)) {
                                          case 'LEFT':
                                            $['justify-content'] = 'flex-start';
                                            break;
                                          case 'CENTER':
                                            $['justify-content'] = 'center';
                                            break;
                                          case 'RIGHT':
                                            $['justify-content'] = 'flex-end';
                                            break;
                                          case 'DEFAULT':
                                            delete $['justify-content'];
                                        }
                                      if (B.align.vAlign)
                                        switch ((($.display = 'flex'), B.align.vAlign)) {
                                          case 'TOP':
                                            $['align-items'] = 'flex-start';
                                            break;
                                          case 'MIDDLE':
                                            $['align-items'] = 'center';
                                            break;
                                          case 'BOTTOM':
                                            $['align-items'] = 'flex-end';
                                            break;
                                          default:
                                            delete $['align-items'];
                                        }
                                    } else if ('number' == typeof A && ((V.class += ' ' + a.cssClass.numeric), ht)) {
                                      var H = l.getColor(A),
                                        R = l.getTextColor(A);
                                      (gt = l.getMeasureColors && l.getMeasureColors()) &&
                                        (R = l.getUserRangeColor(A, gt)),
                                        R && ($.color = R),
                                        H && ($['background-color'] = H);
                                    }
                                    var U,
                                      Y = u._settings.format;
                                    if (r.fieldFormat)
                                      if (!u._isPivot && r.fieldFormat.length > 0)
                                        r.fieldFormat.forEach(function (t) {
                                          if (_.item.COLUMNS === t.aggrColumn)
                                            if (
                                              ((Y = t),
                                              (u._settings.body.color &&
                                                'TEXT' === u._settings.body.color.colorTarget &&
                                                Y.font &&
                                                Y.font.rangeColor) ||
                                                (u._settings.body.color &&
                                                  'BACKGROUND' === u._settings.body.color.colorTarget &&
                                                  Y.rangeBackgroundColor))
                                            ) {
                                              var e = [],
                                                n = '',
                                                r = '';
                                              if (
                                                ((f = u._rangeDataCriteria[Y.aggrColumn]),
                                                'TEXT' === u._settings.body.color.colorTarget
                                                  ? ((e = Y.font.rangeColor), f.getTextColor(A))
                                                  : ((e = Y.rangeBackgroundColor), f.getColor(A)),
                                                r && ($.color = r),
                                                n && ($['background-color'] = n),
                                                e && e.length > 0)
                                              ) {
                                                'TEXT' === u._settings.body.color.colorTarget
                                                  ? ((n = '#ffffff'), (r = f.getUserRangeColor(A, e)))
                                                  : ((n = f.getUserRangeColor(A, e)), (r = '#ffffff'));
                                                var s = l.getMeasureColors && l.getMeasureColors();
                                                s && (r = l.getUserRangeColor(A, s)),
                                                  r && ($.color = r),
                                                  n && ($['background-color'] = n);
                                              }
                                            } else
                                              ($.color = Y.font && Y.font.color ? Y.font.color : $.color),
                                                ($['background-color'] = Y.backgroundColor
                                                  ? Y.backgroundColor
                                                  : $['background-color']);
                                        });
                                      else if (
                                        (Y = r.fieldFormat) &&
                                        T.indexOf('SUB-TOTAL') < 0 &&
                                        Object.values(_.item).indexOf('SUB-TOTAL') < 0
                                      )
                                        if (
                                          ('TEXT' === u._settings.body.color.colorTarget &&
                                            r.fieldFormat.font &&
                                            r.fieldFormat.font.rangeColor) ||
                                          ('BACKGROUND' === u._settings.body.color.colorTarget &&
                                            r.fieldFormat.rangeBackgroundColor)
                                        ) {
                                          var K = [],
                                            X = '',
                                            G = '';
                                          'TEXT' === u._settings.body.color.colorTarget
                                            ? ((K = Y.font.rangeColor), f.getTextColor(A))
                                            : ((K = Y.rangeBackgroundColor), f.getColor(A)),
                                            G && ($.color = G),
                                            X && ($['background-color'] = X),
                                            K &&
                                              K.length > 0 &&
                                              ('TEXT' === u._settings.body.color.colorTarget
                                                ? ((X = '#ffffff'), (G = f.getUserRangeColor(A, K)))
                                                : ((X = f.getUserRangeColor(A, K)), (G = '#ffffff')),
                                              (gt = l.getMeasureColors && l.getMeasureColors()) &&
                                                (G = l.getUserRangeColor(A, gt)),
                                              G && ($.color = G),
                                              X && ($['background-color'] = X));
                                        } else
                                          ($.color = Y.font && Y.font.color ? Y.font.color : $.color),
                                            ($['background-color'] = Y.backgroundColor
                                              ? Y.backgroundColor
                                              : $['background-color']);
                                    (vt = i(mt, t.DATA_COL_MODE.LEFT)),
                                      h.push('<div ' + o.attributesString(V, $) + '>'),
                                      r.type && 'origin' === c._settings.format.type && !c._isPivot
                                        ? _.item.COLUMNS
                                          ? r.type[_.item.COLUMNS]
                                            ? h.push(o.numberFormat(A, _fieldFormat, r.type[_.item.COLUMNS]))
                                            : h.push(o.numberFormat(A, _fieldFormat, r.type))
                                          : h.push(o.numberFormat(A, _fieldFormat))
                                        : ((pt = c._isPivot ? r.name : _.item.COLUMNS),
                                          h.push(
                                            o.numberFormat(
                                              A,
                                              (null === (U = c._settings) ||
                                              void 0 === U ||
                                              null === (U = U.measureFormat) ||
                                              void 0 === U
                                                ? void 0
                                                : U[pt]) || c._settings.format,
                                            ),
                                          )),
                                      h.push('</div>'),
                                      (g = !0);
                                  }
                                } catch (t) {
                                  console.error(t);
                                }
                                g || (h.push('<div ' + o.attributesString(V, $) + '>'), h.push('</div>'));
                              },
                              p = I.left;
                            p <= I.right;
                            p++
                          )
                            g();
                          h.push('</div>');
                        },
                        bt = 0;
                      bt < b;
                      bt++
                    )
                      Ct();
                    if (this._settings.totalValueStyle && _t === this._yItems.length - 1)
                      for (var xt = 0; xt < b; xt++) {
                        var Tt = this._settings.zProperties[xt];
                        ((R = {}).class = a.cssClass.bodyRow),
                          (R.class = this.addClassFontStyle(R.class, this._settings.totalValueStyle.font)),
                          (R.class = this.addClassTextAlign(R.class, this._settings.totalValueStyle.align, 'RIGHT')),
                          ((U = {}).width = '100%'),
                          (U.height = v + 'px'),
                          (U.top = this._yItems.length * b * v + xt * v + 'px;'),
                          h.push('<div ' + o.attributesString(R, U) + '>');
                        for (
                          var Ot = function () {
                              var t = u._xItems[St];
                              ((V = {}).class = a.cssClass.bodyCell),
                                (($ = {}).color = u._settings.totalValueStyle.font.color),
                                ($['background-color'] = u._settings.totalValueStyle.backgroundColor),
                                ($.height = v + 'px');
                              for (
                                var e = 0,
                                  n = function () {
                                    var t = u._xItems[r],
                                      n = u._settings.xProperties
                                        .map(function (e) {
                                          return t[e.name];
                                        })
                                        .join('||');
                                    e += Number(d[n]);
                                  },
                                  r = 0;
                                r < St;
                                r++
                              )
                                n();
                              $.left = e + 'px';
                              var s = '';
                              u._settings.xProperties.forEach(function (e) {
                                var n = t[e.name];
                                n && (s += '' === s ? n : '||' + n);
                              }),
                                ($.width = Number(d[s]) + 'px');
                              var i = u._settings.format;
                              Tt.fieldFormat &&
                                (!u._isPivot && Tt.fieldFormat.length > 0
                                  ? Tt.fieldFormat.forEach(function (t) {
                                      context.item.COLUMNS === t.aggrColumn && (i = t);
                                    })
                                  : (i = Tt.fieldFormat));
                              var l = '' === s ? Tt.name : s + '||' + Tt.name,
                                f = u._yItems
                                  .map(function (t, e) {
                                    if (Object.values(t).indexOf('SUB-TOTAL') > -1) return e;
                                  })
                                  .filter(function (t) {
                                    if (t > -1) return t;
                                  }),
                                g = _.cloneDeep(u.summaryMap[l]);
                              g &&
                                f.forEach(function (t, e) {
                                  g.splice(t - e, 1);
                                }),
                                h.push('<div ' + o.attributesString(V, $) + '>'),
                                Tt.type && 'origin' === c._settings.format.type && !c._isPivot
                                  ? h.push(
                                      o.numberFormat(
                                        c.getSummaryValue(c._settings.totalValueStyle, c.summaryMap[l]),
                                        i,
                                        Tt.type,
                                      ),
                                    )
                                  : h.push(
                                      o.numberFormat(
                                        c.getSummaryValue(c._settings.totalValueStyle, c.summaryMap[l]),
                                        c._settings.measureFormat[Tt.name] || i,
                                      ),
                                    ),
                                h.push('</div>');
                            },
                            St = I.left;
                          St <= I.right;
                          St++
                        )
                          Ot();
                        h.push('</div>');
                      }
                  }
                  (this._elementBodyWrap.innerHTML = h.join('')), a.setClickStyle.apply(this);
                } else {
                  var wt = this._elementHeadWrap.querySelector(
                    '.' + a.cssClass.headRow + ':first-child .' + a.cssClass.bodyCell + ':first-child',
                  );
                  wt && (wt.style.left = this._scrollLeft + 'px');
                }
              }),
              (t.prototype.renderDataToVertical = function (e) {
                var u = this,
                  c = this,
                  f = this._settings.body.showAxisZ ? 1 : 0,
                  h = [],
                  d = this._leafColumnWidth,
                  g = this._leafFrozenColumnWidth,
                  p = this._leafCalculatedColumnWidth,
                  m = this._settings.cellWidth,
                  v = this._settings.cellHeight,
                  y = this._settings.xProperties.length,
                  C = this._settings.yProperties.length,
                  b = this._settings.zProperties.length,
                  x = this._settings.leftAxisWidth ? this._settings.leftAxisWidth : this._settings.cellWidth,
                  T = 0 < y ? 1 : 0,
                  O = y + f;
                O += 0 < y || 0 < C ? 1 : 0;
                var S = Object.keys(g).length
                    ? this._settings.yProperties.reduce(function (t, e) {
                        return t + Number(g[e.name]);
                      }, 0)
                    : x * C,
                  w = Object.keys(p).length
                    ? this._settings.zProperties.reduce(function (t, e) {
                        return t + Number(p['TOTAL||' + e.name]);
                      }, 0)
                    : this._settings.showCalculatedColumnStyle
                      ? t.SHOW_CALCULATED_COLUMN_WIDTH * b
                      : 0,
                  A = Object.keys(this._leafColumnWidth);
                if (0 < A.length) {
                  var L = A.reduce(function (t, e) {
                      return t + Number(u._leafColumnWidth[e]);
                    }, 0),
                    E =
                      1 * this._elementBody.style.width.replace(/px/gi, '') -
                      S -
                      w -
                      (this._scrollVertical && !this._scrollHorizontal ? r : 0);
                  if (this.IS_FILL_WIDTH && L <= E) {
                    var P = (E - L) / A.length;
                    A.forEach(function (t) {
                      return (u._leafColumnWidth[t] = u._leafColumnWidth[t] + P);
                    }),
                      (L = A.reduce(function (t, e) {
                        return t + Number(u._leafColumnWidth[e]);
                      }, 0)),
                      (this._elementBody.style.overflowX = 'hidden');
                  } else this._elementBody.style.overflowX = 'auto';
                  (this._elementHeadWrap.style.width = L + 'px'), (this._elementBodyWrap.style.width = L + 'px');
                } else if (this.IS_FILL_WIDTH) {
                  var k = this._xItems.length * b,
                    D =
                      1 * this._elementBody.style.width.replace(/px/gi, '') -
                      S -
                      w -
                      (this._scrollVertical && !this._scrollHorizontal ? r : 0);
                  D > k * m &&
                    ((m = D / k),
                    (this._elementHeadWrap.style.width = D + 'px'),
                    (this._elementBodyWrap.style.width = D + 'px'),
                    this._elementAnnotation && (this._elementAnnotation.style.width = this._elementBody.style.width));
                }
                var I = {};
                (I.top = Math.floor(this._scrollTop / v)),
                  (I.bottom = Math.min(
                    this._yItems.length - 1,
                    I.top + Math.ceil((this._elementBody.clientHeight + (this._scrollTop - I.top * v)) / v) - 1,
                  )),
                  (I.left = 0);
                for (
                  var M = 0,
                    F = function () {
                      var t = u._xItems[W],
                        e = u._settings.xProperties.reduce(function (e, n) {
                          var r = t[n.name];
                          return r && (e += '' === e ? r : '||' + r), e;
                        }, '');
                      if (
                        ((M += Object.keys(d).reduce(function (t, n) {
                          return n && -1 < n.indexOf(e) && (t += Number(d[n])), t;
                        }, 0)),
                        u._scrollLeft < M)
                      )
                        return (I.left = 0 > W - 1 ? 0 : W - 1), I.left && ++I.left, 1;
                    },
                    W = 0,
                    N = this._xItems.length;
                  W < N && !F();
                  W++
                );
                I.right = Math.min(
                  this._xItems.length - 1,
                  I.left + Math.ceil((this._elementBody.clientWidth - S + (this._scrollLeft - I.left * m)) / m) - 1,
                );
                for (
                  var j = 0,
                    z = this._elementBody.clientWidth,
                    B = function () {
                      var t = u._xItems[H],
                        e = u._settings.xProperties.reduce(function (e, n) {
                          var r = t[n.name];
                          return r && (e += '' === e ? r : '||' + r), e;
                        }, '');
                      u._settings.zProperties.forEach(function (t) {
                        var n = e;
                        t && (n += '||' + t.name),
                          (j += Object.keys(d).reduce(function (t, e) {
                            return e && -1 < e.indexOf(n) && (t += Number(d[e])), t;
                          }, 0));
                      }),
                        j &&
                          (I.left > 0 ? j - S : j) < z &&
                          I.right < u._xItems.length - 1 &&
                          H === I.right &&
                          ++I.right;
                    },
                    H = I.left;
                  H <= I.right;
                  H++
                )
                  B();
                if (
                  !y ||
                  e ||
                  I.top !== this._itemsRange.top ||
                  I.bottom !== this._itemsRange.bottom ||
                  I.left !== this._itemsRange.left ||
                  I.right !== this._itemsRange.right
                ) {
                  (this._itemsRange.top = I.top),
                    (this._itemsRange.bottom = I.bottom),
                    (this._itemsRange.left = I.left),
                    (this._itemsRange.right = I.right);
                  var R = void 0,
                    U = void 0,
                    V = void 0,
                    $ = void 0;
                  h.length = 0;
                  for (var Y = 0; Y < O; Y++) {
                    ((R = {}).class = a.cssClass.headRow),
                      (R.class = this.addClassFontStyle(R.class, this._settings.header.font)),
                      (R.class = this.addClassTextAlign(R.class, this._settings.header.align, 'LEFT')),
                      ((U = {}).width = '100%'),
                      (U.height = v + 'px'),
                      (U.top = Y * v + 'px'),
                      h.push('<div ' + o.attributesString(R, U) + '>');
                    for (var K = 0, X = 0; X < C; X++) {
                      ((V = {}).class = a.cssClass.headCell),
                        (V.title = this._settings.yProperties[X].name),
                        (($ = {}).height = v + 'px'),
                        ($.color = this._settings.header.font.color),
                        ($['background-color'] = this._settings.header.backgroundColor),
                        g[this._settings.yProperties[X].name] || (g[this._settings.yProperties[X].name] = x);
                      var G = g[this._settings.yProperties[X].name];
                      ($.width = G + 'px'),
                        ($.left = K + 'px'),
                        h.push('<div ' + o.attributesString(V, $) + '>'),
                        X < C &&
                          (0 === y || Y === y + f) &&
                          (($.top = '0px'), h.push(this._settings.yProperties[X].name)),
                        ((V = {}).class = a.cssClass.resizeHandle),
                        (V.draggable = 'true'),
                        ($ = {}),
                        h.push('<div ' + o.attributesString(V, $) + '></div>'),
                        h.push('</div>'),
                        (K += Number(G));
                    }
                    h.push('</div>');
                  }
                  if (((this._elementHeadFrozen.innerHTML = h.join('')), this._settings.showCalculatedColumnStyle)) {
                    this._settings.zProperties.forEach(function (e) {
                      void 0 === p['TOTAL||' + e.name] && (p['TOTAL||' + e.name] = t.SHOW_CALCULATED_COLUMN_WIDTH);
                    });
                    var Z = Object.keys(p),
                      q = Z.reduce(function (t, e) {
                        return t + Number(p[e]);
                      }, 0);
                    Z &&
                      q &&
                      ((this._elementHeadCalculatedColumn.style.width = q + 'px'),
                      (this._elementBodyCalculatedColumn.style.width = q + 'px')),
                      (h.length = 0);
                    for (var J = 0; J < O; J++) this.appendHeadCalculatedColumnToHtml(J, v, h, O);
                    this._elementHeadCalculatedColumn.innerHTML = h.join('');
                  }
                  h.length = 0;
                  var Q = 0;
                  this._xItems.forEach(function (t) {
                    var e = u._settings.xProperties.reduce(function (e, n) {
                      return (e = '' === e ? e : e + '||') + t[n.name];
                    }, '');
                    u._settings.zProperties.forEach(function (t) {
                      var n = '' !== e ? e + '||' + t.name : t.name;
                      void 0 === d[n] && (d[n] = m), (Q += Number(d[n]));
                    });
                  }),
                    0 < y &&
                      (((R = {}).class = a.cssClass.headRow),
                      (R.class = this.addClassFontStyle(R.class, this._settings.header.font)),
                      (R.class = this.addClassTextAlign(R.class, this._settings.header.align, 'LEFT')),
                      ((U = {}).width = '100%'),
                      (U.height = v + 'px'),
                      (U.top = '0px;'),
                      h.push('<div ' + o.attributesString(R, U) + '>'),
                      ((V = {}).class = a.cssClass.headCell),
                      (V.title = this._settings.xProperties
                        .map(function (t) {
                          return t.name;
                        })
                        .join(' / ')),
                      (($ = {}).height = v + 'px'),
                      ($.left = this._elementBody.scrollLeft + 'px'),
                      ($.color = this._settings.header.font.color),
                      ($['background-color'] = this._settings.header.backgroundColor),
                      ($.width = Math.min(Q, this._elementHead.offsetWidth - S) + 'px'),
                      h.push('<div ' + o.attributesString(V, $) + '>'),
                      h.push(V.title),
                      h.push('</div>'),
                      h.push('</div>'));
                  for (
                    var tt = function (e) {
                        ((R = {}).class = a.cssClass.headRow),
                          (R.class = u.addClassFontStyle(R.class, u._settings.header.font)),
                          (R.class = u.addClassTextAlign(R.class, u._settings.header.align, 'LEFT')),
                          ((U = {}).width = '100%'),
                          (U.height = v + 'px'),
                          (U.top = (e + T) * v + 'px;'),
                          h.push('<div ' + o.attributesString(R, U) + '>');
                        for (
                          var n = '',
                            r = function () {
                              for (
                                var r = u._xItems[s],
                                  c = u._settings.xProperties[e],
                                  f = u._settings.xProperties[e].name,
                                  _ = o.format(r[f], u._settings.xProperties[e].digits),
                                  g = '',
                                  p = 0;
                                p <= e;
                                p++
                              )
                                g += o.format(r[u._settings.xProperties[p].name], u._settings.xProperties[p].digits);
                              if (n === g) return 0;
                              (n = g),
                                ((V = {}).class = a.cssClass.headCell + ' ' + a.cssClass.axisX),
                                (V.title = l(_)),
                                (V['data-key'] = f),
                                1 === b && (V['data-colIdx'] = s);
                              for (var m = [], C = [], x = 0; x < e; x++)
                                m.push(u._settings.xProperties[x].name), C.push(r[u._settings.xProperties[x].name]);
                              if (C.indexOf('SUB-TOTAL') > -1) return 0;
                              0 < m.length &&
                                ((V['data-parent-keys'] = m.join('||')), (V['data-parent-vals'] = C.join('||')));
                              for (
                                var T = '', O = i(r, t.DATA_COL_MODE.TOP), S = 0;
                                S < u._settings.xProperties.length;
                                S++
                              )
                                if (O.indexOf(u._settings.xProperties[S].name) > -1) {
                                  T = u._settings.xProperties[S].name;
                                  break;
                                }
                              if ((($ = {}), 'SUB-TOTAL' === _ && u._settings.subCalcCellStyle && '' !== T)) {
                                var w = u._settings.subCalcCellStyle[T.toLowerCase()];
                                if (
                                  ((_ = w.label && '' !== w.label ? w.label : a.subSummaryLabel[w.aggregationType]),
                                  (V.class = u.addClassFontStyle(V.class, w.font)),
                                  (V.class = u.addClassTextAlign(V.class, w.align, 'CENTER')),
                                  ($.color = w.font.color),
                                  ($['background-color'] = w.backgroundColor),
                                  ($.height = (u._settings.xProperties.length - C.length) * v + 'px'),
                                  ($['font-style'] = 'normal'),
                                  ($['font-weight'] = 'normal'),
                                  ($['font-size'] = w.font.size + 'px'),
                                  w.font.styles.forEach(function (t) {
                                    'BOLD' === t ? ($['font-weight'] = t) : 'ITALIC' === t && ($['font-style'] = t);
                                  }),
                                  w.align.hAlign)
                                )
                                  switch ((($.display = 'flex'), w.align.hAlign)) {
                                    case 'LEFT':
                                      $['justify-content'] = 'flex-start';
                                      break;
                                    case 'CENTER':
                                      $['justify-content'] = 'center';
                                      break;
                                    case 'RIGHT':
                                      $['justify-content'] = 'flex-end';
                                      break;
                                    case 'DEFAULT':
                                      delete $['justify-content'];
                                  }
                                if (w.align.vAlign)
                                  switch ((($.display = 'flex'), w.align.vAlign)) {
                                    case 'TOP':
                                      $['align-items'] = 'flex-start';
                                      break;
                                    case 'MIDDLE':
                                      $['align-items'] = 'center';
                                      break;
                                    case 'BOTTOM':
                                      $['align-items'] = 'flex-end';
                                      break;
                                    default:
                                      delete $['align-items'];
                                  }
                              } else
                                ($.color = u._settings.header.font.color),
                                  ($['background-color'] = u._settings.header.backgroundColor),
                                  ($.height = v + 'px'),
                                  c.fieldFormat &&
                                    (($.color =
                                      c.fieldFormat.font && c.fieldFormat.font.color
                                        ? c.fieldFormat.font.color
                                        : $.color),
                                    ($['background-color'] = c.fieldFormat.backgroundColor
                                      ? c.fieldFormat.backgroundColor
                                      : $['background-color']));
                              var A = 0,
                                L = V['data-parent-vals'] ? V['data-parent-vals'] + '||' + r[f] : r[f];
                              if (
                                (u._xItems
                                  .slice(0, s)
                                  .map(function (t) {
                                    return u._settings.xProperties
                                      .slice(0, e + 1)
                                      .map(function (e) {
                                        return t[e.name];
                                      })
                                      .join('||');
                                  })
                                  .reduce(function (t, e) {
                                    return -1 === t.indexOf(e) && t.push(e), t;
                                  }, [])
                                  .filter(function (t) {
                                    return t !== L;
                                  })
                                  .forEach(function (t) {
                                    A += Object.keys(d).reduce(function (e, n) {
                                      return n && (n === t || -1 < n.indexOf(t + '||')) && (e += Number(d[n])), e;
                                    }, 0);
                                  }),
                                ($.left = A + 'px'),
                                ($.width =
                                  Object.keys(d).reduce(function (t, e) {
                                    return e && (e === L || -1 < e.indexOf(L + '||')) && (t += Number(d[e])), t;
                                  }, 0) + 'px'),
                                h.push('<div ' + o.attributesString(V, $) + '>'),
                                h.push(l(_)),
                                !u._settings.body.showAxisZ &&
                                  1 === b &&
                                  u._settings.xProperties.slice(-1)[0].name === V['data-key'])
                              ) {
                                V.class = a.cssClass.axisXSort;
                                for (var E = [], P = [], k = 0; k < e; k++)
                                  E.push(u._settings.xProperties[k].name), P.push(r[u._settings.xProperties[k].name]);
                                E.push(V['data-key']),
                                  P.push(V.title),
                                  0 < E.length &&
                                    ((V['data-parent-keys'] = E.join('||')), (V['data-parent-vals'] = P.join('||'))),
                                  u._settings.sortColumnParentVals +
                                    o.__fieldSeparator +
                                    u._settings.sortColumnMeasure ===
                                  V['data-parent-vals'].split('||').join(o.__fieldSeparator) +
                                    o.__fieldSeparator +
                                    u._settings.zProperties[0].name
                                    ? (V['data-sort'] = u._settings.sortType)
                                    : (V['data-sort'] = t.SORT_COL_MODE.NONE),
                                  (($ = {}).display = 'flex'),
                                  ($['align-items'] = 'center'),
                                  h.push('<div ' + o.attributesString(V, $) + '>'),
                                  h.push(
                                    V['data-sort'] === t.SORT_COL_MODE.NONE
                                      ? ''
                                      : V['data-sort'] === t.SORT_COL_MODE.ASC
                                        ? '▲'
                                        : '▼',
                                  ),
                                  h.push('</div>');
                              }
                              u._settings.body.showAxisZ ||
                                e !== y - 1 ||
                                (((V = {}).class = a.cssClass.resizeHandle),
                                (V.draggable = 'true'),
                                ($ = {}),
                                h.push('<div ' + o.attributesString(V, $) + '></div>')),
                                h.push('</div>');
                            },
                            s = I.left;
                          s <= I.right;
                          s++
                        )
                          r();
                        h.push('</div>');
                      },
                      et = 0;
                    et < y;
                    et++
                  )
                    tt(et);
                  ((R = {}).class = a.cssClass.headRow),
                    (R.class = this.addClassFontStyle(R.class, this._settings.header.font)),
                    (R.class = this.addClassTextAlign(R.class, this._settings.header.align, 'LEFT')),
                    ((U = {}).width = '100%'),
                    (U.height = v + 'px'),
                    (U.top = (y + T) * v + 'px;'),
                    h.push('<div ' + o.attributesString(R, U) + '>');
                  for (
                    var nt = function () {
                        for (
                          var e = u._xItems[rt],
                            n = u._settings.xProperties
                              .map(function (t) {
                                return t.name;
                              })
                              .join('||'),
                            r = u._settings.xProperties
                              .map(function (t) {
                                return e[t.name];
                              })
                              .join('||'),
                            s = function () {
                              ((V = {}).class = a.cssClass.headCell),
                                (V.title = u._settings.zProperties[i].name),
                                (V['data-key'] = 'dataAxis'),
                                (V['data-colIdx'] = b * rt + i),
                                (V['data-parent-keys'] = n),
                                (V['data-parent-vals'] = r),
                                (($ = {}).height = v + 'px');
                              var e = u._settings.zProperties[i].name,
                                s = 0;
                              u._xItems
                                .slice(0, rt)
                                .map(function (t) {
                                  return u._settings.xProperties
                                    .map(function (e) {
                                      return t[e.name];
                                    })
                                    .join('||');
                                })
                                .reduce(function (t, e) {
                                  return -1 === t.indexOf(e) && t.push(e), t;
                                }, [])
                                .forEach(function (t) {
                                  s += Object.keys(d).reduce(function (e, n) {
                                    return n && -1 < n.indexOf(t) && (e += Number(d[n])), e;
                                  }, 0);
                                }),
                                (s += u._settings.zProperties.slice(0, i).reduce(function (t, e) {
                                  var n = V['data-parent-vals'] ? V['data-parent-vals'] + '||' + e.name : e.name;
                                  return t + Number(d[n]);
                                }, 0)),
                                ($.left = s + 'px');
                              var l = V['data-parent-vals'] ? V['data-parent-vals'] + '||' + e : e;
                              ($.width =
                                Object.keys(d).reduce(function (t, e) {
                                  return e === l && (t += Number(d[e])), t;
                                }, 0) + 'px'),
                                ($.color = u._settings.body.color.stepTextColors[0]),
                                h.push('<div ' + o.attributesString(V, $) + '>'),
                                u._settings.body.showAxisZ && h.push(e),
                                (V.class = a.cssClass.axisXSort),
                                u._settings.sortColumnParentVals +
                                  o.__fieldSeparator +
                                  u._settings.sortColumnMeasure ===
                                V['data-parent-vals'].split('||').join(o.__fieldSeparator) +
                                  o.__fieldSeparator +
                                  V.title
                                  ? (V['data-sort'] = u._settings.sortType)
                                  : (V['data-sort'] = t.SORT_COL_MODE.NONE),
                                (($ = {}).display = 'flex'),
                                ($['align-items'] = 'center'),
                                h.push('<div ' + o.attributesString(V, $) + '>'),
                                h.push(
                                  V['data-sort'] === t.SORT_COL_MODE.NONE
                                    ? ''
                                    : V['data-sort'] === t.SORT_COL_MODE.ASC
                                      ? '▲'
                                      : '▼',
                                ),
                                h.push('</div>'),
                                ((V = {}).class = a.cssClass.resizeHandle),
                                (V.draggable = 'true'),
                                ($ = {}),
                                h.push('<div ' + o.attributesString(V, $) + '></div>'),
                                h.push('</div>');
                            },
                            i = 0;
                          i < b;
                          i++
                        )
                          s();
                      },
                      rt = I.left;
                    rt <= I.right;
                    rt++
                  )
                    nt();
                  (this._elementHeadWrap.innerHTML = h.join('')),
                    this.arrangeFrozenColumnRelatedElements(),
                    (h.length = 0);
                  for (
                    var st = [],
                      it = function (t, e, n) {
                        for (var r = n; r >= 0; r--) {
                          var s = c._settings.yProperties[r].name;
                          if (t[s] !== e[s]) return !1;
                        }
                        return !0;
                      },
                      ot = I.top;
                    ot <= I.bottom;
                    ot++
                  ) {
                    var at = ot,
                      lt = ot;
                    (R = {}).class = a.cssClass.headRow;
                    var ut = this._yItems[ot],
                      ct = i(ut, t.DATA_COL_MODE.LEFT);
                    if (this._settings.calcCellStyle && void 0 !== n(ut))
                      (R.class = this.addClassFontStyle(R.class, this._settings.calcCellStyle.font)),
                        (R.class = this.addClassTextAlign(R.class, this._settings.calcCellStyle.align, 'CENTER'));
                    else if (void 0 !== ct) {
                      var ft = this._settings.subCalcCellStyle[ct.toLowerCase()];
                      (R.class = this.addClassFontStyle(R.class, ft.font)),
                        (R.class = this.addClassTextAlign(R.class, ft.align, 'CENTER'));
                    } else
                      (R.class = this.addClassFontStyle(R.class, this._settings.body.font)),
                        (R.class = this.addClassTextAlign(R.class, this._settings.body.align, 'LEFT'));
                    ((U = {}).width = '100%'),
                      (U.height = v + 'px'),
                      (U.top = at * v + 'px;'),
                      h.push('<div ' + o.attributesString(R, U) + '>');
                    for (
                      var ht = 0,
                        dt = function () {
                          var e = u._settings.yProperties[_t],
                            n = u._settings.yProperties[_t].name;
                          if (void 0 === ut[n]) return 0;
                          var r = o.format(ut[n], u._settings.yProperties[_t].digits),
                            i = 1;
                          if (at > I.top && u._yItems[ot - 1] && it(u._yItems[ot - 1], ut, _t))
                            return (ht += Number(g[n])), 0;
                          for (var c = ot + 1; c < u._yItems.length && it(u._yItems[c], ut, _t); c++) i++;
                          ((V = {}).class = a.cssClass.headCell + ' ' + a.cssClass.axisY),
                            (V.title = l(r)),
                            (V['data-key'] = n),
                            (V['data-rowIdx'] = lt);
                          for (var f = [], d = [], _ = 0; _ < _t; _++)
                            f.push(u._settings.yProperties[_].name), d.push(ut[u._settings.yProperties[_].name]);
                          0 < f.length &&
                            ((V['data-parent-keys'] = f.join('||')), (V['data-parent-vals'] = d.join('||'))),
                            (($ = {}).left = ht + 'px'),
                            (x = g[n]),
                            ($.width = x + 'px');
                          var p = i * v,
                            m = (I.bottom - I.top) * v + v;
                          if ((($.height = (p > m ? m : p) + 'px'), ($['z-index'] = I.bottom - ot), 'TOTAL' === r))
                            (r =
                              u._settings.calcCellStyle.label && '' !== u._settings.calcCellStyle.label
                                ? u._settings.calcCellStyle.label
                                : a.summaryLabel[u._settings.calcCellStyle.aggregationType]),
                              ($.width =
                                u._settings.yProperties.reduce(function (t, e) {
                                  return t + Number(g[e.name]);
                                }, 0) + 'px'),
                              ($.color = u._settings.calcCellStyle.font.color),
                              ($['background-color'] = u._settings.calcCellStyle.backgroundColor);
                          else if ('SUB-TOTAL' === r) {
                            if (1 == C - _t) $.width = x + 'px';
                            else {
                              for (var y = 0, b = _t; b < C; b++) {
                                var T = u._settings.yProperties[b].name;
                                y += g[T];
                              }
                              $.width = y + 'px';
                            }
                            var O = u._settings.yProperties[_t - 1].name,
                              S = u._settings.subCalcCellStyle[O.toLowerCase()];
                            (r = S.label && '' !== S.label ? S.label : a.subSummaryLabel[S.aggregationType]),
                              ($.color = S.font.color),
                              ($['background-color'] = S.backgroundColor);
                          } else
                            ($.width = x + 'px'),
                              ($.color = u._settings.body.color.stepTextColors[0]),
                              e.fieldFormat &&
                                (($.color =
                                  e.fieldFormat.font && e.fieldFormat.font.color ? e.fieldFormat.font.color : $.color),
                                ($['background-color'] = e.fieldFormat.backgroundColor
                                  ? e.fieldFormat.backgroundColor
                                  : $['background-color']));
                          if (
                            (h.push('<div ' + o.attributesString(V, $) + '>'),
                            h.push(l(r)),
                            h.push('</div>'),
                            (ht += Number(g[n])),
                            u._settings.showCalculatedColumnStyle &&
                              _t == u._settings.yProperties.length - 1 &&
                              r &&
                              !st.filter(function (t) {
                                return t.summaryMapKey === d.concat([r]).join('||');
                              }).length)
                          ) {
                            if (u._settings.subCalcCellStyle) {
                              var w = Object.keys(u._settings.subCalcCellStyle).map(function (t) {
                                  return t.toLowerCase();
                                }),
                                A = u._settings.yProperties.map(function (t) {
                                  return t.name.toLowerCase();
                                });
                              if (u._settings.dataColumnMode === t.DATA_COL_MODE.TOP && w.includes.apply(w, s(A))) {
                                var L =
                                    1 === C ? u._settings.yProperties[_t].name : u._settings.yProperties[_t - 1].name,
                                  E = u._settings.subCalcCellStyle[L.toLowerCase()];
                                (r !== E.label && r !== a.subSummaryLabel[E.aggregationType]) || (r = 'SUB-TOTAL');
                              }
                            }
                            st.push({ summaryMapKey: d.concat([r]).join('||'), top: at * v });
                          }
                        },
                        _t = 0;
                      _t < C;
                      _t++
                    )
                      dt();
                    h.push('</div>'),
                      this._settings.totalValueStyle &&
                        0 < C &&
                        ot === this._yItems.length - 1 &&
                        (((R = {}).class = a.cssClass.headRow),
                        (R.class = this.addClassFontStyle(R.class, this._settings.totalValueStyle.font)),
                        (R.class = this.addClassTextAlign(R.class, this._settings.totalValueStyle.align, 'LEFT')),
                        ((U = {}).width = '100%'),
                        (U.height = v + 'px'),
                        (U.top = this._yItems.length * v + 'px;'),
                        h.push('<div ' + o.attributesString(R, U) + '>'),
                        ((V = {}).class = a.cssClass.headCell),
                        (($ = {}).width =
                          this._settings.yProperties.reduce(function (t, e) {
                            return t + Number(g[e.name]);
                          }, 0) + 'px'),
                        ($.height = v + 'px'),
                        ($.color = this._settings.totalValueStyle.font.color),
                        ($['background-color'] = this._settings.totalValueStyle.backgroundColor),
                        ($.left = '0px'),
                        h.push('<div ' + o.attributesString(V, $) + '>'),
                        h.push(
                          this._settings.totalValueStyle.label && '' !== this._settings.totalValueStyle.label
                            ? this._settings.totalValueStyle.label
                            : a.summaryLabel[this._settings.totalValueStyle.aggregationType],
                        ),
                        h.push('</div>'),
                        h.push('</div>'));
                  }
                  if (((this._elementBodyFrozen.innerHTML = h.join('')), this._settings.showCalculatedColumnStyle)) {
                    if (
                      ((h.length = 0), Object.keys(this.summaryMap).join('').indexOf(t.EMPTY_Y_AXIS_DIMENSION_KEY) > -1)
                    )
                      this._settings.zProperties.forEach(function (e, n) {
                        u.appendBodyCalculatedColumnToHtml(t.EMPTY_Y_AXIS_DIMENSION_KEY, n * v, v, h, e.name);
                      });
                    else
                      for (var gt = 0; gt < st.length; gt++)
                        this.appendBodyCalculatedColumnToHtml(st[gt].summaryMapKey, st[gt].top, v, h, null);
                    this._elementBodyCalculatedColumn.innerHTML = h.join('');
                  }
                  h.length = 0;
                  for (
                    var pt =
                        this._settings.body.color && this._settings.body.color.showColorStep
                          ? this._settings.body.color.showColorStep
                          : null,
                      mt = this._items,
                      vt =
                        this._settings.body.color && this._settings.body.color.stepRangeColors
                          ? this._settings.body.color.stepRangeColors
                          : null,
                      yt = I.top;
                    yt <= I.bottom;
                    yt++
                  ) {
                    var Ct = yt,
                      bt = yt,
                      xt = this._yItems[yt];
                    ((R = {})['data-rowIdx'] = bt), (R.class = a.cssClass.bodyRow + (Ct % 2 == 0 ? ' odd' : ''));
                    var Tt = i(xt, t.DATA_COL_MODE.LEFT);
                    if (this._settings.calcCellStyle && void 0 !== n(xt))
                      (R.class = this.addClassFontStyle(R.class, this._settings.calcCellStyle.font)),
                        (R.class = this.addClassTextAlign(R.class, this._settings.calcCellStyle.align));
                    else if (void 0 !== Tt) {
                      var Ot = this._settings.subCalcCellStyle[Tt.toLowerCase()];
                      (R.class = this.addClassFontStyle(R.class, Ot.font)),
                        (R.class = this.addClassTextAlign(R.class, Ot.align));
                    } else
                      (R.class = this.addClassFontStyle(R.class, this._settings.body.font)),
                        (R.class = this.addClassTextAlign(R.class, this._settings.body.align));
                    ((U = {}).width = '100%'),
                      (U.height = v + 'px'),
                      (U.top = Ct * v + 'px;'),
                      h.push('<div ' + o.attributesString(R, U) + '>');
                    for (var St = I.left; St <= I.right; St++)
                      for (
                        var wt,
                          At,
                          Lt,
                          Et,
                          Pt = function () {
                            var e = u._settings.zProperties[kt],
                              n = null;
                            pt && (n = u._dataCriteria[e.name]);
                            var r = null;
                            e.fieldFormat &&
                              u._settings.body.color &&
                              u._settings.body.color.colorTarget &&
                              (('TEXT' === u._settings.body.color.colorTarget &&
                                e.fieldFormat.font &&
                                e.fieldFormat.font.rangeColor) ||
                                ('BACKGROUND' === u._settings.body.color.colorTarget &&
                                  e.fieldFormat.rangeBackgroundColor)) &&
                              (r = u._rangeDataCriteria[e.name]);
                            var l = u._xItems[St],
                              c = u._itemsContext,
                              f = !1;
                            ((V = {}).class = a.cssClass.bodyCell),
                              (V['data-rowIdx'] = bt),
                              (V['data-colIdx'] = b * St + kt),
                              (($ = {}).height = v + 'px');
                            var _ = u._settings.xProperties.reduce(function (t, e) {
                                var n = l[e.name];
                                return n && (t += '' === t ? n : '||' + n), t;
                              }, ''),
                              g = 0;
                            u._xItems
                              .slice(0, St)
                              .map(function (t) {
                                return u._settings.xProperties
                                  .map(function (e) {
                                    return t[e.name];
                                  })
                                  .join('||');
                              })
                              .reduce(function (t, e) {
                                return -1 === t.indexOf(e) && t.push(e), t;
                              }, [])
                              .forEach(function (t) {
                                g += Object.keys(d).reduce(function (e, n) {
                                  return n && (n === t || -1 < n.indexOf(t + '||')) && (e += Number(d[n])), e;
                                }, 0);
                              }),
                              (g += u._settings.zProperties.slice(0, kt).reduce(function (t, e) {
                                var n = '' !== _ ? _ + '||' + e.name : e.name;
                                return t + Number(d[n]);
                              }, 0)),
                              ($.left = g + 'px'),
                              ($.width = '' === _ ? d[e.name] + 'px' : d[_ + '||' + e.name] + 'px');
                            try {
                              for (var p = [], m = [], x = 0; x < y; x++) {
                                var T = u._settings.xProperties[x].name;
                                (c = c[l[T]]), p.push(T), m.push(l[T]);
                              }
                              (V['data-parent-keys'] = p.join('||')), (V['data-parent-vals'] = m.join('||'));
                              for (var O = 0; O < C; O++) c = c[xt[u._settings.yProperties[O].name]];
                              if (c) {
                                var S = c.item[e.name];
                                (V['data-key'] = e.name), (V.title = e.name + ':' + (S || ''));
                                var w = !1;
                                for (var A in c.item)
                                  if (c.item.hasOwnProperty(A)) {
                                    var L = c.item[A];
                                    (V['data-item-' + A] = u._isPivot ? A + o.__fieldSeparator + L : L),
                                      'TOTAL' === L && (w = !0);
                                  }
                                for (var E = -1, P = 0, k = mt.length; P < k; P++) {
                                  var D = mt[P],
                                    I = !1;
                                  for (var M in c.item)
                                    if (c.item.hasOwnProperty(M) && D[M] !== c.item[M]) {
                                      I = !0;
                                      break;
                                    }
                                  if (!I) {
                                    E = P;
                                    break;
                                  }
                                }
                                if (
                                  (-1 < E && (V['data-idx'] = E),
                                  u._settings.subCalcCellStyle ||
                                    (c.item.hasOwnProperty(Tt) && 'SUB-TOTAL' === c.item[Tt]))
                                ) {
                                  var F = Object.keys(u._settings.subCalcCellStyle).map(function (t) {
                                      return t.toLowerCase();
                                    }),
                                    W = u._settings.xProperties.map(function (t) {
                                      return t.name.toLowerCase();
                                    });
                                  if (
                                    u._settings.dataColumnMode === t.DATA_COL_MODE.TOP &&
                                    F.includes.apply(F, s(W)) &&
                                    m.indexOf('SUB-TOTAL') > -1
                                  )
                                    for (
                                      var N = i(l, t.DATA_COL_MODE.TOP), j = 0;
                                      j < u._settings.xProperties.length;
                                      j++
                                    )
                                      if (N.indexOf(u._settings.xProperties[j].name) > -1) {
                                        Tt = u._settings.xProperties[j].name;
                                        break;
                                      }
                                }
                                if (w)
                                  u.isDefaultTextAlign(u._settings.totalValueStyle.align) &&
                                    (V.class += ' ' + a.cssClass.txtRight),
                                    (V.class += ' ' + a.cssClass.numeric),
                                    ($.color = u._settings.totalValueStyle.font.color),
                                    ($['background-color'] = u._settings.totalValueStyle.backgroundColor);
                                else if (void 0 !== Tt) {
                                  var z = u._settings.subCalcCellStyle[Tt.toLowerCase()];
                                  if (
                                    (u.isDefaultTextAlign(z.align) && (V.class += ' ' + a.cssClass.txtRight),
                                    (V.class += ' ' + a.cssClass.numeric),
                                    ($.color = z.font.color),
                                    ($['background-color'] = z.backgroundColor),
                                    ($['font-style'] = 'normal'),
                                    ($['font-weight'] = 'normal'),
                                    ($['font-size'] = z.font.size + 'px'),
                                    z.font.styles.forEach(function (t) {
                                      'BOLD' === t ? ($['font-weight'] = t) : 'ITALIC' === t && ($['font-style'] = t);
                                    }),
                                    z.align.hAlign)
                                  )
                                    switch ((($.display = 'flex'), z.align.hAlign)) {
                                      case 'LEFT':
                                        $['justify-content'] = 'flex-start';
                                        break;
                                      case 'CENTER':
                                        $['justify-content'] = 'center';
                                        break;
                                      case 'RIGHT':
                                        $['justify-content'] = 'flex-end';
                                        break;
                                      case 'DEFAULT':
                                        delete $['justify-content'];
                                    }
                                  if (z.align.vAlign)
                                    switch ((($.display = 'flex'), z.align.vAlign)) {
                                      case 'TOP':
                                        $['align-items'] = 'flex-start';
                                        break;
                                      case 'MIDDLE':
                                        $['align-items'] = 'center';
                                        break;
                                      case 'BOTTOM':
                                        $['align-items'] = 'flex-end';
                                        break;
                                      default:
                                        delete $['align-items'];
                                    }
                                } else
                                  'number' == typeof S &&
                                    ((V.class += ' ' + a.cssClass.numeric),
                                    pt &&
                                      ((wt = n.getColor(S)),
                                      (At = n.getTextColor(S)),
                                      (Et = n.getMeasureColors()),
                                      (Lt = n.getUserRangeColor(S, Et || At)) && ($.color = Lt),
                                      wt && ($['background-color'] = wt),
                                      vt &&
                                        vt.length > 0 &&
                                        ('TEXT' === u._settings.body.color.colorTarget
                                          ? ((wt = '#ffffff'), (Lt = n.getUserRangeColor(S, vt)))
                                          : ((wt = n.getUserRangeColor(S, vt)), (Lt = '#ffffff')),
                                        Lt && ($.color = Lt),
                                        wt && ($['background-color'] = wt))));
                                var B = u._settings.format;
                                if (e.fieldFormat)
                                  if (!u._isPivot && e.fieldFormat.length > 0)
                                    e.fieldFormat.forEach(function (t) {
                                      c.item.COLUMNS === t.aggrColumn && (B = t);
                                    });
                                  else if (
                                    (B = e.fieldFormat) &&
                                    m.indexOf('SUB-TOTAL') < 0 &&
                                    Object.values(c.item).indexOf('SUB-TOTAL') < 0
                                  )
                                    if (
                                      ('TEXT' === u._settings.body.color.colorTarget &&
                                        e.fieldFormat.font &&
                                        e.fieldFormat.font.rangeColor) ||
                                      ('BACKGROUND' === u._settings.body.color.colorTarget &&
                                        e.fieldFormat.rangeBackgroundColor)
                                    ) {
                                      var H = [],
                                        R = '',
                                        U = '';
                                      'TEXT' === u._settings.body.color.colorTarget
                                        ? ((H = B.font.rangeColor), r.getTextColor(S))
                                        : ((H = B.rangeBackgroundColor), r.getColor(S)),
                                        U && ($.color = U),
                                        R && ($['background-color'] = R),
                                        H &&
                                          H.length > 0 &&
                                          ('TEXT' === u._settings.body.color.colorTarget
                                            ? ((R = '#ffffff'), (U = r.getUserRangeColor(S, H)))
                                            : ((R = r.getUserRangeColor(S, H)), (U = '#ffffff')),
                                          (Et = n.getMeasureColors && n.getMeasureColors()) &&
                                            (U = n.getUserRangeColor(S, Et)),
                                          U && ($.color = U),
                                          R && ($['background-color'] = R));
                                    } else
                                      ($.color = B.font && B.font.color ? B.font.color : $.color),
                                        ($['background-color'] = B.backgroundColor
                                          ? B.backgroundColor
                                          : $['background-color']);
                                (Tt = i(xt, t.DATA_COL_MODE.LEFT)),
                                  h.push('<div ' + o.attributesString(V, $) + '>'),
                                  e.type && 'origin' === u._settings.format.type && !u._isPivot
                                    ? h.push(o.numberFormat(S, B, e.type))
                                    : h.push(
                                        o.numberFormat(
                                          S,
                                          (u._settings.measureFormat ? u._settings.measureFormat[e.name] : void 0) ||
                                            (B.type ? B : u._settings.format),
                                        ),
                                      ),
                                  h.push('</div>'),
                                  (f = !0);
                              }
                            } catch (t) {
                              console.error(t);
                            }
                            f || (h.push('<div ' + o.attributesString(V, $) + '>'), h.push('</div>'));
                          },
                          kt = 0;
                        kt < b;
                        kt++
                      )
                        Pt();
                    if ((h.push('</div>'), this._settings.totalValueStyle && yt === this._yItems.length - 1)) {
                      ((R = {}).class = a.cssClass.bodyRow),
                        (R.class = this.addClassFontStyle(R.class, this._settings.totalValueStyle.font)),
                        (R.class = this.addClassTextAlign(R.class, this._settings.totalValueStyle.align, 'RIGHT')),
                        ((U = {}).width = '100%'),
                        (U.height = v + 'px'),
                        (U.top = this._yItems.length * v + 'px;'),
                        h.push('<div ' + o.attributesString(R, U) + '>');
                      for (var Dt = I.left; Dt <= I.right; Dt++)
                        for (
                          var It = function () {
                              var t = u._settings.zProperties[Mt],
                                e = u._xItems[Dt];
                              ((V = {}).class = a.cssClass.bodyCell),
                                (($ = {}).color = u._settings.totalValueStyle.font.color),
                                ($['background-color'] = u._settings.totalValueStyle.backgroundColor),
                                ($.height = v + 'px');
                              var n = u._settings.xProperties.reduce(function (t, n) {
                                  var r = e[n.name];
                                  return r && (t += '' === t ? r : '||' + r), t;
                                }, ''),
                                r = 0;
                              u._xItems
                                .slice(0, Dt)
                                .map(function (t) {
                                  return u._settings.xProperties
                                    .map(function (e) {
                                      return t[e.name];
                                    })
                                    .join('||');
                                })
                                .reduce(function (t, e) {
                                  return -1 === t.indexOf(e) && t.push(e), t;
                                }, [])
                                .forEach(function (t) {
                                  r += Object.keys(d).reduce(function (e, n) {
                                    return n && (n === t || -1 < n.indexOf(t + '||')) && (e += Number(d[n])), e;
                                  }, 0);
                                }),
                                (r += u._settings.zProperties.slice(0, Mt).reduce(function (t, e) {
                                  var r = '' !== n ? n + '||' + e.name : e.name;
                                  return t + Number(d[r]);
                                }, 0)),
                                ($.left = r + 'px');
                              var s = '' === n ? t.name : n + '||' + t.name;
                              $.width = d[s] + 'px';
                              var i = u._settings.format;
                              t.fieldFormat &&
                                (!u._isPivot && t.fieldFormat.length > 0
                                  ? t.fieldFormat.forEach(function (t) {
                                      context.item.COLUMNS === t.aggrColumn && (i = t);
                                    })
                                  : (i = t.fieldFormat));
                              var l = u._yItems
                                  .map(function (t, e) {
                                    if (Object.values(t).indexOf('SUB-TOTAL') > -1) return e;
                                  })
                                  .filter(function (t) {
                                    if (t > -1) return t;
                                  }),
                                c = _.cloneDeep(u.summaryMap[s]);
                              c &&
                                l.forEach(function (t, e) {
                                  c.splice(t - e, 1);
                                }),
                                h.push('<div ' + o.attributesString(V, $) + '>'),
                                t.type && 'origin' === u._settings.format.type && !u._isPivot
                                  ? h.push(o.numberFormat(u.getSummaryValue(c, u._settings.totalValueStyle), i, t.type))
                                  : h.push(
                                      o.numberFormat(
                                        u.getSummaryValue(c, u._settings.totalValueStyle),
                                        (u._settings.measureFormat ? u._settings.measureFormat[t.name] : void 0) || i,
                                      ),
                                    ),
                                h.push('</div>');
                            },
                            Mt = 0;
                          Mt < b;
                          Mt++
                        )
                          It();
                      h.push('</div>');
                    }
                  }
                  (this._elementBodyWrap.innerHTML = h.join('')), a.setClickStyle.apply(this);
                } else {
                  var Ft = this._elementHeadWrap.querySelector(
                    '.' + a.cssClass.headRow + ':first-child .' + a.cssClass.bodyCell + ':first-child',
                  );
                  Ft && (Ft.style.left = this._scrollLeft + 'px');
                }
              }),
              (t.prototype.generateDownloadTableHorizontal = function () {
                var t = this,
                  e = [],
                  n = this._settings.xProperties.length,
                  r = this._settings.yProperties.length,
                  s = this._settings.zProperties.length,
                  i = this._settings.body.showAxisZ ? 1 : 0,
                  l = (this._isPivot ? 1 : 0) + n;
                if ((e.push('<table>'), e.push('<thead>'), this._isPivot)) {
                  e.push('<tr>');
                  for (var u = 0; u < r; u++)
                    e.push('<th rowspan="' + l + '" >'), e.push(this._settings.yProperties[u].name), e.push('</th>');
                  if ((i && e.push('<th rowspan="' + l + '" ></th>'), 0 < n)) {
                    var c = this._xItems.length * this._settings.zProperties.length;
                    e.push('<th colspan="' + c + '" >'),
                      e.push(
                        this._settings.xProperties
                          .map(function (t) {
                            return t.name;
                          })
                          .join(' / '),
                      ),
                      e.push('</th>');
                  }
                  e.push('</tr>');
                }
                for (var f = 0; f < n; f++) {
                  e.push('<tr>'), this._isPivot || 0 !== f || e.push('<th rowspan="' + n + '" ></th>');
                  for (var h = '', d = 0, _ = 0, g = this._xItems.length; _ < g; _++) {
                    var p = this._xItems[_],
                      m = this._settings.xProperties[f].name,
                      v = o.format(p[m], this._settings.xProperties[f].digits);
                    '' !== h && h !== v
                      ? (e.push('<th colspan="' + d + '" >' + h + '</th>'), (d = 1), (h = v))
                      : ((h = v), d++);
                  }
                  e.push('<th colspan="' + d + '" >' + h + '</th>'), e.push('</tr>');
                }
                e.push('</thead>'), e.push('<tbody>');
                for (
                  var y = function (e, n, r) {
                      for (var s = r; s >= 0; s--) {
                        var i = t._settings.yProperties[s].name;
                        if (e[i] !== n[i]) return !1;
                      }
                      return !0;
                    },
                    C = 0,
                    b = this._yItems.length;
                  C < b;
                  C++
                )
                  for (var x = this._yItems[C], T = 0; T < s; T++) {
                    e.push('<tr>');
                    var O = this._settings.zProperties[T];
                    if (0 === T)
                      for (var S = 0; S < r; S++) {
                        var w = this._settings.yProperties[S].name;
                        if (void 0 !== x[w]) {
                          var A = o.format(x[w], this._settings.yProperties[S].digits),
                            L = 1;
                          if (!this._yItems[C - 1] || !y(this._yItems[C - 1], x, S)) {
                            for (var E = C + 1; E < this._yItems.length && y(this._yItems[E], x, S); E++) L++;
                            if ('TOTAL' === A) {
                              var P = r - S;
                              (A =
                                this._settings.calcCellStyle.label && '' !== this._settings.calcCellStyle.label
                                  ? this._settings.calcCellStyle.label
                                  : a.summaryLabel[this._settings.calcCellStyle.aggregationType]),
                                e.push('<td rowspan="' + L * s + '"  colspan="' + P + '" >' + A + '</td>');
                            } else if ('SUB-TOTAL' === A) {
                              var k = r - S,
                                D = this._settings.yProperties[S - 1].name,
                                I = this._settings.subCalcCellStyle[D.toLowerCase()];
                              (A = I.label && '' !== I.label ? I.label : a.subSummaryLabel[I.aggregationType]),
                                e.push('<td rowspan="' + L * s + '"  colspan="' + k + '" >' + A + '</td>');
                            } else e.push('<td rowspan="' + L * s + '" >' + A + '</td>');
                          }
                        }
                      }
                    this._settings.body.showAxisZ && e.push('<td>' + O.alias + '</td>');
                    for (var M = 0, F = this._xItems.length; M < F; M++) {
                      var W = this._xItems[M],
                        N = this._itemsContext,
                        j = !1;
                      try {
                        for (var z = 0; z < n; z++) N = N[W[this._settings.xProperties[z].name]];
                        for (var B = 0; B < r; B++) N = N[x[this._settings.yProperties[B].name]];
                        if (N) {
                          var H = N.item[O.name];
                          null == H ? e.push('<td></td>') : e.push('<td>' + H + '</td>'), (j = !0);
                        }
                      } catch (t) {
                        console.error(t);
                      }
                      j || e.push('<td></td>');
                    }
                    e.push('</tr>');
                  }
                return e.push('</tbody>'), e.join('');
              }),
              (t.prototype.generateDownloadTableVertical = function () {
                var t = this,
                  e = [],
                  n = this._settings.xProperties.length,
                  r = this._settings.yProperties.length,
                  s = this._settings.zProperties.length;
                e.push('<table>'), e.push('<thead>'), e.push('<tr>');
                for (var i = this._settings.body.showAxisZ ? 1 : 0, l = 0 < n ? n + 1 + i : i, u = 0; u < r; u++)
                  e.push('<th rowspan="' + l + '" >'), e.push(this._settings.yProperties[u].name), e.push('</th>');
                if (0 < n) {
                  var c = this._xItems.length * this._settings.zProperties.length;
                  e.push('<th colspan="' + c + '" >'),
                    e.push(
                      this._settings.xProperties
                        .map(function (t) {
                          return t.name;
                        })
                        .join(' / '),
                    ),
                    e.push('</th>');
                } else if (this._settings.body.showAxisZ)
                  for (var f = 0; f < s; f++) e.push('<th>' + this._settings.zProperties[f].name + '</th>');
                else e.push('<th colspan="' + this._settings.zProperties.length + '" ></th>');
                e.push('</tr>');
                for (var h = 0; h < n; h++) {
                  e.push('<tr>');
                  for (var d = '', _ = 0, g = 0, p = this._xItems.length; g < p; g++) {
                    var m = this._xItems[g],
                      v = this._settings.xProperties[h].name,
                      y = o.format(m[v], this._settings.xProperties[h].digits);
                    '' !== d && d !== y
                      ? (this._settings.body.showAxisZ
                          ? e.push('<th colspan="' + _ * s + '" >')
                          : e.push('<th colspan="' + _ + '" >'),
                        e.push(d),
                        e.push('</th>'),
                        (_ = 1),
                        (d = y))
                      : ((d = y), _++);
                  }
                  this._settings.body.showAxisZ
                    ? e.push('<th colspan="' + _ * s + '" >')
                    : e.push('<th colspan="' + _ + '" >'),
                    e.push(d),
                    e.push('</th>'),
                    e.push('</tr>');
                }
                if (0 < n && this._settings.body.showAxisZ) {
                  e.push('<tr>');
                  for (var C = 0, b = this._xItems.length; C < b; C++)
                    for (var x = 0; x < s; x++) e.push('<th>' + this._settings.zProperties[x].alias + '</th>');
                  e.push('</tr>');
                }
                e.push('</thead>'), e.push('<tbody>');
                for (
                  var T = function (e, n, r) {
                      for (var s = r; s >= 0; s--) {
                        var i = t._settings.yProperties[s].name;
                        if (e[i] !== n[i]) return !1;
                      }
                      return !0;
                    },
                    O = 0,
                    S = this._yItems.length;
                  O < S;
                  O++
                ) {
                  var w = this._yItems[O];
                  e.push('<tr>');
                  for (var A = 0; A < r; A++) {
                    var L = this._settings.yProperties[A].name;
                    if (void 0 !== w[L]) {
                      var E = o.format(w[L], this._settings.yProperties[A].digits),
                        P = 1;
                      if (!this._yItems[O - 1] || !T(this._yItems[O - 1], w, A)) {
                        for (var k = O + 1; k < this._yItems.length && T(this._yItems[k], w, A); k++) P++;
                        if ('TOTAL' === E) {
                          var D = r;
                          (E =
                            this._settings.calcCellStyle.label && '' !== this._settings.calcCellStyle.label
                              ? this._settings.calcCellStyle.label
                              : a.summaryLabel[this._settings.calcCellStyle.aggregationType]),
                            e.push('<td colspan="' + D + '" >' + E + '</td>');
                        } else if ('SUB-TOTAL' === E) {
                          var I = r - A,
                            M = this._settings.yProperties[A - 1].name,
                            F = this._settings.subCalcCellStyle[M.toLowerCase()];
                          (E = F.label && '' !== F.label ? F.label : a.subSummaryLabel[F.aggregationType]),
                            e.push('<td colspan="' + I + '" >' + E + '</td>');
                        } else e.push('<td rowspan="' + P + '" >' + E + '</td>');
                      }
                    }
                  }
                  for (var W = 0, N = this._xItems.length; W < N; W++)
                    for (var j = 0; j < s; j++) {
                      var z = this._settings.zProperties[j],
                        B = this._xItems[W],
                        H = this._itemsContext,
                        R = !1;
                      try {
                        for (var U = 0; U < n; U++) H = H[B[this._settings.xProperties[U].name]];
                        for (var V = 0; V < r; V++) H = H[w[this._settings.yProperties[V].name]];
                        if (H) {
                          var $ = H.item[z.name];
                          null == $ ? e.push('<td></td>') : e.push('<td>' + $ + '</td>'), (R = !0);
                        }
                      } catch (t) {
                        console.error(t);
                      }
                      R || e.push('<td></td>');
                    }
                  e.push('</tr>');
                }
                return e.push('</tbody>'), e.join('');
              }),
              (t.prototype.getDownloadContents = function () {
                return t.DATA_COL_MODE.TOP === this._settings.dataColumnMode
                  ? this.generateDownloadTableVertical()
                  : this.generateDownloadTableHorizontal();
              }),
              (t.prototype.onScroll = function () {
                var e = this._elementBody.scrollTop,
                  n = this._scrollTop !== e,
                  r = this._elementBody.scrollLeft,
                  s = this._scrollLeft !== r;
                n && (this._scrollTop = Math.min(e, this._scrollTopMax)),
                  s &&
                    ((this._scrollLeft = r),
                    (this._elementHead.scrollLeft = this._scrollLeft),
                    (this._elementHeadFrozen.style.left = this._scrollLeft + 'px')),
                  (n || s) &&
                    (t.DATA_COL_MODE.TOP === this._settings.dataColumnMode
                      ? this.renderDataToVertical()
                      : this.renderDataToHorizontal());
              }),
              (t.prototype.resize = function () {
                var e = this;
                if ((this.timer && clearTimeout(this.timer), this._settings)) {
                  var n = this._settings.showCalculatedColumnStyle ? t.SHOW_CALCULATED_COLUMN_WIDTH : 0,
                    s = function () {
                      var s = Object.keys(e._leafColumnWidth),
                        i = $(e._elementHeadWrap)
                          .find('.' + a.cssClass.headRow)
                          .last()
                          .find('.' + a.cssClass.headCell),
                        o = s.reduce(function (t, n) {
                          return t + Number(e._leafColumnWidth[n]);
                        }, 0),
                        l =
                          1 * e._elementBody.style.width.replace(/px/gi, '') -
                          1 * e._elementBodyFrozen.style.width.replace(/px/gi, '') -
                          n -
                          (e._scrollVertical && !e._scrollHorizontal ? r : 0);
                      if (e.IS_FILL_WIDTH && !e._scrollHorizontal && o !== l) {
                        var u = (l - o) / s.length;
                        s.forEach(function (n, r) {
                          if (e._leafColumnWidth[n] + u >= t.COLUMN_WIDTH_MIN) {
                            var s = e.getColumnTextWidth(n.split('||').slice(-1).join(''), i.eq(r));
                            e._leafColumnWidth[n] = s > e._leafColumnWidth[n] + u ? s : e._leafColumnWidth[n] + u;
                          }
                        });
                      }
                      e.arrange();
                    };
                  s(),
                    (this.timer = setTimeout(function () {
                      return s();
                    }, 200));
                }
              }),
              (t.prototype.getSummaryValue = function (t, e) {
                if (t) {
                  var n = '';
                  if (
                    t.some(function (t) {
                      return 'number' == typeof t;
                    }) &&
                    e &&
                    e.aggregationType
                  )
                    switch (e.aggregationType) {
                      case 'SUM':
                        n = t.reduce(function (t, e) {
                          return t + Number(e);
                        }, 0);
                        break;
                      case 'AVERAGE':
                        n =
                          t.reduce(function (t, e) {
                            return t + Number(e);
                          }, 0) / t.length;
                        break;
                      case 'MAX':
                        n = Math.max.apply(null, t);
                        break;
                      case 'MIN':
                        n = Math.min.apply(null, t);
                        break;
                      case 'COUNT':
                        n = t.reduce(function (t, e) {
                          return t + (null == e ? 0 : 1);
                        }, 0);
                    }
                  return n;
                }
              }),
              (t.prototype.arrangeFrozenColumnRelatedElements = function () {
                var t = this,
                  e = Object.keys(t._leafFrozenColumnWidth).reduce(function (e, n) {
                    return e + Number(t._leafFrozenColumnWidth[n]);
                  }, 0);
                if (
                  ((this._elementHeadWrap.style.left = e + 'px'),
                  (this._elementHeadFrozen.style.width = e + 'px'),
                  (this._elementBodyWrap.style.left = e + 'px'),
                  (this._elementBodyFrozen.style.width = e + 'px'),
                  t._settings.showCalculatedColumnStyle)
                ) {
                  var n = Object.keys(t._leafColumnWidth).reduce(function (e, n) {
                    return e + Number(t._leafColumnWidth[n]);
                  }, 0);
                  (this._elementHeadCalculatedColumn.style.left = n + e - 1 + 'px'),
                    (this._elementHeadCalculatedColumn.style['border-left'] = '1px solid #dddddd'),
                    (this._elementBodyCalculatedColumn.style.left = n + e + 'px');
                }
              }),
              (t.prototype.appendCalculatedColumnDataToSummaryMap = function (e, n, r, s) {
                for (var i = 0; i < e.seriesName.length; i++)
                  for (var o = e.seriesName[i], a = '', l = 0; l < r.length; l++) {
                    var u = r[l];
                    '' !== o
                      ? ((a =
                          s === t.DATA_COL_MODE.TOP && o.indexOf('SUB-TOTAL') > -1
                            ? o.split('―')[0] + '||SUB-TOTAL'
                            : o.split('―').join('||')),
                        (a += '||' + u.name))
                      : (a = t.EMPTY_Y_AXIS_DIMENSION_KEY + '||' + u.name),
                      e.name.indexOf(u.name) > -1 && (n[a] || (n[a] = []), n[a].push(e.value[i]));
                  }
              }),
              (t.prototype.appendBodyCalculatedColumnToHtml = function (e, n, r, s, i) {
                var l = this,
                  u = l._settings.zProperties.length ? l._settings.zProperties.length : 1,
                  c = {};
                (c.class = a.cssClass.bodyRow),
                  (c.class = l.addClassFontStyle(c.class, l._settings.showCalculatedColumnStyle.font)),
                  (c.class = l.addClassTextAlign(c.class, l._settings.showCalculatedColumnStyle.align, 'RIGHT'));
                var f = { width: '100%' };
                (f.height = r + 'px'), (f.top = n + 'px;'), s.push('<div ' + o.attributesString(c, f) + '>');
                var h = {};
                h.class = a.cssClass.headCell + ' ' + a.cssClass.numeric;
                var d = {};
                if (
                  ((d.height = r + 'px'),
                  (d.width = t.SHOW_CALCULATED_COLUMN_WIDTH + 'px'),
                  (d.color = l._settings.showCalculatedColumnStyle.font.color),
                  (d['background-color'] = l._settings.showCalculatedColumnStyle.backgroundColor),
                  this._settings.dataColumnMode === t.DATA_COL_MODE.TOP)
                )
                  for (var _ = 0, g = 0; g < u; g++) {
                    var p = l._settings.zProperties[g],
                      m = p && p.fieldFormat ? p.fieldFormat : l._settings.format,
                      v = e + (l._settings.dataColumnMode === t.DATA_COL_MODE.TOP ? '||' + p.name : ''),
                      y = l.summaryMap[v],
                      C = 'TOTAL||' + p.name;
                    l._leafCalculatedColumnWidth[C] ||
                      (l._leafCalculatedColumnWidth[C] = t.SHOW_CALCULATED_COLUMN_WIDTH);
                    var b = l._leafCalculatedColumnWidth[C];
                    (d.width =
                      (l._leafCalculatedColumnWidth[C]
                        ? l._leafCalculatedColumnWidth[C]
                        : t.SHOW_CALCULATED_COLUMN_WIDTH * g) + 'px'),
                      (d.left = _ + 'px'),
                      s.push('<div ' + o.attributesString(h, d) + '>'),
                      s.push(
                        o.numberFormat(
                          l.getSummaryValue(y, l._settings.showCalculatedColumnStyle),
                          l._settings.measureFormat[p.name] || (m.type ? m : l._settings.format),
                        ),
                      ),
                      s.push('</div>'),
                      (_ += Number(b));
                  }
                else {
                  var x = t.EMPTY_Y_AXIS_DIMENSION_KEY.indexOf(e) > -1 ? e + '||' + i : e,
                    T = l.summaryMap[x],
                    O =
                      l._settings.zProperties.filter(function (t) {
                        return t.name === x.split('||').slice(-1).join('');
                      }).length > 0
                        ? l._settings.zProperties.filter(function (t) {
                            return t.name === x.split('||').slice(-1).join('');
                          })[0]
                        : void 0,
                    S = O && O.fieldFormat ? O.fieldFormat : l._settings.format,
                    w = 'TOTAL';
                  l._leafCalculatedColumnWidth[w] || (l._leafCalculatedColumnWidth[w] = t.SHOW_CALCULATED_COLUMN_WIDTH);
                  var A = l._leafCalculatedColumnWidth[w];
                  (d.width = A + 'px'),
                    s.push('<div ' + o.attributesString(h, d) + '>'),
                    s.push(
                      o.numberFormat(
                        l.getSummaryValue(T, l._settings.showCalculatedColumnStyle),
                        l._settings.measureFormat[x.split('||').slice(-1).join('')] ||
                          (S.type ? S : l._settings.format),
                      ),
                    ),
                    s.push('</div>');
                }
                s.push('</div>');
              }),
              (t.prototype.appendHeadCalculatedColumnToHtml = function (e, n, r, s) {
                var i = this,
                  l = i._settings.body.showAxisZ ? 1 : 0,
                  u = i._settings.zProperties.length,
                  c = s - (l && i._settings.dataColumnMode === t.DATA_COL_MODE.TOP ? l : 0),
                  f = Object.keys(i._leafCalculatedColumnWidth).reduce(function (t, e) {
                    return t + Number(i._leafCalculatedColumnWidth[e]);
                  }, 0),
                  h = {};
                (h.class = a.cssClass.headRow),
                  (h.class = i.addClassFontStyle(h.class, i._settings.showCalculatedColumnStyle.font)),
                  (h.class = i.addClassTextAlign(h.class, i._settings.showCalculatedColumnStyle.align, 'LEFT'));
                var d = { width: '100%' };
                (d.height = n + 'px'), (d.top = e * n + 'px'), r.push('<div ' + o.attributesString(h, d) + '>');
                var _ = {};
                _.class = a.cssClass.headCell;
                var g = {};
                (g.width =
                  (f ||
                    (e < c && i._settings.dataColumnMode === t.DATA_COL_MODE.TOP
                      ? t.SHOW_CALCULATED_COLUMN_WIDTH * u
                      : t.SHOW_CALCULATED_COLUMN_WIDTH)) + 'px'),
                  (g.height = n + 'px');
                var p = {},
                  m = {};
                if (e < c)
                  (_.title = 'TOTAL'),
                    (g.color = i._settings.showCalculatedColumnStyle.font.color),
                    (g['background-color'] = i._settings.showCalculatedColumnStyle.backgroundColor),
                    r.push('<div ' + o.attributesString(_, g) + '>'),
                    (l && i._settings.dataColumnMode !== t.DATA_COL_MODE.LEFT) ||
                      ((m = {}),
                      ((p = {}).class = a.cssClass.resizeHandle),
                      (p.draggable = 'true'),
                      r.push('<div ' + o.attributesString(p, m) + '></div>')),
                    e === c - 1 &&
                      r.push(
                        i._settings.showCalculatedColumnStyle.label &&
                          '' !== i._settings.showCalculatedColumnStyle.label
                          ? i._settings.showCalculatedColumnStyle.label
                          : a.summaryLabel[i._settings.showCalculatedColumnStyle.aggregationType],
                      ),
                    r.push('</div>');
                else if (l && i._settings.dataColumnMode === t.DATA_COL_MODE.TOP)
                  for (var v = 0, y = 0; y < u; y++) {
                    var C = 'TOTAL||' + this._settings.zProperties[y].name;
                    i._leafCalculatedColumnWidth[C] ||
                      (i._leafCalculatedColumnWidth[C] = t.SHOW_CALCULATED_COLUMN_WIDTH);
                    var b = i._leafCalculatedColumnWidth[C];
                    (_.title = 'TOTAL||' + i._settings.zProperties[y].name),
                      (g.width =
                        (i._leafCalculatedColumnWidth[C]
                          ? i._leafCalculatedColumnWidth[C]
                          : t.SHOW_CALCULATED_COLUMN_WIDTH * y) + 'px'),
                      (g.left = v + 'px'),
                      (v += Number(b)),
                      r.push('<div ' + o.attributesString(_, g) + '>'),
                      r.push(i._settings.zProperties[y].name),
                      (m = {}),
                      ((p = {}).class = a.cssClass.resizeHandle),
                      (p.draggable = 'true'),
                      r.push('<div ' + o.attributesString(p, m) + '></div>'),
                      r.push('</div>');
                  }
                r.push('</div>');
              }),
              (t.prototype.getLeafColumnWidth = function () {
                var t = this._leafColumnWidth,
                  e = this._leafFrozenColumnWidth,
                  n = this._leafCalculatedColumnWidth,
                  r = {};
                if (t) {
                  var s = Object.keys(t);
                  s.length > 0 &&
                    s.forEach(function (e) {
                      e && (r[e] = t[e]);
                    });
                }
                if (e) {
                  var i = Object.keys(e);
                  i.length > 0 &&
                    i.forEach(function (t) {
                      t && (r[t] = e[t]);
                    });
                }
                if (n) {
                  var o = Object.keys(n);
                  o.length > 0 &&
                    o.forEach(function (t) {
                      t && (r[t] = n[t]);
                    });
                }
                return r;
              }),
              (t.prototype.getColumnTextWidth = function (t, e) {
                var n = $(e),
                  r = document.createElement('canvas').getContext('2d');
                e && (r.font = n.css('font'));
                var s = r.measureText(t).width;
                return (
                  e &&
                    (s +=
                      1 * n.css('padding-left').replace(/px/, '') + 1 * n.css('padding-right').replace(/px/, '') + 10),
                  Math.ceil(s)
                );
              }),
              t
            );
          })();
        })(u);
        const c = u;
      })(),
      r.default
    );
  })(),
);
